/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as AuthedRouteImport } from './routes/_authed';
import { Route as publicAcceptInviteRouteImport } from './routes/(public)/accept-invite';
import { Route as publicConfirmEmailRouteImport } from './routes/(public)/confirm-email';
import { Route as publicForgotPasswordRouteImport } from './routes/(public)/forgot-password';
import { Route as publicLoginRouteImport } from './routes/(public)/login';
import { Route as publicMagicLinkRouteImport } from './routes/(public)/magic-link';
import { Route as publicResetPasswordRouteImport } from './routes/(public)/reset-password';
import { Route as publicSignInLinkRouteImport } from './routes/(public)/sign-in-link';
import { Route as AuthedActiveRouteImport } from './routes/_authed/_active';
import { Route as AuthedDocsRouteImport } from './routes/_authed/docs';
import { Route as publicApplyIndexRouteImport } from './routes/(public)/apply/index';
import { Route as publicApplyConfirmRouteImport } from './routes/(public)/apply/confirm';
import { Route as AuthedActiveHelpRouteImport } from './routes/_authed/_active/help';
import { Route as AuthedDocsIndexRouteImport } from './routes/_authed/docs/index';
import { Route as AuthedDocsBuildRouteImport } from './routes/_authed/docs/build';
import { Route as AuthedDocsPostmanRouteImport } from './routes/_authed/docs/postman';
import { Route as publicAuthGoogleCallbackRouteImport } from './routes/(public)/auth/google/callback';
import { Route as AuthedActiveAccountIndexRouteImport } from './routes/_authed/_active/account/index';
import { Route as AuthedActiveAccountChatProfileRouteImport } from './routes/_authed/_active/account/chat-profile';
import { Route as AuthedActiveAccountNotificationsRouteImport } from './routes/_authed/_active/account/notifications';
import { Route as AuthedActiveAccountSecurityRouteImport } from './routes/_authed/_active/account/security';
import { Route as AuthedActiveOrgIndexRouteImport } from './routes/_authed/_active/org/index';
import { Route as AuthedActiveOrgActivityRouteImport } from './routes/_authed/_active/org/activity';
import { Route as AuthedActiveOrgCatalogSetupRouteImport } from './routes/_authed/_active/org/catalog-setup';
import { Route as AuthedActiveOrgCustomizationsRouteImport } from './routes/_authed/_active/org/customizations';
import { Route as AuthedActiveOrgInboxRouteImport } from './routes/_authed/_active/org/inbox';
import { Route as AuthedActiveOrgMediaRouteImport } from './routes/_authed/_active/org/media';
import { Route as AuthedActiveOrgProductsRouteImport } from './routes/_authed/_active/org/products';
import { Route as AuthedActiveOrgRolesRouteImport } from './routes/_authed/_active/org/roles';
import { Route as AuthedActiveOrgSchedulesRouteImport } from './routes/_authed/_active/org/schedules';
import { Route as AuthedActiveOrgSettingsRouteImport } from './routes/_authed/_active/org/settings';
import { Route as AuthedActiveOrgSharedBlocksRouteImport } from './routes/_authed/_active/org/shared-blocks';
import { Route as AuthedActiveOrgStonePricingRouteImport } from './routes/_authed/_active/org/stone-pricing';
import { Route as AuthedActiveOrgStoresRouteImport } from './routes/_authed/_active/org/stores';
import { Route as AuthedActiveOrgTeamRouteImport } from './routes/_authed/_active/org/team';
import { Route as AuthedActiveSStoreIdRouteImport } from './routes/_authed/_active/s/$storeId';
import { Route as AuthedDocsApiIndexRouteImport } from './routes/_authed/docs/api/index';
import { Route as AuthedDocsGuidesSlugRouteImport } from './routes/_authed/docs/guides/$slug';
import { Route as AuthedActiveOrgCatalogSetupIndexRouteImport } from './routes/_authed/_active/org/catalog-setup/index';
import { Route as AuthedActiveOrgCatalogSetupAttributesRouteImport } from './routes/_authed/_active/org/catalog-setup/attributes';
import { Route as AuthedActiveOrgCatalogSetupCustomizationsRouteImport } from './routes/_authed/_active/org/catalog-setup/customizations';
import { Route as AuthedActiveOrgCatalogSetupProductTypesRouteImport } from './routes/_authed/_active/org/catalog-setup/product-types';
import { Route as AuthedActiveOrgCatalogSetupSizeSetsRouteImport } from './routes/_authed/_active/org/catalog-setup/size-sets';
import { Route as AuthedActiveOrgCatalogSetupSkuRulesRouteImport } from './routes/_authed/_active/org/catalog-setup/sku-rules';
import { Route as AuthedActiveOrgInboxIndexRouteImport } from './routes/_authed/_active/org/inbox/index';
import { Route as AuthedActiveOrgProductsIndexRouteImport } from './routes/_authed/_active/org/products/index';
import { Route as AuthedActiveOrgProductsProductIdRouteImport } from './routes/_authed/_active/org/products/$productId';
import { Route as AuthedActiveOrgProductsNewRouteImport } from './routes/_authed/_active/org/products/new';
import { Route as AuthedActiveOrgSchedulesIndexRouteImport } from './routes/_authed/_active/org/schedules/index';
import { Route as AuthedActiveOrgSchedulesScheduleIdRouteImport } from './routes/_authed/_active/org/schedules/$scheduleId';
import { Route as AuthedActiveOrgSchedulesNewRouteImport } from './routes/_authed/_active/org/schedules/new';
import { Route as AuthedActiveOrgSchedulesUpcomingRouteImport } from './routes/_authed/_active/org/schedules/upcoming';
import { Route as AuthedActiveOrgSharedBlocksIndexRouteImport } from './routes/_authed/_active/org/shared-blocks/index';
import { Route as AuthedActiveOrgSharedBlocksBlockIdRouteImport } from './routes/_authed/_active/org/shared-blocks/$blockId';
import { Route as AuthedActiveOrgSharedBlocksNewRouteImport } from './routes/_authed/_active/org/shared-blocks/new';
import { Route as AuthedActiveOrgStoresIndexRouteImport } from './routes/_authed/_active/org/stores/index';
import { Route as AuthedActiveOrgStoresStoreIdRouteImport } from './routes/_authed/_active/org/stores/$storeId';
import { Route as AuthedActiveSStoreIdIndexRouteImport } from './routes/_authed/_active/s/$storeId/index';
import { Route as AuthedActiveSStoreIdAbandonedCheckoutsRouteImport } from './routes/_authed/_active/s/$storeId/abandoned-checkouts';
import { Route as AuthedActiveSStoreIdAppointmentsRouteImport } from './routes/_authed/_active/s/$storeId/appointments';
import { Route as AuthedActiveSStoreIdAuctionsRouteImport } from './routes/_authed/_active/s/$storeId/auctions';
import { Route as AuthedActiveSStoreIdCatalogRouteImport } from './routes/_authed/_active/s/$storeId/catalog';
import { Route as AuthedActiveSStoreIdCollectionsRouteImport } from './routes/_authed/_active/s/$storeId/collections';
import { Route as AuthedActiveSStoreIdContentRouteImport } from './routes/_authed/_active/s/$storeId/content';
import { Route as AuthedActiveSStoreIdCustomersRouteImport } from './routes/_authed/_active/s/$storeId/customers';
import { Route as AuthedActiveSStoreIdDiscountsRouteImport } from './routes/_authed/_active/s/$storeId/discounts';
import { Route as AuthedActiveSStoreIdDraftOrdersRouteImport } from './routes/_authed/_active/s/$storeId/draft-orders';
import { Route as AuthedActiveSStoreIdGiftCardsRouteImport } from './routes/_authed/_active/s/$storeId/gift-cards';
import { Route as AuthedActiveSStoreIdHelpRouteImport } from './routes/_authed/_active/s/$storeId/help';
import { Route as AuthedActiveSStoreIdInboxRouteImport } from './routes/_authed/_active/s/$storeId/inbox';
import { Route as AuthedActiveSStoreIdInventoryRouteImport } from './routes/_authed/_active/s/$storeId/inventory';
import { Route as AuthedActiveSStoreIdOrdersRouteImport } from './routes/_authed/_active/s/$storeId/orders';
import { Route as AuthedActiveSStoreIdPrivacyRequestsRouteImport } from './routes/_authed/_active/s/$storeId/privacy-requests';
import { Route as AuthedActiveSStoreIdProductionRouteImport } from './routes/_authed/_active/s/$storeId/production';
import { Route as AuthedActiveSStoreIdReportsRouteImport } from './routes/_authed/_active/s/$storeId/reports';
import { Route as AuthedActiveSStoreIdReturnsRouteImport } from './routes/_authed/_active/s/$storeId/returns';
import { Route as AuthedActiveSStoreIdSettingsRouteImport } from './routes/_authed/_active/s/$storeId/settings';
import { Route as AuthedActiveSStoreIdSocialRouteImport } from './routes/_authed/_active/s/$storeId/social';
import { Route as AuthedDocsApiTagOperationRouteImport } from './routes/_authed/docs/api/$tag/$operation';
import { Route as AuthedActiveOrgCatalogSetupAttributesIndexRouteImport } from './routes/_authed/_active/org/catalog-setup/attributes/index';
import { Route as AuthedActiveOrgCatalogSetupAttributesAttributeIdRouteImport } from './routes/_authed/_active/org/catalog-setup/attributes/$attributeId';
import { Route as AuthedActiveOrgCatalogSetupProductTypesIndexRouteImport } from './routes/_authed/_active/org/catalog-setup/product-types/index';
import { Route as AuthedActiveOrgCatalogSetupProductTypesProductTypeIdRouteImport } from './routes/_authed/_active/org/catalog-setup/product-types/$productTypeId';
import { Route as AuthedActiveOrgCatalogSetupProductTypesNewRouteImport } from './routes/_authed/_active/org/catalog-setup/product-types/new';
import { Route as AuthedActiveOrgCatalogSetupSizeSetsIndexRouteImport } from './routes/_authed/_active/org/catalog-setup/size-sets/index';
import { Route as AuthedActiveOrgCatalogSetupSizeSetsSizeSetIdRouteImport } from './routes/_authed/_active/org/catalog-setup/size-sets/$sizeSetId';
import { Route as AuthedActiveOrgCatalogSetupSizeSetsNewRouteImport } from './routes/_authed/_active/org/catalog-setup/size-sets/new';
import { Route as AuthedActiveOrgCatalogSetupSkuRulesIndexRouteImport } from './routes/_authed/_active/org/catalog-setup/sku-rules/index';
import { Route as AuthedActiveOrgCatalogSetupSkuRulesRuleIdRouteImport } from './routes/_authed/_active/org/catalog-setup/sku-rules/$ruleId';
import { Route as AuthedActiveOrgCatalogSetupSkuRulesNewRouteImport } from './routes/_authed/_active/org/catalog-setup/sku-rules/new';
import { Route as AuthedActiveOrgInboxStoreIdConversationIdRouteImport } from './routes/_authed/_active/org/inbox/$storeId.$conversationId';
import { Route as AuthedActiveOrgSharedBlocksNewIndexRouteImport } from './routes/_authed/_active/org/shared-blocks/new/index';
import { Route as AuthedActiveOrgSharedBlocksNewKindRouteImport } from './routes/_authed/_active/org/shared-blocks/new/$kind';
import { Route as AuthedActiveSStoreIdAbandonedCheckoutsIndexRouteImport } from './routes/_authed/_active/s/$storeId/abandoned-checkouts/index';
import { Route as AuthedActiveSStoreIdAbandonedCheckoutsCheckoutIdRouteImport } from './routes/_authed/_active/s/$storeId/abandoned-checkouts/$checkoutId';
import { Route as AuthedActiveSStoreIdAuctionsIndexRouteImport } from './routes/_authed/_active/s/$storeId/auctions/index';
import { Route as AuthedActiveSStoreIdAuctionsAuctionIdRouteImport } from './routes/_authed/_active/s/$storeId/auctions/$auctionId';
import { Route as AuthedActiveSStoreIdAuctionsBiddersRouteImport } from './routes/_authed/_active/s/$storeId/auctions/bidders';
import { Route as AuthedActiveSStoreIdAuctionsQuestionsRouteImport } from './routes/_authed/_active/s/$storeId/auctions/questions';
import { Route as AuthedActiveSStoreIdCatalogIndexRouteImport } from './routes/_authed/_active/s/$storeId/catalog/index';
import { Route as AuthedActiveSStoreIdCatalogStoreProductIdRouteImport } from './routes/_authed/_active/s/$storeId/catalog/$storeProductId';
import { Route as AuthedActiveSStoreIdCollectionsIndexRouteImport } from './routes/_authed/_active/s/$storeId/collections/index';
import { Route as AuthedActiveSStoreIdCollectionsCollectionIdRouteImport } from './routes/_authed/_active/s/$storeId/collections/$collectionId';
import { Route as AuthedActiveSStoreIdCollectionsNewRouteImport } from './routes/_authed/_active/s/$storeId/collections/new';
import { Route as AuthedActiveSStoreIdContentIndexRouteImport } from './routes/_authed/_active/s/$storeId/content/index';
import { Route as AuthedActiveSStoreIdContentBlocksRouteImport } from './routes/_authed/_active/s/$storeId/content/blocks';
import { Route as AuthedActiveSStoreIdContentBlogRouteImport } from './routes/_authed/_active/s/$storeId/content/blog';
import { Route as AuthedActiveSStoreIdContentMenusRouteImport } from './routes/_authed/_active/s/$storeId/content/menus';
import { Route as AuthedActiveSStoreIdContentPagesRouteImport } from './routes/_authed/_active/s/$storeId/content/pages';
import { Route as AuthedActiveSStoreIdContentRedirectsRouteImport } from './routes/_authed/_active/s/$storeId/content/redirects';
import { Route as AuthedActiveSStoreIdContentSectionsRouteImport } from './routes/_authed/_active/s/$storeId/content/sections';
import { Route as AuthedActiveSStoreIdContentSeoRouteImport } from './routes/_authed/_active/s/$storeId/content/seo';
import { Route as AuthedActiveSStoreIdCustomersIndexRouteImport } from './routes/_authed/_active/s/$storeId/customers/index';
import { Route as AuthedActiveSStoreIdCustomersCustomerIdRouteImport } from './routes/_authed/_active/s/$storeId/customers/$customerId';
import { Route as AuthedActiveSStoreIdDiscountsIndexRouteImport } from './routes/_authed/_active/s/$storeId/discounts/index';
import { Route as AuthedActiveSStoreIdDiscountsDiscountIdRouteImport } from './routes/_authed/_active/s/$storeId/discounts/$discountId';
import { Route as AuthedActiveSStoreIdDiscountsNewRouteImport } from './routes/_authed/_active/s/$storeId/discounts/new';
import { Route as AuthedActiveSStoreIdDraftOrdersIndexRouteImport } from './routes/_authed/_active/s/$storeId/draft-orders/index';
import { Route as AuthedActiveSStoreIdDraftOrdersDraftIdRouteImport } from './routes/_authed/_active/s/$storeId/draft-orders/$draftId';
import { Route as AuthedActiveSStoreIdDraftOrdersNewRouteImport } from './routes/_authed/_active/s/$storeId/draft-orders/new';
import { Route as AuthedActiveSStoreIdGiftCardsIndexRouteImport } from './routes/_authed/_active/s/$storeId/gift-cards/index';
import { Route as AuthedActiveSStoreIdGiftCardsGiftCardIdRouteImport } from './routes/_authed/_active/s/$storeId/gift-cards/$giftCardId';
import { Route as AuthedActiveSStoreIdHelpIndexRouteImport } from './routes/_authed/_active/s/$storeId/help/index';
import { Route as AuthedActiveSStoreIdHelpArticleIdRouteImport } from './routes/_authed/_active/s/$storeId/help/$articleId';
import { Route as AuthedActiveSStoreIdHelpCategoriesRouteImport } from './routes/_authed/_active/s/$storeId/help/categories';
import { Route as AuthedActiveSStoreIdHelpNewRouteImport } from './routes/_authed/_active/s/$storeId/help/new';
import { Route as AuthedActiveSStoreIdInboxIndexRouteImport } from './routes/_authed/_active/s/$storeId/inbox/index';
import { Route as AuthedActiveSStoreIdInboxConversationIdRouteImport } from './routes/_authed/_active/s/$storeId/inbox/$conversationId';
import { Route as AuthedActiveSStoreIdInventoryVariantIdRouteImport } from './routes/_authed/_active/s/$storeId/inventory_.$variantId';
import { Route as AuthedActiveSStoreIdOrdersIndexRouteImport } from './routes/_authed/_active/s/$storeId/orders/index';
import { Route as AuthedActiveSStoreIdOrdersOrderIdRouteImport } from './routes/_authed/_active/s/$storeId/orders/$orderId';
import { Route as AuthedActiveSStoreIdReportsIndexRouteImport } from './routes/_authed/_active/s/$storeId/reports/index';
import { Route as AuthedActiveSStoreIdReportsAnalyticsRouteImport } from './routes/_authed/_active/s/$storeId/reports/analytics';
import { Route as AuthedActiveSStoreIdReportsAuctionsRouteImport } from './routes/_authed/_active/s/$storeId/reports/auctions';
import { Route as AuthedActiveSStoreIdReportsCustomersRouteImport } from './routes/_authed/_active/s/$storeId/reports/customers';
import { Route as AuthedActiveSStoreIdReportsInventoryRouteImport } from './routes/_authed/_active/s/$storeId/reports/inventory';
import { Route as AuthedActiveSStoreIdReportsPaymentsRouteImport } from './routes/_authed/_active/s/$storeId/reports/payments';
import { Route as AuthedActiveSStoreIdReportsProductsRouteImport } from './routes/_authed/_active/s/$storeId/reports/products';
import { Route as AuthedActiveSStoreIdReportsSalesRouteImport } from './routes/_authed/_active/s/$storeId/reports/sales';
import { Route as AuthedActiveSStoreIdReportsSupportRouteImport } from './routes/_authed/_active/s/$storeId/reports/support';
import { Route as AuthedActiveSStoreIdReturnsIndexRouteImport } from './routes/_authed/_active/s/$storeId/returns/index';
import { Route as AuthedActiveSStoreIdReturnsReturnIdRouteImport } from './routes/_authed/_active/s/$storeId/returns/$returnId';
import { Route as AuthedActiveSStoreIdSettingsIndexRouteImport } from './routes/_authed/_active/s/$storeId/settings/index';
import { Route as AuthedActiveSStoreIdSettingsAnalyticsRouteImport } from './routes/_authed/_active/s/$storeId/settings/analytics';
import { Route as AuthedActiveSStoreIdSettingsApiKeysRouteImport } from './routes/_authed/_active/s/$storeId/settings/api-keys';
import { Route as AuthedActiveSStoreIdSettingsChatRouteImport } from './routes/_authed/_active/s/$storeId/settings/chat';
import { Route as AuthedActiveSStoreIdSettingsFeedsRouteImport } from './routes/_authed/_active/s/$storeId/settings/feeds';
import { Route as AuthedActiveSStoreIdSettingsImportsExportsRouteImport } from './routes/_authed/_active/s/$storeId/settings/imports-exports';
import { Route as AuthedActiveSStoreIdSettingsLocationsRouteImport } from './routes/_authed/_active/s/$storeId/settings/locations';
import { Route as AuthedActiveSStoreIdSettingsMarketsRouteImport } from './routes/_authed/_active/s/$storeId/settings/markets';
import { Route as AuthedActiveSStoreIdSettingsNotificationsRouteImport } from './routes/_authed/_active/s/$storeId/settings/notifications';
import { Route as AuthedActiveSStoreIdSettingsPaymentMethodsRouteImport } from './routes/_authed/_active/s/$storeId/settings/payment-methods';
import { Route as AuthedActiveSStoreIdSettingsPoliciesRouteImport } from './routes/_authed/_active/s/$storeId/settings/policies';
import { Route as AuthedActiveSStoreIdSettingsQcChecklistsRouteImport } from './routes/_authed/_active/s/$storeId/settings/qc-checklists';
import { Route as AuthedActiveSStoreIdSettingsRecoveryRouteImport } from './routes/_authed/_active/s/$storeId/settings/recovery';
import { Route as AuthedActiveSStoreIdSettingsReturnsRouteImport } from './routes/_authed/_active/s/$storeId/settings/returns';
import { Route as AuthedActiveSStoreIdSettingsShippingRouteImport } from './routes/_authed/_active/s/$storeId/settings/shipping';
import { Route as AuthedActiveSStoreIdSettingsTaxRouteImport } from './routes/_authed/_active/s/$storeId/settings/tax';
import { Route as AuthedActiveSStoreIdSettingsWebhooksRouteImport } from './routes/_authed/_active/s/$storeId/settings/webhooks';
import { Route as AuthedActiveSStoreIdSettingsWorkflowsRouteImport } from './routes/_authed/_active/s/$storeId/settings/workflows';
import { Route as AuthedActiveSStoreIdSocialIndexRouteImport } from './routes/_authed/_active/s/$storeId/social/index';
import { Route as AuthedActiveSStoreIdSocialPinterestRouteImport } from './routes/_authed/_active/s/$storeId/social/pinterest';
import { Route as AuthedActiveStoresStoreIdInboxConversationIdRouteImport } from './routes/_authed/_active/stores/$storeId/inbox/$conversationId';
import { Route as AuthedActiveOrgProductsProductIdVariantsVariantIdRouteImport } from './routes/_authed/_active/org/products/$productId_.variants.$variantId';
import { Route as AuthedActiveSStoreIdAuctionsSalesIndexRouteImport } from './routes/_authed/_active/s/$storeId/auctions/sales/index';
import { Route as AuthedActiveSStoreIdAuctionsSalesSaleIdRouteImport } from './routes/_authed/_active/s/$storeId/auctions/sales/$saleId';
import { Route as AuthedActiveSStoreIdContentBlocksIndexRouteImport } from './routes/_authed/_active/s/$storeId/content/blocks/index';
import { Route as AuthedActiveSStoreIdContentBlocksBlockIdRouteImport } from './routes/_authed/_active/s/$storeId/content/blocks/$blockId';
import { Route as AuthedActiveSStoreIdContentBlocksNewRouteImport } from './routes/_authed/_active/s/$storeId/content/blocks/new';
import { Route as AuthedActiveSStoreIdContentBlogIndexRouteImport } from './routes/_authed/_active/s/$storeId/content/blog/index';
import { Route as AuthedActiveSStoreIdContentBlogPostIdRouteImport } from './routes/_authed/_active/s/$storeId/content/blog/$postId';
import { Route as AuthedActiveSStoreIdContentBlogCategoriesRouteImport } from './routes/_authed/_active/s/$storeId/content/blog/categories';
import { Route as AuthedActiveSStoreIdContentBlogNewRouteImport } from './routes/_authed/_active/s/$storeId/content/blog/new';
import { Route as AuthedActiveSStoreIdContentMenusIndexRouteImport } from './routes/_authed/_active/s/$storeId/content/menus/index';
import { Route as AuthedActiveSStoreIdContentMenusMenuIdRouteImport } from './routes/_authed/_active/s/$storeId/content/menus/$menuId';
import { Route as AuthedActiveSStoreIdContentPagesIndexRouteImport } from './routes/_authed/_active/s/$storeId/content/pages/index';
import { Route as AuthedActiveSStoreIdContentPagesPageIdRouteImport } from './routes/_authed/_active/s/$storeId/content/pages/$pageId';
import { Route as AuthedActiveSStoreIdContentPagesNewRouteImport } from './routes/_authed/_active/s/$storeId/content/pages/new';
import { Route as AuthedActiveSStoreIdContentSectionsIndexRouteImport } from './routes/_authed/_active/s/$storeId/content/sections/index';
import { Route as AuthedActiveSStoreIdContentSectionsSectionIdRouteImport } from './routes/_authed/_active/s/$storeId/content/sections/$sectionId';
import { Route as AuthedActiveSStoreIdContentSectionsNewRouteImport } from './routes/_authed/_active/s/$storeId/content/sections/new';
import { Route as AuthedActiveSStoreIdSettingsPoliciesIndexRouteImport } from './routes/_authed/_active/s/$storeId/settings/policies/index';
import { Route as AuthedActiveSStoreIdSettingsPoliciesPolicyIdRouteImport } from './routes/_authed/_active/s/$storeId/settings/policies/$policyId';
import { Route as AuthedActiveSStoreIdSettingsPoliciesNewRouteImport } from './routes/_authed/_active/s/$storeId/settings/policies/new';
import { Route as AuthedActiveSStoreIdSettingsQcChecklistsIndexRouteImport } from './routes/_authed/_active/s/$storeId/settings/qc-checklists/index';
import { Route as AuthedActiveSStoreIdSettingsQcChecklistsChecklistIdRouteImport } from './routes/_authed/_active/s/$storeId/settings/qc-checklists/$checklistId';
import { Route as AuthedActiveSStoreIdSettingsQcChecklistsNewRouteImport } from './routes/_authed/_active/s/$storeId/settings/qc-checklists/new';
import { Route as AuthedActiveSStoreIdSettingsWebhooksIndexRouteImport } from './routes/_authed/_active/s/$storeId/settings/webhooks/index';
import { Route as AuthedActiveSStoreIdSettingsWebhooksEndpointIdRouteImport } from './routes/_authed/_active/s/$storeId/settings/webhooks/$endpointId';
import { Route as AuthedActiveSStoreIdSettingsWorkflowsIndexRouteImport } from './routes/_authed/_active/s/$storeId/settings/workflows/index';
import { Route as AuthedActiveSStoreIdSettingsWorkflowsTemplateIdRouteImport } from './routes/_authed/_active/s/$storeId/settings/workflows/$templateId';
import { Route as AuthedActiveSStoreIdSettingsWorkflowsNewRouteImport } from './routes/_authed/_active/s/$storeId/settings/workflows/new';
import { Route as AuthedActiveSStoreIdSocialPinterestIndexRouteImport } from './routes/_authed/_active/s/$storeId/social/pinterest/index';
import { Route as AuthedActiveSStoreIdSocialPinterestAnalyticsRouteImport } from './routes/_authed/_active/s/$storeId/social/pinterest/analytics';
import { Route as AuthedActiveSStoreIdSocialPinterestConnectionRouteImport } from './routes/_authed/_active/s/$storeId/social/pinterest/connection';
import { Route as AuthedActiveSStoreIdSocialPinterestCreateRouteImport } from './routes/_authed/_active/s/$storeId/social/pinterest/create';
import { Route as AuthedActiveSStoreIdSocialPinterestPostsRouteImport } from './routes/_authed/_active/s/$storeId/social/pinterest/posts';
import { Route as AuthedActiveSStoreIdSocialPinterestSettingsRouteImport } from './routes/_authed/_active/s/$storeId/social/pinterest/settings';
import { Route as AuthedActiveSStoreIdCatalogStoreProductIdVariantsVariantIdRouteImport } from './routes/_authed/_active/s/$storeId/catalog/$storeProductId_.variants.$variantId';
import { Route as AuthedActiveSStoreIdContentBlocksNewIndexRouteImport } from './routes/_authed/_active/s/$storeId/content/blocks/new/index';
import { Route as AuthedActiveSStoreIdContentBlocksNewKindRouteImport } from './routes/_authed/_active/s/$storeId/content/blocks/new/$kind';
import { Route as AuthedActiveSStoreIdSettingsPaymentsStripeCallbackRouteImport } from './routes/_authed/_active/s/$storeId/settings/payments/stripe/callback';
import { Route as AuthedActiveSStoreIdSocialPinterestPostsIndexRouteImport } from './routes/_authed/_active/s/$storeId/social/pinterest/posts/index';
import { Route as AuthedActiveSStoreIdSocialPinterestPostsPostIdRouteImport } from './routes/_authed/_active/s/$storeId/social/pinterest/posts/$postId';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any);
const publicAcceptInviteRoute = publicAcceptInviteRouteImport.update({
  id: '/(public)/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any);
const publicConfirmEmailRoute = publicConfirmEmailRouteImport.update({
  id: '/(public)/confirm-email',
  path: '/confirm-email',
  getParentRoute: () => rootRouteImport,
} as any);
const publicForgotPasswordRoute = publicForgotPasswordRouteImport.update({
  id: '/(public)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any);
const publicLoginRoute = publicLoginRouteImport.update({
  id: '/(public)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const publicMagicLinkRoute = publicMagicLinkRouteImport.update({
  id: '/(public)/magic-link',
  path: '/magic-link',
  getParentRoute: () => rootRouteImport,
} as any);
const publicResetPasswordRoute = publicResetPasswordRouteImport.update({
  id: '/(public)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any);
const publicSignInLinkRoute = publicSignInLinkRouteImport.update({
  id: '/(public)/sign-in-link',
  path: '/sign-in-link',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedActiveRoute = AuthedActiveRouteImport.update({
  id: '/_active',
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedDocsRoute = AuthedDocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => AuthedRoute,
} as any);
const publicApplyIndexRoute = publicApplyIndexRouteImport.update({
  id: '/(public)/apply/',
  path: '/apply/',
  getParentRoute: () => rootRouteImport,
} as any);
const publicApplyConfirmRoute = publicApplyConfirmRouteImport.update({
  id: '/(public)/apply/confirm',
  path: '/apply/confirm',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedActiveHelpRoute = AuthedActiveHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AuthedActiveRoute,
} as any);
const AuthedDocsIndexRoute = AuthedDocsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedDocsRoute,
} as any);
const AuthedDocsBuildRoute = AuthedDocsBuildRouteImport.update({
  id: '/build',
  path: '/build',
  getParentRoute: () => AuthedDocsRoute,
} as any);
const AuthedDocsPostmanRoute = AuthedDocsPostmanRouteImport.update({
  id: '/postman',
  path: '/postman',
  getParentRoute: () => AuthedDocsRoute,
} as any);
const publicAuthGoogleCallbackRoute =
  publicAuthGoogleCallbackRouteImport.update({
    id: '/(public)/auth/google/callback',
    path: '/auth/google/callback',
    getParentRoute: () => rootRouteImport,
  } as any);
const AuthedActiveAccountIndexRoute =
  AuthedActiveAccountIndexRouteImport.update({
    id: '/account/',
    path: '/account/',
    getParentRoute: () => AuthedActiveRoute,
  } as any);
const AuthedActiveAccountChatProfileRoute =
  AuthedActiveAccountChatProfileRouteImport.update({
    id: '/account/chat-profile',
    path: '/account/chat-profile',
    getParentRoute: () => AuthedActiveRoute,
  } as any);
const AuthedActiveAccountNotificationsRoute =
  AuthedActiveAccountNotificationsRouteImport.update({
    id: '/account/notifications',
    path: '/account/notifications',
    getParentRoute: () => AuthedActiveRoute,
  } as any);
const AuthedActiveAccountSecurityRoute =
  AuthedActiveAccountSecurityRouteImport.update({
    id: '/account/security',
    path: '/account/security',
    getParentRoute: () => AuthedActiveRoute,
  } as any);
const AuthedActiveOrgIndexRoute = AuthedActiveOrgIndexRouteImport.update({
  id: '/org/',
  path: '/org/',
  getParentRoute: () => AuthedActiveRoute,
} as any);
const AuthedActiveOrgActivityRoute = AuthedActiveOrgActivityRouteImport.update({
  id: '/org/activity',
  path: '/org/activity',
  getParentRoute: () => AuthedActiveRoute,
} as any);
const AuthedActiveOrgCatalogSetupRoute =
  AuthedActiveOrgCatalogSetupRouteImport.update({
    id: '/org/catalog-setup',
    path: '/org/catalog-setup',
    getParentRoute: () => AuthedActiveRoute,
  } as any);
const AuthedActiveOrgCustomizationsRoute =
  AuthedActiveOrgCustomizationsRouteImport.update({
    id: '/org/customizations',
    path: '/org/customizations',
    getParentRoute: () => AuthedActiveRoute,
  } as any);
const AuthedActiveOrgInboxRoute = AuthedActiveOrgInboxRouteImport.update({
  id: '/org/inbox',
  path: '/org/inbox',
  getParentRoute: () => AuthedActiveRoute,
} as any);
const AuthedActiveOrgMediaRoute = AuthedActiveOrgMediaRouteImport.update({
  id: '/org/media',
  path: '/org/media',
  getParentRoute: () => AuthedActiveRoute,
} as any);
const AuthedActiveOrgProductsRoute = AuthedActiveOrgProductsRouteImport.update({
  id: '/org/products',
  path: '/org/products',
  getParentRoute: () => AuthedActiveRoute,
} as any);
const AuthedActiveOrgRolesRoute = AuthedActiveOrgRolesRouteImport.update({
  id: '/org/roles',
  path: '/org/roles',
  getParentRoute: () => AuthedActiveRoute,
} as any);
const AuthedActiveOrgSchedulesRoute =
  AuthedActiveOrgSchedulesRouteImport.update({
    id: '/org/schedules',
    path: '/org/schedules',
    getParentRoute: () => AuthedActiveRoute,
  } as any);
const AuthedActiveOrgSettingsRoute = AuthedActiveOrgSettingsRouteImport.update({
  id: '/org/settings',
  path: '/org/settings',
  getParentRoute: () => AuthedActiveRoute,
} as any);
const AuthedActiveOrgSharedBlocksRoute =
  AuthedActiveOrgSharedBlocksRouteImport.update({
    id: '/org/shared-blocks',
    path: '/org/shared-blocks',
    getParentRoute: () => AuthedActiveRoute,
  } as any);
const AuthedActiveOrgStonePricingRoute =
  AuthedActiveOrgStonePricingRouteImport.update({
    id: '/org/stone-pricing',
    path: '/org/stone-pricing',
    getParentRoute: () => AuthedActiveRoute,
  } as any);
const AuthedActiveOrgStoresRoute = AuthedActiveOrgStoresRouteImport.update({
  id: '/org/stores',
  path: '/org/stores',
  getParentRoute: () => AuthedActiveRoute,
} as any);
const AuthedActiveOrgTeamRoute = AuthedActiveOrgTeamRouteImport.update({
  id: '/org/team',
  path: '/org/team',
  getParentRoute: () => AuthedActiveRoute,
} as any);
const AuthedActiveSStoreIdRoute = AuthedActiveSStoreIdRouteImport.update({
  id: '/s/$storeId',
  path: '/s/$storeId',
  getParentRoute: () => AuthedActiveRoute,
} as any);
const AuthedDocsApiIndexRoute = AuthedDocsApiIndexRouteImport.update({
  id: '/api/',
  path: '/api/',
  getParentRoute: () => AuthedDocsRoute,
} as any);
const AuthedDocsGuidesSlugRoute = AuthedDocsGuidesSlugRouteImport.update({
  id: '/guides/$slug',
  path: '/guides/$slug',
  getParentRoute: () => AuthedDocsRoute,
} as any);
const AuthedActiveOrgCatalogSetupIndexRoute =
  AuthedActiveOrgCatalogSetupIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveOrgCatalogSetupRoute,
  } as any);
const AuthedActiveOrgCatalogSetupAttributesRoute =
  AuthedActiveOrgCatalogSetupAttributesRouteImport.update({
    id: '/attributes',
    path: '/attributes',
    getParentRoute: () => AuthedActiveOrgCatalogSetupRoute,
  } as any);
const AuthedActiveOrgCatalogSetupCustomizationsRoute =
  AuthedActiveOrgCatalogSetupCustomizationsRouteImport.update({
    id: '/customizations',
    path: '/customizations',
    getParentRoute: () => AuthedActiveOrgCatalogSetupRoute,
  } as any);
const AuthedActiveOrgCatalogSetupProductTypesRoute =
  AuthedActiveOrgCatalogSetupProductTypesRouteImport.update({
    id: '/product-types',
    path: '/product-types',
    getParentRoute: () => AuthedActiveOrgCatalogSetupRoute,
  } as any);
const AuthedActiveOrgCatalogSetupSizeSetsRoute =
  AuthedActiveOrgCatalogSetupSizeSetsRouteImport.update({
    id: '/size-sets',
    path: '/size-sets',
    getParentRoute: () => AuthedActiveOrgCatalogSetupRoute,
  } as any);
const AuthedActiveOrgCatalogSetupSkuRulesRoute =
  AuthedActiveOrgCatalogSetupSkuRulesRouteImport.update({
    id: '/sku-rules',
    path: '/sku-rules',
    getParentRoute: () => AuthedActiveOrgCatalogSetupRoute,
  } as any);
const AuthedActiveOrgInboxIndexRoute =
  AuthedActiveOrgInboxIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveOrgInboxRoute,
  } as any);
const AuthedActiveOrgProductsIndexRoute =
  AuthedActiveOrgProductsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveOrgProductsRoute,
  } as any);
const AuthedActiveOrgProductsProductIdRoute =
  AuthedActiveOrgProductsProductIdRouteImport.update({
    id: '/$productId',
    path: '/$productId',
    getParentRoute: () => AuthedActiveOrgProductsRoute,
  } as any);
const AuthedActiveOrgProductsNewRoute =
  AuthedActiveOrgProductsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedActiveOrgProductsRoute,
  } as any);
const AuthedActiveOrgSchedulesIndexRoute =
  AuthedActiveOrgSchedulesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveOrgSchedulesRoute,
  } as any);
const AuthedActiveOrgSchedulesScheduleIdRoute =
  AuthedActiveOrgSchedulesScheduleIdRouteImport.update({
    id: '/$scheduleId',
    path: '/$scheduleId',
    getParentRoute: () => AuthedActiveOrgSchedulesRoute,
  } as any);
const AuthedActiveOrgSchedulesNewRoute =
  AuthedActiveOrgSchedulesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedActiveOrgSchedulesRoute,
  } as any);
const AuthedActiveOrgSchedulesUpcomingRoute =
  AuthedActiveOrgSchedulesUpcomingRouteImport.update({
    id: '/upcoming',
    path: '/upcoming',
    getParentRoute: () => AuthedActiveOrgSchedulesRoute,
  } as any);
const AuthedActiveOrgSharedBlocksIndexRoute =
  AuthedActiveOrgSharedBlocksIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveOrgSharedBlocksRoute,
  } as any);
const AuthedActiveOrgSharedBlocksBlockIdRoute =
  AuthedActiveOrgSharedBlocksBlockIdRouteImport.update({
    id: '/$blockId',
    path: '/$blockId',
    getParentRoute: () => AuthedActiveOrgSharedBlocksRoute,
  } as any);
const AuthedActiveOrgSharedBlocksNewRoute =
  AuthedActiveOrgSharedBlocksNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedActiveOrgSharedBlocksRoute,
  } as any);
const AuthedActiveOrgStoresIndexRoute =
  AuthedActiveOrgStoresIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveOrgStoresRoute,
  } as any);
const AuthedActiveOrgStoresStoreIdRoute =
  AuthedActiveOrgStoresStoreIdRouteImport.update({
    id: '/$storeId',
    path: '/$storeId',
    getParentRoute: () => AuthedActiveOrgStoresRoute,
  } as any);
const AuthedActiveSStoreIdIndexRoute =
  AuthedActiveSStoreIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdAbandonedCheckoutsRoute =
  AuthedActiveSStoreIdAbandonedCheckoutsRouteImport.update({
    id: '/abandoned-checkouts',
    path: '/abandoned-checkouts',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdAppointmentsRoute =
  AuthedActiveSStoreIdAppointmentsRouteImport.update({
    id: '/appointments',
    path: '/appointments',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdAuctionsRoute =
  AuthedActiveSStoreIdAuctionsRouteImport.update({
    id: '/auctions',
    path: '/auctions',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdCatalogRoute =
  AuthedActiveSStoreIdCatalogRouteImport.update({
    id: '/catalog',
    path: '/catalog',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdCollectionsRoute =
  AuthedActiveSStoreIdCollectionsRouteImport.update({
    id: '/collections',
    path: '/collections',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdContentRoute =
  AuthedActiveSStoreIdContentRouteImport.update({
    id: '/content',
    path: '/content',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdCustomersRoute =
  AuthedActiveSStoreIdCustomersRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdDiscountsRoute =
  AuthedActiveSStoreIdDiscountsRouteImport.update({
    id: '/discounts',
    path: '/discounts',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdDraftOrdersRoute =
  AuthedActiveSStoreIdDraftOrdersRouteImport.update({
    id: '/draft-orders',
    path: '/draft-orders',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdGiftCardsRoute =
  AuthedActiveSStoreIdGiftCardsRouteImport.update({
    id: '/gift-cards',
    path: '/gift-cards',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdHelpRoute =
  AuthedActiveSStoreIdHelpRouteImport.update({
    id: '/help',
    path: '/help',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdInboxRoute =
  AuthedActiveSStoreIdInboxRouteImport.update({
    id: '/inbox',
    path: '/inbox',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdInventoryRoute =
  AuthedActiveSStoreIdInventoryRouteImport.update({
    id: '/inventory',
    path: '/inventory',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdOrdersRoute =
  AuthedActiveSStoreIdOrdersRouteImport.update({
    id: '/orders',
    path: '/orders',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdPrivacyRequestsRoute =
  AuthedActiveSStoreIdPrivacyRequestsRouteImport.update({
    id: '/privacy-requests',
    path: '/privacy-requests',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdProductionRoute =
  AuthedActiveSStoreIdProductionRouteImport.update({
    id: '/production',
    path: '/production',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdReportsRoute =
  AuthedActiveSStoreIdReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdReturnsRoute =
  AuthedActiveSStoreIdReturnsRouteImport.update({
    id: '/returns',
    path: '/returns',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdSettingsRoute =
  AuthedActiveSStoreIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdSocialRoute =
  AuthedActiveSStoreIdSocialRouteImport.update({
    id: '/social',
    path: '/social',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedDocsApiTagOperationRoute =
  AuthedDocsApiTagOperationRouteImport.update({
    id: '/api/$tag/$operation',
    path: '/api/$tag/$operation',
    getParentRoute: () => AuthedDocsRoute,
  } as any);
const AuthedActiveOrgCatalogSetupAttributesIndexRoute =
  AuthedActiveOrgCatalogSetupAttributesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveOrgCatalogSetupAttributesRoute,
  } as any);
const AuthedActiveOrgCatalogSetupAttributesAttributeIdRoute =
  AuthedActiveOrgCatalogSetupAttributesAttributeIdRouteImport.update({
    id: '/$attributeId',
    path: '/$attributeId',
    getParentRoute: () => AuthedActiveOrgCatalogSetupAttributesRoute,
  } as any);
const AuthedActiveOrgCatalogSetupProductTypesIndexRoute =
  AuthedActiveOrgCatalogSetupProductTypesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveOrgCatalogSetupProductTypesRoute,
  } as any);
const AuthedActiveOrgCatalogSetupProductTypesProductTypeIdRoute =
  AuthedActiveOrgCatalogSetupProductTypesProductTypeIdRouteImport.update({
    id: '/$productTypeId',
    path: '/$productTypeId',
    getParentRoute: () => AuthedActiveOrgCatalogSetupProductTypesRoute,
  } as any);
const AuthedActiveOrgCatalogSetupProductTypesNewRoute =
  AuthedActiveOrgCatalogSetupProductTypesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedActiveOrgCatalogSetupProductTypesRoute,
  } as any);
const AuthedActiveOrgCatalogSetupSizeSetsIndexRoute =
  AuthedActiveOrgCatalogSetupSizeSetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveOrgCatalogSetupSizeSetsRoute,
  } as any);
const AuthedActiveOrgCatalogSetupSizeSetsSizeSetIdRoute =
  AuthedActiveOrgCatalogSetupSizeSetsSizeSetIdRouteImport.update({
    id: '/$sizeSetId',
    path: '/$sizeSetId',
    getParentRoute: () => AuthedActiveOrgCatalogSetupSizeSetsRoute,
  } as any);
const AuthedActiveOrgCatalogSetupSizeSetsNewRoute =
  AuthedActiveOrgCatalogSetupSizeSetsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedActiveOrgCatalogSetupSizeSetsRoute,
  } as any);
const AuthedActiveOrgCatalogSetupSkuRulesIndexRoute =
  AuthedActiveOrgCatalogSetupSkuRulesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveOrgCatalogSetupSkuRulesRoute,
  } as any);
const AuthedActiveOrgCatalogSetupSkuRulesRuleIdRoute =
  AuthedActiveOrgCatalogSetupSkuRulesRuleIdRouteImport.update({
    id: '/$ruleId',
    path: '/$ruleId',
    getParentRoute: () => AuthedActiveOrgCatalogSetupSkuRulesRoute,
  } as any);
const AuthedActiveOrgCatalogSetupSkuRulesNewRoute =
  AuthedActiveOrgCatalogSetupSkuRulesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedActiveOrgCatalogSetupSkuRulesRoute,
  } as any);
const AuthedActiveOrgInboxStoreIdConversationIdRoute =
  AuthedActiveOrgInboxStoreIdConversationIdRouteImport.update({
    id: '/$storeId/$conversationId',
    path: '/$storeId/$conversationId',
    getParentRoute: () => AuthedActiveOrgInboxRoute,
  } as any);
const AuthedActiveOrgSharedBlocksNewIndexRoute =
  AuthedActiveOrgSharedBlocksNewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveOrgSharedBlocksNewRoute,
  } as any);
const AuthedActiveOrgSharedBlocksNewKindRoute =
  AuthedActiveOrgSharedBlocksNewKindRouteImport.update({
    id: '/$kind',
    path: '/$kind',
    getParentRoute: () => AuthedActiveOrgSharedBlocksNewRoute,
  } as any);
const AuthedActiveSStoreIdAbandonedCheckoutsIndexRoute =
  AuthedActiveSStoreIdAbandonedCheckoutsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdAbandonedCheckoutsRoute,
  } as any);
const AuthedActiveSStoreIdAbandonedCheckoutsCheckoutIdRoute =
  AuthedActiveSStoreIdAbandonedCheckoutsCheckoutIdRouteImport.update({
    id: '/$checkoutId',
    path: '/$checkoutId',
    getParentRoute: () => AuthedActiveSStoreIdAbandonedCheckoutsRoute,
  } as any);
const AuthedActiveSStoreIdAuctionsIndexRoute =
  AuthedActiveSStoreIdAuctionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdAuctionsRoute,
  } as any);
const AuthedActiveSStoreIdAuctionsAuctionIdRoute =
  AuthedActiveSStoreIdAuctionsAuctionIdRouteImport.update({
    id: '/$auctionId',
    path: '/$auctionId',
    getParentRoute: () => AuthedActiveSStoreIdAuctionsRoute,
  } as any);
const AuthedActiveSStoreIdAuctionsBiddersRoute =
  AuthedActiveSStoreIdAuctionsBiddersRouteImport.update({
    id: '/bidders',
    path: '/bidders',
    getParentRoute: () => AuthedActiveSStoreIdAuctionsRoute,
  } as any);
const AuthedActiveSStoreIdAuctionsQuestionsRoute =
  AuthedActiveSStoreIdAuctionsQuestionsRouteImport.update({
    id: '/questions',
    path: '/questions',
    getParentRoute: () => AuthedActiveSStoreIdAuctionsRoute,
  } as any);
const AuthedActiveSStoreIdCatalogIndexRoute =
  AuthedActiveSStoreIdCatalogIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdCatalogRoute,
  } as any);
const AuthedActiveSStoreIdCatalogStoreProductIdRoute =
  AuthedActiveSStoreIdCatalogStoreProductIdRouteImport.update({
    id: '/$storeProductId',
    path: '/$storeProductId',
    getParentRoute: () => AuthedActiveSStoreIdCatalogRoute,
  } as any);
const AuthedActiveSStoreIdCollectionsIndexRoute =
  AuthedActiveSStoreIdCollectionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdCollectionsRoute,
  } as any);
const AuthedActiveSStoreIdCollectionsCollectionIdRoute =
  AuthedActiveSStoreIdCollectionsCollectionIdRouteImport.update({
    id: '/$collectionId',
    path: '/$collectionId',
    getParentRoute: () => AuthedActiveSStoreIdCollectionsRoute,
  } as any);
const AuthedActiveSStoreIdCollectionsNewRoute =
  AuthedActiveSStoreIdCollectionsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedActiveSStoreIdCollectionsRoute,
  } as any);
const AuthedActiveSStoreIdContentIndexRoute =
  AuthedActiveSStoreIdContentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdContentRoute,
  } as any);
const AuthedActiveSStoreIdContentBlocksRoute =
  AuthedActiveSStoreIdContentBlocksRouteImport.update({
    id: '/blocks',
    path: '/blocks',
    getParentRoute: () => AuthedActiveSStoreIdContentRoute,
  } as any);
const AuthedActiveSStoreIdContentBlogRoute =
  AuthedActiveSStoreIdContentBlogRouteImport.update({
    id: '/blog',
    path: '/blog',
    getParentRoute: () => AuthedActiveSStoreIdContentRoute,
  } as any);
const AuthedActiveSStoreIdContentMenusRoute =
  AuthedActiveSStoreIdContentMenusRouteImport.update({
    id: '/menus',
    path: '/menus',
    getParentRoute: () => AuthedActiveSStoreIdContentRoute,
  } as any);
const AuthedActiveSStoreIdContentPagesRoute =
  AuthedActiveSStoreIdContentPagesRouteImport.update({
    id: '/pages',
    path: '/pages',
    getParentRoute: () => AuthedActiveSStoreIdContentRoute,
  } as any);
const AuthedActiveSStoreIdContentRedirectsRoute =
  AuthedActiveSStoreIdContentRedirectsRouteImport.update({
    id: '/redirects',
    path: '/redirects',
    getParentRoute: () => AuthedActiveSStoreIdContentRoute,
  } as any);
const AuthedActiveSStoreIdContentSectionsRoute =
  AuthedActiveSStoreIdContentSectionsRouteImport.update({
    id: '/sections',
    path: '/sections',
    getParentRoute: () => AuthedActiveSStoreIdContentRoute,
  } as any);
const AuthedActiveSStoreIdContentSeoRoute =
  AuthedActiveSStoreIdContentSeoRouteImport.update({
    id: '/seo',
    path: '/seo',
    getParentRoute: () => AuthedActiveSStoreIdContentRoute,
  } as any);
const AuthedActiveSStoreIdCustomersIndexRoute =
  AuthedActiveSStoreIdCustomersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdCustomersRoute,
  } as any);
const AuthedActiveSStoreIdCustomersCustomerIdRoute =
  AuthedActiveSStoreIdCustomersCustomerIdRouteImport.update({
    id: '/$customerId',
    path: '/$customerId',
    getParentRoute: () => AuthedActiveSStoreIdCustomersRoute,
  } as any);
const AuthedActiveSStoreIdDiscountsIndexRoute =
  AuthedActiveSStoreIdDiscountsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdDiscountsRoute,
  } as any);
const AuthedActiveSStoreIdDiscountsDiscountIdRoute =
  AuthedActiveSStoreIdDiscountsDiscountIdRouteImport.update({
    id: '/$discountId',
    path: '/$discountId',
    getParentRoute: () => AuthedActiveSStoreIdDiscountsRoute,
  } as any);
const AuthedActiveSStoreIdDiscountsNewRoute =
  AuthedActiveSStoreIdDiscountsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedActiveSStoreIdDiscountsRoute,
  } as any);
const AuthedActiveSStoreIdDraftOrdersIndexRoute =
  AuthedActiveSStoreIdDraftOrdersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdDraftOrdersRoute,
  } as any);
const AuthedActiveSStoreIdDraftOrdersDraftIdRoute =
  AuthedActiveSStoreIdDraftOrdersDraftIdRouteImport.update({
    id: '/$draftId',
    path: '/$draftId',
    getParentRoute: () => AuthedActiveSStoreIdDraftOrdersRoute,
  } as any);
const AuthedActiveSStoreIdDraftOrdersNewRoute =
  AuthedActiveSStoreIdDraftOrdersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedActiveSStoreIdDraftOrdersRoute,
  } as any);
const AuthedActiveSStoreIdGiftCardsIndexRoute =
  AuthedActiveSStoreIdGiftCardsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdGiftCardsRoute,
  } as any);
const AuthedActiveSStoreIdGiftCardsGiftCardIdRoute =
  AuthedActiveSStoreIdGiftCardsGiftCardIdRouteImport.update({
    id: '/$giftCardId',
    path: '/$giftCardId',
    getParentRoute: () => AuthedActiveSStoreIdGiftCardsRoute,
  } as any);
const AuthedActiveSStoreIdHelpIndexRoute =
  AuthedActiveSStoreIdHelpIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdHelpRoute,
  } as any);
const AuthedActiveSStoreIdHelpArticleIdRoute =
  AuthedActiveSStoreIdHelpArticleIdRouteImport.update({
    id: '/$articleId',
    path: '/$articleId',
    getParentRoute: () => AuthedActiveSStoreIdHelpRoute,
  } as any);
const AuthedActiveSStoreIdHelpCategoriesRoute =
  AuthedActiveSStoreIdHelpCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => AuthedActiveSStoreIdHelpRoute,
  } as any);
const AuthedActiveSStoreIdHelpNewRoute =
  AuthedActiveSStoreIdHelpNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedActiveSStoreIdHelpRoute,
  } as any);
const AuthedActiveSStoreIdInboxIndexRoute =
  AuthedActiveSStoreIdInboxIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdInboxRoute,
  } as any);
const AuthedActiveSStoreIdInboxConversationIdRoute =
  AuthedActiveSStoreIdInboxConversationIdRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => AuthedActiveSStoreIdInboxRoute,
  } as any);
const AuthedActiveSStoreIdInventoryVariantIdRoute =
  AuthedActiveSStoreIdInventoryVariantIdRouteImport.update({
    id: '/inventory_/$variantId',
    path: '/inventory/$variantId',
    getParentRoute: () => AuthedActiveSStoreIdRoute,
  } as any);
const AuthedActiveSStoreIdOrdersIndexRoute =
  AuthedActiveSStoreIdOrdersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdOrdersRoute,
  } as any);
const AuthedActiveSStoreIdOrdersOrderIdRoute =
  AuthedActiveSStoreIdOrdersOrderIdRouteImport.update({
    id: '/$orderId',
    path: '/$orderId',
    getParentRoute: () => AuthedActiveSStoreIdOrdersRoute,
  } as any);
const AuthedActiveSStoreIdReportsIndexRoute =
  AuthedActiveSStoreIdReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdReportsRoute,
  } as any);
const AuthedActiveSStoreIdReportsAnalyticsRoute =
  AuthedActiveSStoreIdReportsAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthedActiveSStoreIdReportsRoute,
  } as any);
const AuthedActiveSStoreIdReportsAuctionsRoute =
  AuthedActiveSStoreIdReportsAuctionsRouteImport.update({
    id: '/auctions',
    path: '/auctions',
    getParentRoute: () => AuthedActiveSStoreIdReportsRoute,
  } as any);
const AuthedActiveSStoreIdReportsCustomersRoute =
  AuthedActiveSStoreIdReportsCustomersRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => AuthedActiveSStoreIdReportsRoute,
  } as any);
const AuthedActiveSStoreIdReportsInventoryRoute =
  AuthedActiveSStoreIdReportsInventoryRouteImport.update({
    id: '/inventory',
    path: '/inventory',
    getParentRoute: () => AuthedActiveSStoreIdReportsRoute,
  } as any);
const AuthedActiveSStoreIdReportsPaymentsRoute =
  AuthedActiveSStoreIdReportsPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => AuthedActiveSStoreIdReportsRoute,
  } as any);
const AuthedActiveSStoreIdReportsProductsRoute =
  AuthedActiveSStoreIdReportsProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthedActiveSStoreIdReportsRoute,
  } as any);
const AuthedActiveSStoreIdReportsSalesRoute =
  AuthedActiveSStoreIdReportsSalesRouteImport.update({
    id: '/sales',
    path: '/sales',
    getParentRoute: () => AuthedActiveSStoreIdReportsRoute,
  } as any);
const AuthedActiveSStoreIdReportsSupportRoute =
  AuthedActiveSStoreIdReportsSupportRouteImport.update({
    id: '/support',
    path: '/support',
    getParentRoute: () => AuthedActiveSStoreIdReportsRoute,
  } as any);
const AuthedActiveSStoreIdReturnsIndexRoute =
  AuthedActiveSStoreIdReturnsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdReturnsRoute,
  } as any);
const AuthedActiveSStoreIdReturnsReturnIdRoute =
  AuthedActiveSStoreIdReturnsReturnIdRouteImport.update({
    id: '/$returnId',
    path: '/$returnId',
    getParentRoute: () => AuthedActiveSStoreIdReturnsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsIndexRoute =
  AuthedActiveSStoreIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsAnalyticsRoute =
  AuthedActiveSStoreIdSettingsAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsApiKeysRoute =
  AuthedActiveSStoreIdSettingsApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsChatRoute =
  AuthedActiveSStoreIdSettingsChatRouteImport.update({
    id: '/chat',
    path: '/chat',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsFeedsRoute =
  AuthedActiveSStoreIdSettingsFeedsRouteImport.update({
    id: '/feeds',
    path: '/feeds',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsImportsExportsRoute =
  AuthedActiveSStoreIdSettingsImportsExportsRouteImport.update({
    id: '/imports-exports',
    path: '/imports-exports',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsLocationsRoute =
  AuthedActiveSStoreIdSettingsLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsMarketsRoute =
  AuthedActiveSStoreIdSettingsMarketsRouteImport.update({
    id: '/markets',
    path: '/markets',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsNotificationsRoute =
  AuthedActiveSStoreIdSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsPaymentMethodsRoute =
  AuthedActiveSStoreIdSettingsPaymentMethodsRouteImport.update({
    id: '/payment-methods',
    path: '/payment-methods',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsPoliciesRoute =
  AuthedActiveSStoreIdSettingsPoliciesRouteImport.update({
    id: '/policies',
    path: '/policies',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsQcChecklistsRoute =
  AuthedActiveSStoreIdSettingsQcChecklistsRouteImport.update({
    id: '/qc-checklists',
    path: '/qc-checklists',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsRecoveryRoute =
  AuthedActiveSStoreIdSettingsRecoveryRouteImport.update({
    id: '/recovery',
    path: '/recovery',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsReturnsRoute =
  AuthedActiveSStoreIdSettingsReturnsRouteImport.update({
    id: '/returns',
    path: '/returns',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsShippingRoute =
  AuthedActiveSStoreIdSettingsShippingRouteImport.update({
    id: '/shipping',
    path: '/shipping',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsTaxRoute =
  AuthedActiveSStoreIdSettingsTaxRouteImport.update({
    id: '/tax',
    path: '/tax',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsWebhooksRoute =
  AuthedActiveSStoreIdSettingsWebhooksRouteImport.update({
    id: '/webhooks',
    path: '/webhooks',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsWorkflowsRoute =
  AuthedActiveSStoreIdSettingsWorkflowsRouteImport.update({
    id: '/workflows',
    path: '/workflows',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSocialIndexRoute =
  AuthedActiveSStoreIdSocialIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdSocialRoute,
  } as any);
const AuthedActiveSStoreIdSocialPinterestRoute =
  AuthedActiveSStoreIdSocialPinterestRouteImport.update({
    id: '/pinterest',
    path: '/pinterest',
    getParentRoute: () => AuthedActiveSStoreIdSocialRoute,
  } as any);
const AuthedActiveStoresStoreIdInboxConversationIdRoute =
  AuthedActiveStoresStoreIdInboxConversationIdRouteImport.update({
    id: '/stores/$storeId/inbox/$conversationId',
    path: '/stores/$storeId/inbox/$conversationId',
    getParentRoute: () => AuthedActiveRoute,
  } as any);
const AuthedActiveOrgProductsProductIdVariantsVariantIdRoute =
  AuthedActiveOrgProductsProductIdVariantsVariantIdRouteImport.update({
    id: '/$productId_/variants/$variantId',
    path: '/$productId/variants/$variantId',
    getParentRoute: () => AuthedActiveOrgProductsRoute,
  } as any);
const AuthedActiveSStoreIdAuctionsSalesIndexRoute =
  AuthedActiveSStoreIdAuctionsSalesIndexRouteImport.update({
    id: '/sales/',
    path: '/sales/',
    getParentRoute: () => AuthedActiveSStoreIdAuctionsRoute,
  } as any);
const AuthedActiveSStoreIdAuctionsSalesSaleIdRoute =
  AuthedActiveSStoreIdAuctionsSalesSaleIdRouteImport.update({
    id: '/sales/$saleId',
    path: '/sales/$saleId',
    getParentRoute: () => AuthedActiveSStoreIdAuctionsRoute,
  } as any);
const AuthedActiveSStoreIdContentBlocksIndexRoute =
  AuthedActiveSStoreIdContentBlocksIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdContentBlocksRoute,
  } as any);
const AuthedActiveSStoreIdContentBlocksBlockIdRoute =
  AuthedActiveSStoreIdContentBlocksBlockIdRouteImport.update({
    id: '/$blockId',
    path: '/$blockId',
    getParentRoute: () => AuthedActiveSStoreIdContentBlocksRoute,
  } as any);
const AuthedActiveSStoreIdContentBlocksNewRoute =
  AuthedActiveSStoreIdContentBlocksNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedActiveSStoreIdContentBlocksRoute,
  } as any);
const AuthedActiveSStoreIdContentBlogIndexRoute =
  AuthedActiveSStoreIdContentBlogIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdContentBlogRoute,
  } as any);
const AuthedActiveSStoreIdContentBlogPostIdRoute =
  AuthedActiveSStoreIdContentBlogPostIdRouteImport.update({
    id: '/$postId',
    path: '/$postId',
    getParentRoute: () => AuthedActiveSStoreIdContentBlogRoute,
  } as any);
const AuthedActiveSStoreIdContentBlogCategoriesRoute =
  AuthedActiveSStoreIdContentBlogCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => AuthedActiveSStoreIdContentBlogRoute,
  } as any);
const AuthedActiveSStoreIdContentBlogNewRoute =
  AuthedActiveSStoreIdContentBlogNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedActiveSStoreIdContentBlogRoute,
  } as any);
const AuthedActiveSStoreIdContentMenusIndexRoute =
  AuthedActiveSStoreIdContentMenusIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdContentMenusRoute,
  } as any);
const AuthedActiveSStoreIdContentMenusMenuIdRoute =
  AuthedActiveSStoreIdContentMenusMenuIdRouteImport.update({
    id: '/$menuId',
    path: '/$menuId',
    getParentRoute: () => AuthedActiveSStoreIdContentMenusRoute,
  } as any);
const AuthedActiveSStoreIdContentPagesIndexRoute =
  AuthedActiveSStoreIdContentPagesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdContentPagesRoute,
  } as any);
const AuthedActiveSStoreIdContentPagesPageIdRoute =
  AuthedActiveSStoreIdContentPagesPageIdRouteImport.update({
    id: '/$pageId',
    path: '/$pageId',
    getParentRoute: () => AuthedActiveSStoreIdContentPagesRoute,
  } as any);
const AuthedActiveSStoreIdContentPagesNewRoute =
  AuthedActiveSStoreIdContentPagesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedActiveSStoreIdContentPagesRoute,
  } as any);
const AuthedActiveSStoreIdContentSectionsIndexRoute =
  AuthedActiveSStoreIdContentSectionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdContentSectionsRoute,
  } as any);
const AuthedActiveSStoreIdContentSectionsSectionIdRoute =
  AuthedActiveSStoreIdContentSectionsSectionIdRouteImport.update({
    id: '/$sectionId',
    path: '/$sectionId',
    getParentRoute: () => AuthedActiveSStoreIdContentSectionsRoute,
  } as any);
const AuthedActiveSStoreIdContentSectionsNewRoute =
  AuthedActiveSStoreIdContentSectionsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedActiveSStoreIdContentSectionsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsPoliciesIndexRoute =
  AuthedActiveSStoreIdSettingsPoliciesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdSettingsPoliciesRoute,
  } as any);
const AuthedActiveSStoreIdSettingsPoliciesPolicyIdRoute =
  AuthedActiveSStoreIdSettingsPoliciesPolicyIdRouteImport.update({
    id: '/$policyId',
    path: '/$policyId',
    getParentRoute: () => AuthedActiveSStoreIdSettingsPoliciesRoute,
  } as any);
const AuthedActiveSStoreIdSettingsPoliciesNewRoute =
  AuthedActiveSStoreIdSettingsPoliciesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedActiveSStoreIdSettingsPoliciesRoute,
  } as any);
const AuthedActiveSStoreIdSettingsQcChecklistsIndexRoute =
  AuthedActiveSStoreIdSettingsQcChecklistsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdSettingsQcChecklistsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsQcChecklistsChecklistIdRoute =
  AuthedActiveSStoreIdSettingsQcChecklistsChecklistIdRouteImport.update({
    id: '/$checklistId',
    path: '/$checklistId',
    getParentRoute: () => AuthedActiveSStoreIdSettingsQcChecklistsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsQcChecklistsNewRoute =
  AuthedActiveSStoreIdSettingsQcChecklistsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedActiveSStoreIdSettingsQcChecklistsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsWebhooksIndexRoute =
  AuthedActiveSStoreIdSettingsWebhooksIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdSettingsWebhooksRoute,
  } as any);
const AuthedActiveSStoreIdSettingsWebhooksEndpointIdRoute =
  AuthedActiveSStoreIdSettingsWebhooksEndpointIdRouteImport.update({
    id: '/$endpointId',
    path: '/$endpointId',
    getParentRoute: () => AuthedActiveSStoreIdSettingsWebhooksRoute,
  } as any);
const AuthedActiveSStoreIdSettingsWorkflowsIndexRoute =
  AuthedActiveSStoreIdSettingsWorkflowsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdSettingsWorkflowsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsWorkflowsTemplateIdRoute =
  AuthedActiveSStoreIdSettingsWorkflowsTemplateIdRouteImport.update({
    id: '/$templateId',
    path: '/$templateId',
    getParentRoute: () => AuthedActiveSStoreIdSettingsWorkflowsRoute,
  } as any);
const AuthedActiveSStoreIdSettingsWorkflowsNewRoute =
  AuthedActiveSStoreIdSettingsWorkflowsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedActiveSStoreIdSettingsWorkflowsRoute,
  } as any);
const AuthedActiveSStoreIdSocialPinterestIndexRoute =
  AuthedActiveSStoreIdSocialPinterestIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdSocialPinterestRoute,
  } as any);
const AuthedActiveSStoreIdSocialPinterestAnalyticsRoute =
  AuthedActiveSStoreIdSocialPinterestAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthedActiveSStoreIdSocialPinterestRoute,
  } as any);
const AuthedActiveSStoreIdSocialPinterestConnectionRoute =
  AuthedActiveSStoreIdSocialPinterestConnectionRouteImport.update({
    id: '/connection',
    path: '/connection',
    getParentRoute: () => AuthedActiveSStoreIdSocialPinterestRoute,
  } as any);
const AuthedActiveSStoreIdSocialPinterestCreateRoute =
  AuthedActiveSStoreIdSocialPinterestCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthedActiveSStoreIdSocialPinterestRoute,
  } as any);
const AuthedActiveSStoreIdSocialPinterestPostsRoute =
  AuthedActiveSStoreIdSocialPinterestPostsRouteImport.update({
    id: '/posts',
    path: '/posts',
    getParentRoute: () => AuthedActiveSStoreIdSocialPinterestRoute,
  } as any);
const AuthedActiveSStoreIdSocialPinterestSettingsRoute =
  AuthedActiveSStoreIdSocialPinterestSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthedActiveSStoreIdSocialPinterestRoute,
  } as any);
const AuthedActiveSStoreIdCatalogStoreProductIdVariantsVariantIdRoute =
  AuthedActiveSStoreIdCatalogStoreProductIdVariantsVariantIdRouteImport.update({
    id: '/$storeProductId_/variants/$variantId',
    path: '/$storeProductId/variants/$variantId',
    getParentRoute: () => AuthedActiveSStoreIdCatalogRoute,
  } as any);
const AuthedActiveSStoreIdContentBlocksNewIndexRoute =
  AuthedActiveSStoreIdContentBlocksNewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdContentBlocksNewRoute,
  } as any);
const AuthedActiveSStoreIdContentBlocksNewKindRoute =
  AuthedActiveSStoreIdContentBlocksNewKindRouteImport.update({
    id: '/$kind',
    path: '/$kind',
    getParentRoute: () => AuthedActiveSStoreIdContentBlocksNewRoute,
  } as any);
const AuthedActiveSStoreIdSettingsPaymentsStripeCallbackRoute =
  AuthedActiveSStoreIdSettingsPaymentsStripeCallbackRouteImport.update({
    id: '/payments/stripe/callback',
    path: '/payments/stripe/callback',
    getParentRoute: () => AuthedActiveSStoreIdSettingsRoute,
  } as any);
const AuthedActiveSStoreIdSocialPinterestPostsIndexRoute =
  AuthedActiveSStoreIdSocialPinterestPostsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedActiveSStoreIdSocialPinterestPostsRoute,
  } as any);
const AuthedActiveSStoreIdSocialPinterestPostsPostIdRoute =
  AuthedActiveSStoreIdSocialPinterestPostsPostIdRouteImport.update({
    id: '/$postId',
    path: '/$postId',
    getParentRoute: () => AuthedActiveSStoreIdSocialPinterestPostsRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/accept-invite': typeof publicAcceptInviteRoute;
  '/confirm-email': typeof publicConfirmEmailRoute;
  '/forgot-password': typeof publicForgotPasswordRoute;
  '/login': typeof publicLoginRoute;
  '/magic-link': typeof publicMagicLinkRoute;
  '/reset-password': typeof publicResetPasswordRoute;
  '/sign-in-link': typeof publicSignInLinkRoute;
  '/docs': typeof AuthedDocsRouteWithChildren;
  '/apply/confirm': typeof publicApplyConfirmRoute;
  '/help': typeof AuthedActiveHelpRoute;
  '/docs/build': typeof AuthedDocsBuildRoute;
  '/docs/postman': typeof AuthedDocsPostmanRoute;
  '/apply/': typeof publicApplyIndexRoute;
  '/docs/': typeof AuthedDocsIndexRoute;
  '/auth/google/callback': typeof publicAuthGoogleCallbackRoute;
  '/account/chat-profile': typeof AuthedActiveAccountChatProfileRoute;
  '/account/notifications': typeof AuthedActiveAccountNotificationsRoute;
  '/account/security': typeof AuthedActiveAccountSecurityRoute;
  '/org/activity': typeof AuthedActiveOrgActivityRoute;
  '/org/catalog-setup': typeof AuthedActiveOrgCatalogSetupRouteWithChildren;
  '/org/customizations': typeof AuthedActiveOrgCustomizationsRoute;
  '/org/inbox': typeof AuthedActiveOrgInboxRouteWithChildren;
  '/org/media': typeof AuthedActiveOrgMediaRoute;
  '/org/products': typeof AuthedActiveOrgProductsRouteWithChildren;
  '/org/roles': typeof AuthedActiveOrgRolesRoute;
  '/org/schedules': typeof AuthedActiveOrgSchedulesRouteWithChildren;
  '/org/settings': typeof AuthedActiveOrgSettingsRoute;
  '/org/shared-blocks': typeof AuthedActiveOrgSharedBlocksRouteWithChildren;
  '/org/stone-pricing': typeof AuthedActiveOrgStonePricingRoute;
  '/org/stores': typeof AuthedActiveOrgStoresRouteWithChildren;
  '/org/team': typeof AuthedActiveOrgTeamRoute;
  '/s/$storeId': typeof AuthedActiveSStoreIdRouteWithChildren;
  '/docs/guides/$slug': typeof AuthedDocsGuidesSlugRoute;
  '/account/': typeof AuthedActiveAccountIndexRoute;
  '/org/': typeof AuthedActiveOrgIndexRoute;
  '/docs/api/': typeof AuthedDocsApiIndexRoute;
  '/org/catalog-setup/attributes': typeof AuthedActiveOrgCatalogSetupAttributesRouteWithChildren;
  '/org/catalog-setup/customizations': typeof AuthedActiveOrgCatalogSetupCustomizationsRoute;
  '/org/catalog-setup/product-types': typeof AuthedActiveOrgCatalogSetupProductTypesRouteWithChildren;
  '/org/catalog-setup/size-sets': typeof AuthedActiveOrgCatalogSetupSizeSetsRouteWithChildren;
  '/org/catalog-setup/sku-rules': typeof AuthedActiveOrgCatalogSetupSkuRulesRouteWithChildren;
  '/org/products/$productId': typeof AuthedActiveOrgProductsProductIdRoute;
  '/org/products/new': typeof AuthedActiveOrgProductsNewRoute;
  '/org/schedules/$scheduleId': typeof AuthedActiveOrgSchedulesScheduleIdRoute;
  '/org/schedules/new': typeof AuthedActiveOrgSchedulesNewRoute;
  '/org/schedules/upcoming': typeof AuthedActiveOrgSchedulesUpcomingRoute;
  '/org/shared-blocks/$blockId': typeof AuthedActiveOrgSharedBlocksBlockIdRoute;
  '/org/shared-blocks/new': typeof AuthedActiveOrgSharedBlocksNewRouteWithChildren;
  '/org/stores/$storeId': typeof AuthedActiveOrgStoresStoreIdRoute;
  '/s/$storeId/abandoned-checkouts': typeof AuthedActiveSStoreIdAbandonedCheckoutsRouteWithChildren;
  '/s/$storeId/appointments': typeof AuthedActiveSStoreIdAppointmentsRoute;
  '/s/$storeId/auctions': typeof AuthedActiveSStoreIdAuctionsRouteWithChildren;
  '/s/$storeId/catalog': typeof AuthedActiveSStoreIdCatalogRouteWithChildren;
  '/s/$storeId/collections': typeof AuthedActiveSStoreIdCollectionsRouteWithChildren;
  '/s/$storeId/content': typeof AuthedActiveSStoreIdContentRouteWithChildren;
  '/s/$storeId/customers': typeof AuthedActiveSStoreIdCustomersRouteWithChildren;
  '/s/$storeId/discounts': typeof AuthedActiveSStoreIdDiscountsRouteWithChildren;
  '/s/$storeId/draft-orders': typeof AuthedActiveSStoreIdDraftOrdersRouteWithChildren;
  '/s/$storeId/gift-cards': typeof AuthedActiveSStoreIdGiftCardsRouteWithChildren;
  '/s/$storeId/help': typeof AuthedActiveSStoreIdHelpRouteWithChildren;
  '/s/$storeId/inbox': typeof AuthedActiveSStoreIdInboxRouteWithChildren;
  '/s/$storeId/inventory': typeof AuthedActiveSStoreIdInventoryRoute;
  '/s/$storeId/orders': typeof AuthedActiveSStoreIdOrdersRouteWithChildren;
  '/s/$storeId/privacy-requests': typeof AuthedActiveSStoreIdPrivacyRequestsRoute;
  '/s/$storeId/production': typeof AuthedActiveSStoreIdProductionRoute;
  '/s/$storeId/reports': typeof AuthedActiveSStoreIdReportsRouteWithChildren;
  '/s/$storeId/returns': typeof AuthedActiveSStoreIdReturnsRouteWithChildren;
  '/s/$storeId/settings': typeof AuthedActiveSStoreIdSettingsRouteWithChildren;
  '/s/$storeId/social': typeof AuthedActiveSStoreIdSocialRouteWithChildren;
  '/docs/api/$tag/$operation': typeof AuthedDocsApiTagOperationRoute;
  '/org/catalog-setup/': typeof AuthedActiveOrgCatalogSetupIndexRoute;
  '/org/inbox/': typeof AuthedActiveOrgInboxIndexRoute;
  '/org/products/': typeof AuthedActiveOrgProductsIndexRoute;
  '/org/schedules/': typeof AuthedActiveOrgSchedulesIndexRoute;
  '/org/shared-blocks/': typeof AuthedActiveOrgSharedBlocksIndexRoute;
  '/org/stores/': typeof AuthedActiveOrgStoresIndexRoute;
  '/s/$storeId/': typeof AuthedActiveSStoreIdIndexRoute;
  '/org/catalog-setup/attributes/$attributeId': typeof AuthedActiveOrgCatalogSetupAttributesAttributeIdRoute;
  '/org/catalog-setup/product-types/$productTypeId': typeof AuthedActiveOrgCatalogSetupProductTypesProductTypeIdRoute;
  '/org/catalog-setup/product-types/new': typeof AuthedActiveOrgCatalogSetupProductTypesNewRoute;
  '/org/catalog-setup/size-sets/$sizeSetId': typeof AuthedActiveOrgCatalogSetupSizeSetsSizeSetIdRoute;
  '/org/catalog-setup/size-sets/new': typeof AuthedActiveOrgCatalogSetupSizeSetsNewRoute;
  '/org/catalog-setup/sku-rules/$ruleId': typeof AuthedActiveOrgCatalogSetupSkuRulesRuleIdRoute;
  '/org/catalog-setup/sku-rules/new': typeof AuthedActiveOrgCatalogSetupSkuRulesNewRoute;
  '/org/inbox/$storeId/$conversationId': typeof AuthedActiveOrgInboxStoreIdConversationIdRoute;
  '/org/shared-blocks/new/$kind': typeof AuthedActiveOrgSharedBlocksNewKindRoute;
  '/s/$storeId/abandoned-checkouts/$checkoutId': typeof AuthedActiveSStoreIdAbandonedCheckoutsCheckoutIdRoute;
  '/s/$storeId/auctions/$auctionId': typeof AuthedActiveSStoreIdAuctionsAuctionIdRoute;
  '/s/$storeId/auctions/bidders': typeof AuthedActiveSStoreIdAuctionsBiddersRoute;
  '/s/$storeId/auctions/questions': typeof AuthedActiveSStoreIdAuctionsQuestionsRoute;
  '/s/$storeId/catalog/$storeProductId': typeof AuthedActiveSStoreIdCatalogStoreProductIdRoute;
  '/s/$storeId/collections/$collectionId': typeof AuthedActiveSStoreIdCollectionsCollectionIdRoute;
  '/s/$storeId/collections/new': typeof AuthedActiveSStoreIdCollectionsNewRoute;
  '/s/$storeId/content/blocks': typeof AuthedActiveSStoreIdContentBlocksRouteWithChildren;
  '/s/$storeId/content/blog': typeof AuthedActiveSStoreIdContentBlogRouteWithChildren;
  '/s/$storeId/content/menus': typeof AuthedActiveSStoreIdContentMenusRouteWithChildren;
  '/s/$storeId/content/pages': typeof AuthedActiveSStoreIdContentPagesRouteWithChildren;
  '/s/$storeId/content/redirects': typeof AuthedActiveSStoreIdContentRedirectsRoute;
  '/s/$storeId/content/sections': typeof AuthedActiveSStoreIdContentSectionsRouteWithChildren;
  '/s/$storeId/content/seo': typeof AuthedActiveSStoreIdContentSeoRoute;
  '/s/$storeId/customers/$customerId': typeof AuthedActiveSStoreIdCustomersCustomerIdRoute;
  '/s/$storeId/discounts/$discountId': typeof AuthedActiveSStoreIdDiscountsDiscountIdRoute;
  '/s/$storeId/discounts/new': typeof AuthedActiveSStoreIdDiscountsNewRoute;
  '/s/$storeId/draft-orders/$draftId': typeof AuthedActiveSStoreIdDraftOrdersDraftIdRoute;
  '/s/$storeId/draft-orders/new': typeof AuthedActiveSStoreIdDraftOrdersNewRoute;
  '/s/$storeId/gift-cards/$giftCardId': typeof AuthedActiveSStoreIdGiftCardsGiftCardIdRoute;
  '/s/$storeId/help/$articleId': typeof AuthedActiveSStoreIdHelpArticleIdRoute;
  '/s/$storeId/help/categories': typeof AuthedActiveSStoreIdHelpCategoriesRoute;
  '/s/$storeId/help/new': typeof AuthedActiveSStoreIdHelpNewRoute;
  '/s/$storeId/inbox/$conversationId': typeof AuthedActiveSStoreIdInboxConversationIdRoute;
  '/s/$storeId/inventory/$variantId': typeof AuthedActiveSStoreIdInventoryVariantIdRoute;
  '/s/$storeId/orders/$orderId': typeof AuthedActiveSStoreIdOrdersOrderIdRoute;
  '/s/$storeId/reports/analytics': typeof AuthedActiveSStoreIdReportsAnalyticsRoute;
  '/s/$storeId/reports/auctions': typeof AuthedActiveSStoreIdReportsAuctionsRoute;
  '/s/$storeId/reports/customers': typeof AuthedActiveSStoreIdReportsCustomersRoute;
  '/s/$storeId/reports/inventory': typeof AuthedActiveSStoreIdReportsInventoryRoute;
  '/s/$storeId/reports/payments': typeof AuthedActiveSStoreIdReportsPaymentsRoute;
  '/s/$storeId/reports/products': typeof AuthedActiveSStoreIdReportsProductsRoute;
  '/s/$storeId/reports/sales': typeof AuthedActiveSStoreIdReportsSalesRoute;
  '/s/$storeId/reports/support': typeof AuthedActiveSStoreIdReportsSupportRoute;
  '/s/$storeId/returns/$returnId': typeof AuthedActiveSStoreIdReturnsReturnIdRoute;
  '/s/$storeId/settings/analytics': typeof AuthedActiveSStoreIdSettingsAnalyticsRoute;
  '/s/$storeId/settings/api-keys': typeof AuthedActiveSStoreIdSettingsApiKeysRoute;
  '/s/$storeId/settings/chat': typeof AuthedActiveSStoreIdSettingsChatRoute;
  '/s/$storeId/settings/feeds': typeof AuthedActiveSStoreIdSettingsFeedsRoute;
  '/s/$storeId/settings/imports-exports': typeof AuthedActiveSStoreIdSettingsImportsExportsRoute;
  '/s/$storeId/settings/locations': typeof AuthedActiveSStoreIdSettingsLocationsRoute;
  '/s/$storeId/settings/markets': typeof AuthedActiveSStoreIdSettingsMarketsRoute;
  '/s/$storeId/settings/notifications': typeof AuthedActiveSStoreIdSettingsNotificationsRoute;
  '/s/$storeId/settings/payment-methods': typeof AuthedActiveSStoreIdSettingsPaymentMethodsRoute;
  '/s/$storeId/settings/policies': typeof AuthedActiveSStoreIdSettingsPoliciesRouteWithChildren;
  '/s/$storeId/settings/qc-checklists': typeof AuthedActiveSStoreIdSettingsQcChecklistsRouteWithChildren;
  '/s/$storeId/settings/recovery': typeof AuthedActiveSStoreIdSettingsRecoveryRoute;
  '/s/$storeId/settings/returns': typeof AuthedActiveSStoreIdSettingsReturnsRoute;
  '/s/$storeId/settings/shipping': typeof AuthedActiveSStoreIdSettingsShippingRoute;
  '/s/$storeId/settings/tax': typeof AuthedActiveSStoreIdSettingsTaxRoute;
  '/s/$storeId/settings/webhooks': typeof AuthedActiveSStoreIdSettingsWebhooksRouteWithChildren;
  '/s/$storeId/settings/workflows': typeof AuthedActiveSStoreIdSettingsWorkflowsRouteWithChildren;
  '/s/$storeId/social/pinterest': typeof AuthedActiveSStoreIdSocialPinterestRouteWithChildren;
  '/stores/$storeId/inbox/$conversationId': typeof AuthedActiveStoresStoreIdInboxConversationIdRoute;
  '/org/catalog-setup/attributes/': typeof AuthedActiveOrgCatalogSetupAttributesIndexRoute;
  '/org/catalog-setup/product-types/': typeof AuthedActiveOrgCatalogSetupProductTypesIndexRoute;
  '/org/catalog-setup/size-sets/': typeof AuthedActiveOrgCatalogSetupSizeSetsIndexRoute;
  '/org/catalog-setup/sku-rules/': typeof AuthedActiveOrgCatalogSetupSkuRulesIndexRoute;
  '/org/shared-blocks/new/': typeof AuthedActiveOrgSharedBlocksNewIndexRoute;
  '/s/$storeId/abandoned-checkouts/': typeof AuthedActiveSStoreIdAbandonedCheckoutsIndexRoute;
  '/s/$storeId/auctions/': typeof AuthedActiveSStoreIdAuctionsIndexRoute;
  '/s/$storeId/catalog/': typeof AuthedActiveSStoreIdCatalogIndexRoute;
  '/s/$storeId/collections/': typeof AuthedActiveSStoreIdCollectionsIndexRoute;
  '/s/$storeId/content/': typeof AuthedActiveSStoreIdContentIndexRoute;
  '/s/$storeId/customers/': typeof AuthedActiveSStoreIdCustomersIndexRoute;
  '/s/$storeId/discounts/': typeof AuthedActiveSStoreIdDiscountsIndexRoute;
  '/s/$storeId/draft-orders/': typeof AuthedActiveSStoreIdDraftOrdersIndexRoute;
  '/s/$storeId/gift-cards/': typeof AuthedActiveSStoreIdGiftCardsIndexRoute;
  '/s/$storeId/help/': typeof AuthedActiveSStoreIdHelpIndexRoute;
  '/s/$storeId/inbox/': typeof AuthedActiveSStoreIdInboxIndexRoute;
  '/s/$storeId/orders/': typeof AuthedActiveSStoreIdOrdersIndexRoute;
  '/s/$storeId/reports/': typeof AuthedActiveSStoreIdReportsIndexRoute;
  '/s/$storeId/returns/': typeof AuthedActiveSStoreIdReturnsIndexRoute;
  '/s/$storeId/settings/': typeof AuthedActiveSStoreIdSettingsIndexRoute;
  '/s/$storeId/social/': typeof AuthedActiveSStoreIdSocialIndexRoute;
  '/org/products/$productId/variants/$variantId': typeof AuthedActiveOrgProductsProductIdVariantsVariantIdRoute;
  '/s/$storeId/auctions/sales/$saleId': typeof AuthedActiveSStoreIdAuctionsSalesSaleIdRoute;
  '/s/$storeId/content/blocks/$blockId': typeof AuthedActiveSStoreIdContentBlocksBlockIdRoute;
  '/s/$storeId/content/blocks/new': typeof AuthedActiveSStoreIdContentBlocksNewRouteWithChildren;
  '/s/$storeId/content/blog/$postId': typeof AuthedActiveSStoreIdContentBlogPostIdRoute;
  '/s/$storeId/content/blog/categories': typeof AuthedActiveSStoreIdContentBlogCategoriesRoute;
  '/s/$storeId/content/blog/new': typeof AuthedActiveSStoreIdContentBlogNewRoute;
  '/s/$storeId/content/menus/$menuId': typeof AuthedActiveSStoreIdContentMenusMenuIdRoute;
  '/s/$storeId/content/pages/$pageId': typeof AuthedActiveSStoreIdContentPagesPageIdRoute;
  '/s/$storeId/content/pages/new': typeof AuthedActiveSStoreIdContentPagesNewRoute;
  '/s/$storeId/content/sections/$sectionId': typeof AuthedActiveSStoreIdContentSectionsSectionIdRoute;
  '/s/$storeId/content/sections/new': typeof AuthedActiveSStoreIdContentSectionsNewRoute;
  '/s/$storeId/settings/policies/$policyId': typeof AuthedActiveSStoreIdSettingsPoliciesPolicyIdRoute;
  '/s/$storeId/settings/policies/new': typeof AuthedActiveSStoreIdSettingsPoliciesNewRoute;
  '/s/$storeId/settings/qc-checklists/$checklistId': typeof AuthedActiveSStoreIdSettingsQcChecklistsChecklistIdRoute;
  '/s/$storeId/settings/qc-checklists/new': typeof AuthedActiveSStoreIdSettingsQcChecklistsNewRoute;
  '/s/$storeId/settings/webhooks/$endpointId': typeof AuthedActiveSStoreIdSettingsWebhooksEndpointIdRoute;
  '/s/$storeId/settings/workflows/$templateId': typeof AuthedActiveSStoreIdSettingsWorkflowsTemplateIdRoute;
  '/s/$storeId/settings/workflows/new': typeof AuthedActiveSStoreIdSettingsWorkflowsNewRoute;
  '/s/$storeId/social/pinterest/analytics': typeof AuthedActiveSStoreIdSocialPinterestAnalyticsRoute;
  '/s/$storeId/social/pinterest/connection': typeof AuthedActiveSStoreIdSocialPinterestConnectionRoute;
  '/s/$storeId/social/pinterest/create': typeof AuthedActiveSStoreIdSocialPinterestCreateRoute;
  '/s/$storeId/social/pinterest/posts': typeof AuthedActiveSStoreIdSocialPinterestPostsRouteWithChildren;
  '/s/$storeId/social/pinterest/settings': typeof AuthedActiveSStoreIdSocialPinterestSettingsRoute;
  '/s/$storeId/auctions/sales/': typeof AuthedActiveSStoreIdAuctionsSalesIndexRoute;
  '/s/$storeId/content/blocks/': typeof AuthedActiveSStoreIdContentBlocksIndexRoute;
  '/s/$storeId/content/blog/': typeof AuthedActiveSStoreIdContentBlogIndexRoute;
  '/s/$storeId/content/menus/': typeof AuthedActiveSStoreIdContentMenusIndexRoute;
  '/s/$storeId/content/pages/': typeof AuthedActiveSStoreIdContentPagesIndexRoute;
  '/s/$storeId/content/sections/': typeof AuthedActiveSStoreIdContentSectionsIndexRoute;
  '/s/$storeId/settings/policies/': typeof AuthedActiveSStoreIdSettingsPoliciesIndexRoute;
  '/s/$storeId/settings/qc-checklists/': typeof AuthedActiveSStoreIdSettingsQcChecklistsIndexRoute;
  '/s/$storeId/settings/webhooks/': typeof AuthedActiveSStoreIdSettingsWebhooksIndexRoute;
  '/s/$storeId/settings/workflows/': typeof AuthedActiveSStoreIdSettingsWorkflowsIndexRoute;
  '/s/$storeId/social/pinterest/': typeof AuthedActiveSStoreIdSocialPinterestIndexRoute;
  '/s/$storeId/catalog/$storeProductId/variants/$variantId': typeof AuthedActiveSStoreIdCatalogStoreProductIdVariantsVariantIdRoute;
  '/s/$storeId/content/blocks/new/$kind': typeof AuthedActiveSStoreIdContentBlocksNewKindRoute;
  '/s/$storeId/settings/payments/stripe/callback': typeof AuthedActiveSStoreIdSettingsPaymentsStripeCallbackRoute;
  '/s/$storeId/social/pinterest/posts/$postId': typeof AuthedActiveSStoreIdSocialPinterestPostsPostIdRoute;
  '/s/$storeId/content/blocks/new/': typeof AuthedActiveSStoreIdContentBlocksNewIndexRoute;
  '/s/$storeId/social/pinterest/posts/': typeof AuthedActiveSStoreIdSocialPinterestPostsIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/accept-invite': typeof publicAcceptInviteRoute;
  '/confirm-email': typeof publicConfirmEmailRoute;
  '/forgot-password': typeof publicForgotPasswordRoute;
  '/login': typeof publicLoginRoute;
  '/magic-link': typeof publicMagicLinkRoute;
  '/reset-password': typeof publicResetPasswordRoute;
  '/sign-in-link': typeof publicSignInLinkRoute;
  '/apply/confirm': typeof publicApplyConfirmRoute;
  '/help': typeof AuthedActiveHelpRoute;
  '/docs/build': typeof AuthedDocsBuildRoute;
  '/docs/postman': typeof AuthedDocsPostmanRoute;
  '/apply': typeof publicApplyIndexRoute;
  '/docs': typeof AuthedDocsIndexRoute;
  '/auth/google/callback': typeof publicAuthGoogleCallbackRoute;
  '/account/chat-profile': typeof AuthedActiveAccountChatProfileRoute;
  '/account/notifications': typeof AuthedActiveAccountNotificationsRoute;
  '/account/security': typeof AuthedActiveAccountSecurityRoute;
  '/org/activity': typeof AuthedActiveOrgActivityRoute;
  '/org/customizations': typeof AuthedActiveOrgCustomizationsRoute;
  '/org/media': typeof AuthedActiveOrgMediaRoute;
  '/org/roles': typeof AuthedActiveOrgRolesRoute;
  '/org/settings': typeof AuthedActiveOrgSettingsRoute;
  '/org/stone-pricing': typeof AuthedActiveOrgStonePricingRoute;
  '/org/team': typeof AuthedActiveOrgTeamRoute;
  '/docs/guides/$slug': typeof AuthedDocsGuidesSlugRoute;
  '/account': typeof AuthedActiveAccountIndexRoute;
  '/org': typeof AuthedActiveOrgIndexRoute;
  '/docs/api': typeof AuthedDocsApiIndexRoute;
  '/org/catalog-setup/customizations': typeof AuthedActiveOrgCatalogSetupCustomizationsRoute;
  '/org/products/$productId': typeof AuthedActiveOrgProductsProductIdRoute;
  '/org/products/new': typeof AuthedActiveOrgProductsNewRoute;
  '/org/schedules/$scheduleId': typeof AuthedActiveOrgSchedulesScheduleIdRoute;
  '/org/schedules/new': typeof AuthedActiveOrgSchedulesNewRoute;
  '/org/schedules/upcoming': typeof AuthedActiveOrgSchedulesUpcomingRoute;
  '/org/shared-blocks/$blockId': typeof AuthedActiveOrgSharedBlocksBlockIdRoute;
  '/org/stores/$storeId': typeof AuthedActiveOrgStoresStoreIdRoute;
  '/s/$storeId/appointments': typeof AuthedActiveSStoreIdAppointmentsRoute;
  '/s/$storeId/inventory': typeof AuthedActiveSStoreIdInventoryRoute;
  '/s/$storeId/privacy-requests': typeof AuthedActiveSStoreIdPrivacyRequestsRoute;
  '/s/$storeId/production': typeof AuthedActiveSStoreIdProductionRoute;
  '/docs/api/$tag/$operation': typeof AuthedDocsApiTagOperationRoute;
  '/org/catalog-setup': typeof AuthedActiveOrgCatalogSetupIndexRoute;
  '/org/inbox': typeof AuthedActiveOrgInboxIndexRoute;
  '/org/products': typeof AuthedActiveOrgProductsIndexRoute;
  '/org/schedules': typeof AuthedActiveOrgSchedulesIndexRoute;
  '/org/shared-blocks': typeof AuthedActiveOrgSharedBlocksIndexRoute;
  '/org/stores': typeof AuthedActiveOrgStoresIndexRoute;
  '/s/$storeId': typeof AuthedActiveSStoreIdIndexRoute;
  '/org/catalog-setup/attributes/$attributeId': typeof AuthedActiveOrgCatalogSetupAttributesAttributeIdRoute;
  '/org/catalog-setup/product-types/$productTypeId': typeof AuthedActiveOrgCatalogSetupProductTypesProductTypeIdRoute;
  '/org/catalog-setup/product-types/new': typeof AuthedActiveOrgCatalogSetupProductTypesNewRoute;
  '/org/catalog-setup/size-sets/$sizeSetId': typeof AuthedActiveOrgCatalogSetupSizeSetsSizeSetIdRoute;
  '/org/catalog-setup/size-sets/new': typeof AuthedActiveOrgCatalogSetupSizeSetsNewRoute;
  '/org/catalog-setup/sku-rules/$ruleId': typeof AuthedActiveOrgCatalogSetupSkuRulesRuleIdRoute;
  '/org/catalog-setup/sku-rules/new': typeof AuthedActiveOrgCatalogSetupSkuRulesNewRoute;
  '/org/inbox/$storeId/$conversationId': typeof AuthedActiveOrgInboxStoreIdConversationIdRoute;
  '/org/shared-blocks/new/$kind': typeof AuthedActiveOrgSharedBlocksNewKindRoute;
  '/s/$storeId/abandoned-checkouts/$checkoutId': typeof AuthedActiveSStoreIdAbandonedCheckoutsCheckoutIdRoute;
  '/s/$storeId/auctions/$auctionId': typeof AuthedActiveSStoreIdAuctionsAuctionIdRoute;
  '/s/$storeId/auctions/bidders': typeof AuthedActiveSStoreIdAuctionsBiddersRoute;
  '/s/$storeId/auctions/questions': typeof AuthedActiveSStoreIdAuctionsQuestionsRoute;
  '/s/$storeId/catalog/$storeProductId': typeof AuthedActiveSStoreIdCatalogStoreProductIdRoute;
  '/s/$storeId/collections/$collectionId': typeof AuthedActiveSStoreIdCollectionsCollectionIdRoute;
  '/s/$storeId/collections/new': typeof AuthedActiveSStoreIdCollectionsNewRoute;
  '/s/$storeId/content/redirects': typeof AuthedActiveSStoreIdContentRedirectsRoute;
  '/s/$storeId/content/seo': typeof AuthedActiveSStoreIdContentSeoRoute;
  '/s/$storeId/customers/$customerId': typeof AuthedActiveSStoreIdCustomersCustomerIdRoute;
  '/s/$storeId/discounts/$discountId': typeof AuthedActiveSStoreIdDiscountsDiscountIdRoute;
  '/s/$storeId/discounts/new': typeof AuthedActiveSStoreIdDiscountsNewRoute;
  '/s/$storeId/draft-orders/$draftId': typeof AuthedActiveSStoreIdDraftOrdersDraftIdRoute;
  '/s/$storeId/draft-orders/new': typeof AuthedActiveSStoreIdDraftOrdersNewRoute;
  '/s/$storeId/gift-cards/$giftCardId': typeof AuthedActiveSStoreIdGiftCardsGiftCardIdRoute;
  '/s/$storeId/help/$articleId': typeof AuthedActiveSStoreIdHelpArticleIdRoute;
  '/s/$storeId/help/categories': typeof AuthedActiveSStoreIdHelpCategoriesRoute;
  '/s/$storeId/help/new': typeof AuthedActiveSStoreIdHelpNewRoute;
  '/s/$storeId/inbox/$conversationId': typeof AuthedActiveSStoreIdInboxConversationIdRoute;
  '/s/$storeId/inventory/$variantId': typeof AuthedActiveSStoreIdInventoryVariantIdRoute;
  '/s/$storeId/orders/$orderId': typeof AuthedActiveSStoreIdOrdersOrderIdRoute;
  '/s/$storeId/reports/analytics': typeof AuthedActiveSStoreIdReportsAnalyticsRoute;
  '/s/$storeId/reports/auctions': typeof AuthedActiveSStoreIdReportsAuctionsRoute;
  '/s/$storeId/reports/customers': typeof AuthedActiveSStoreIdReportsCustomersRoute;
  '/s/$storeId/reports/inventory': typeof AuthedActiveSStoreIdReportsInventoryRoute;
  '/s/$storeId/reports/payments': typeof AuthedActiveSStoreIdReportsPaymentsRoute;
  '/s/$storeId/reports/products': typeof AuthedActiveSStoreIdReportsProductsRoute;
  '/s/$storeId/reports/sales': typeof AuthedActiveSStoreIdReportsSalesRoute;
  '/s/$storeId/reports/support': typeof AuthedActiveSStoreIdReportsSupportRoute;
  '/s/$storeId/returns/$returnId': typeof AuthedActiveSStoreIdReturnsReturnIdRoute;
  '/s/$storeId/settings/analytics': typeof AuthedActiveSStoreIdSettingsAnalyticsRoute;
  '/s/$storeId/settings/api-keys': typeof AuthedActiveSStoreIdSettingsApiKeysRoute;
  '/s/$storeId/settings/chat': typeof AuthedActiveSStoreIdSettingsChatRoute;
  '/s/$storeId/settings/feeds': typeof AuthedActiveSStoreIdSettingsFeedsRoute;
  '/s/$storeId/settings/imports-exports': typeof AuthedActiveSStoreIdSettingsImportsExportsRoute;
  '/s/$storeId/settings/locations': typeof AuthedActiveSStoreIdSettingsLocationsRoute;
  '/s/$storeId/settings/markets': typeof AuthedActiveSStoreIdSettingsMarketsRoute;
  '/s/$storeId/settings/notifications': typeof AuthedActiveSStoreIdSettingsNotificationsRoute;
  '/s/$storeId/settings/payment-methods': typeof AuthedActiveSStoreIdSettingsPaymentMethodsRoute;
  '/s/$storeId/settings/recovery': typeof AuthedActiveSStoreIdSettingsRecoveryRoute;
  '/s/$storeId/settings/returns': typeof AuthedActiveSStoreIdSettingsReturnsRoute;
  '/s/$storeId/settings/shipping': typeof AuthedActiveSStoreIdSettingsShippingRoute;
  '/s/$storeId/settings/tax': typeof AuthedActiveSStoreIdSettingsTaxRoute;
  '/stores/$storeId/inbox/$conversationId': typeof AuthedActiveStoresStoreIdInboxConversationIdRoute;
  '/org/catalog-setup/attributes': typeof AuthedActiveOrgCatalogSetupAttributesIndexRoute;
  '/org/catalog-setup/product-types': typeof AuthedActiveOrgCatalogSetupProductTypesIndexRoute;
  '/org/catalog-setup/size-sets': typeof AuthedActiveOrgCatalogSetupSizeSetsIndexRoute;
  '/org/catalog-setup/sku-rules': typeof AuthedActiveOrgCatalogSetupSkuRulesIndexRoute;
  '/org/shared-blocks/new': typeof AuthedActiveOrgSharedBlocksNewIndexRoute;
  '/s/$storeId/abandoned-checkouts': typeof AuthedActiveSStoreIdAbandonedCheckoutsIndexRoute;
  '/s/$storeId/auctions': typeof AuthedActiveSStoreIdAuctionsIndexRoute;
  '/s/$storeId/catalog': typeof AuthedActiveSStoreIdCatalogIndexRoute;
  '/s/$storeId/collections': typeof AuthedActiveSStoreIdCollectionsIndexRoute;
  '/s/$storeId/content': typeof AuthedActiveSStoreIdContentIndexRoute;
  '/s/$storeId/customers': typeof AuthedActiveSStoreIdCustomersIndexRoute;
  '/s/$storeId/discounts': typeof AuthedActiveSStoreIdDiscountsIndexRoute;
  '/s/$storeId/draft-orders': typeof AuthedActiveSStoreIdDraftOrdersIndexRoute;
  '/s/$storeId/gift-cards': typeof AuthedActiveSStoreIdGiftCardsIndexRoute;
  '/s/$storeId/help': typeof AuthedActiveSStoreIdHelpIndexRoute;
  '/s/$storeId/inbox': typeof AuthedActiveSStoreIdInboxIndexRoute;
  '/s/$storeId/orders': typeof AuthedActiveSStoreIdOrdersIndexRoute;
  '/s/$storeId/reports': typeof AuthedActiveSStoreIdReportsIndexRoute;
  '/s/$storeId/returns': typeof AuthedActiveSStoreIdReturnsIndexRoute;
  '/s/$storeId/settings': typeof AuthedActiveSStoreIdSettingsIndexRoute;
  '/s/$storeId/social': typeof AuthedActiveSStoreIdSocialIndexRoute;
  '/org/products/$productId/variants/$variantId': typeof AuthedActiveOrgProductsProductIdVariantsVariantIdRoute;
  '/s/$storeId/auctions/sales/$saleId': typeof AuthedActiveSStoreIdAuctionsSalesSaleIdRoute;
  '/s/$storeId/content/blocks/$blockId': typeof AuthedActiveSStoreIdContentBlocksBlockIdRoute;
  '/s/$storeId/content/blog/$postId': typeof AuthedActiveSStoreIdContentBlogPostIdRoute;
  '/s/$storeId/content/blog/categories': typeof AuthedActiveSStoreIdContentBlogCategoriesRoute;
  '/s/$storeId/content/blog/new': typeof AuthedActiveSStoreIdContentBlogNewRoute;
  '/s/$storeId/content/menus/$menuId': typeof AuthedActiveSStoreIdContentMenusMenuIdRoute;
  '/s/$storeId/content/pages/$pageId': typeof AuthedActiveSStoreIdContentPagesPageIdRoute;
  '/s/$storeId/content/pages/new': typeof AuthedActiveSStoreIdContentPagesNewRoute;
  '/s/$storeId/content/sections/$sectionId': typeof AuthedActiveSStoreIdContentSectionsSectionIdRoute;
  '/s/$storeId/content/sections/new': typeof AuthedActiveSStoreIdContentSectionsNewRoute;
  '/s/$storeId/settings/policies/$policyId': typeof AuthedActiveSStoreIdSettingsPoliciesPolicyIdRoute;
  '/s/$storeId/settings/policies/new': typeof AuthedActiveSStoreIdSettingsPoliciesNewRoute;
  '/s/$storeId/settings/qc-checklists/$checklistId': typeof AuthedActiveSStoreIdSettingsQcChecklistsChecklistIdRoute;
  '/s/$storeId/settings/qc-checklists/new': typeof AuthedActiveSStoreIdSettingsQcChecklistsNewRoute;
  '/s/$storeId/settings/webhooks/$endpointId': typeof AuthedActiveSStoreIdSettingsWebhooksEndpointIdRoute;
  '/s/$storeId/settings/workflows/$templateId': typeof AuthedActiveSStoreIdSettingsWorkflowsTemplateIdRoute;
  '/s/$storeId/settings/workflows/new': typeof AuthedActiveSStoreIdSettingsWorkflowsNewRoute;
  '/s/$storeId/social/pinterest/analytics': typeof AuthedActiveSStoreIdSocialPinterestAnalyticsRoute;
  '/s/$storeId/social/pinterest/connection': typeof AuthedActiveSStoreIdSocialPinterestConnectionRoute;
  '/s/$storeId/social/pinterest/create': typeof AuthedActiveSStoreIdSocialPinterestCreateRoute;
  '/s/$storeId/social/pinterest/settings': typeof AuthedActiveSStoreIdSocialPinterestSettingsRoute;
  '/s/$storeId/auctions/sales': typeof AuthedActiveSStoreIdAuctionsSalesIndexRoute;
  '/s/$storeId/content/blocks': typeof AuthedActiveSStoreIdContentBlocksIndexRoute;
  '/s/$storeId/content/blog': typeof AuthedActiveSStoreIdContentBlogIndexRoute;
  '/s/$storeId/content/menus': typeof AuthedActiveSStoreIdContentMenusIndexRoute;
  '/s/$storeId/content/pages': typeof AuthedActiveSStoreIdContentPagesIndexRoute;
  '/s/$storeId/content/sections': typeof AuthedActiveSStoreIdContentSectionsIndexRoute;
  '/s/$storeId/settings/policies': typeof AuthedActiveSStoreIdSettingsPoliciesIndexRoute;
  '/s/$storeId/settings/qc-checklists': typeof AuthedActiveSStoreIdSettingsQcChecklistsIndexRoute;
  '/s/$storeId/settings/webhooks': typeof AuthedActiveSStoreIdSettingsWebhooksIndexRoute;
  '/s/$storeId/settings/workflows': typeof AuthedActiveSStoreIdSettingsWorkflowsIndexRoute;
  '/s/$storeId/social/pinterest': typeof AuthedActiveSStoreIdSocialPinterestIndexRoute;
  '/s/$storeId/catalog/$storeProductId/variants/$variantId': typeof AuthedActiveSStoreIdCatalogStoreProductIdVariantsVariantIdRoute;
  '/s/$storeId/content/blocks/new/$kind': typeof AuthedActiveSStoreIdContentBlocksNewKindRoute;
  '/s/$storeId/settings/payments/stripe/callback': typeof AuthedActiveSStoreIdSettingsPaymentsStripeCallbackRoute;
  '/s/$storeId/social/pinterest/posts/$postId': typeof AuthedActiveSStoreIdSocialPinterestPostsPostIdRoute;
  '/s/$storeId/content/blocks/new': typeof AuthedActiveSStoreIdContentBlocksNewIndexRoute;
  '/s/$storeId/social/pinterest/posts': typeof AuthedActiveSStoreIdSocialPinterestPostsIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/_authed': typeof AuthedRouteWithChildren;
  '/(public)/accept-invite': typeof publicAcceptInviteRoute;
  '/(public)/confirm-email': typeof publicConfirmEmailRoute;
  '/(public)/forgot-password': typeof publicForgotPasswordRoute;
  '/(public)/login': typeof publicLoginRoute;
  '/(public)/magic-link': typeof publicMagicLinkRoute;
  '/(public)/reset-password': typeof publicResetPasswordRoute;
  '/(public)/sign-in-link': typeof publicSignInLinkRoute;
  '/_authed/_active': typeof AuthedActiveRouteWithChildren;
  '/_authed/docs': typeof AuthedDocsRouteWithChildren;
  '/(public)/apply/confirm': typeof publicApplyConfirmRoute;
  '/_authed/_active/help': typeof AuthedActiveHelpRoute;
  '/_authed/docs/build': typeof AuthedDocsBuildRoute;
  '/_authed/docs/postman': typeof AuthedDocsPostmanRoute;
  '/(public)/apply/': typeof publicApplyIndexRoute;
  '/_authed/docs/': typeof AuthedDocsIndexRoute;
  '/(public)/auth/google/callback': typeof publicAuthGoogleCallbackRoute;
  '/_authed/_active/account/chat-profile': typeof AuthedActiveAccountChatProfileRoute;
  '/_authed/_active/account/notifications': typeof AuthedActiveAccountNotificationsRoute;
  '/_authed/_active/account/security': typeof AuthedActiveAccountSecurityRoute;
  '/_authed/_active/org/activity': typeof AuthedActiveOrgActivityRoute;
  '/_authed/_active/org/catalog-setup': typeof AuthedActiveOrgCatalogSetupRouteWithChildren;
  '/_authed/_active/org/customizations': typeof AuthedActiveOrgCustomizationsRoute;
  '/_authed/_active/org/inbox': typeof AuthedActiveOrgInboxRouteWithChildren;
  '/_authed/_active/org/media': typeof AuthedActiveOrgMediaRoute;
  '/_authed/_active/org/products': typeof AuthedActiveOrgProductsRouteWithChildren;
  '/_authed/_active/org/roles': typeof AuthedActiveOrgRolesRoute;
  '/_authed/_active/org/schedules': typeof AuthedActiveOrgSchedulesRouteWithChildren;
  '/_authed/_active/org/settings': typeof AuthedActiveOrgSettingsRoute;
  '/_authed/_active/org/shared-blocks': typeof AuthedActiveOrgSharedBlocksRouteWithChildren;
  '/_authed/_active/org/stone-pricing': typeof AuthedActiveOrgStonePricingRoute;
  '/_authed/_active/org/stores': typeof AuthedActiveOrgStoresRouteWithChildren;
  '/_authed/_active/org/team': typeof AuthedActiveOrgTeamRoute;
  '/_authed/_active/s/$storeId': typeof AuthedActiveSStoreIdRouteWithChildren;
  '/_authed/docs/guides/$slug': typeof AuthedDocsGuidesSlugRoute;
  '/_authed/_active/account/': typeof AuthedActiveAccountIndexRoute;
  '/_authed/_active/org/': typeof AuthedActiveOrgIndexRoute;
  '/_authed/docs/api/': typeof AuthedDocsApiIndexRoute;
  '/_authed/_active/org/catalog-setup/attributes': typeof AuthedActiveOrgCatalogSetupAttributesRouteWithChildren;
  '/_authed/_active/org/catalog-setup/customizations': typeof AuthedActiveOrgCatalogSetupCustomizationsRoute;
  '/_authed/_active/org/catalog-setup/product-types': typeof AuthedActiveOrgCatalogSetupProductTypesRouteWithChildren;
  '/_authed/_active/org/catalog-setup/size-sets': typeof AuthedActiveOrgCatalogSetupSizeSetsRouteWithChildren;
  '/_authed/_active/org/catalog-setup/sku-rules': typeof AuthedActiveOrgCatalogSetupSkuRulesRouteWithChildren;
  '/_authed/_active/org/products/$productId': typeof AuthedActiveOrgProductsProductIdRoute;
  '/_authed/_active/org/products/new': typeof AuthedActiveOrgProductsNewRoute;
  '/_authed/_active/org/schedules/$scheduleId': typeof AuthedActiveOrgSchedulesScheduleIdRoute;
  '/_authed/_active/org/schedules/new': typeof AuthedActiveOrgSchedulesNewRoute;
  '/_authed/_active/org/schedules/upcoming': typeof AuthedActiveOrgSchedulesUpcomingRoute;
  '/_authed/_active/org/shared-blocks/$blockId': typeof AuthedActiveOrgSharedBlocksBlockIdRoute;
  '/_authed/_active/org/shared-blocks/new': typeof AuthedActiveOrgSharedBlocksNewRouteWithChildren;
  '/_authed/_active/org/stores/$storeId': typeof AuthedActiveOrgStoresStoreIdRoute;
  '/_authed/_active/s/$storeId/abandoned-checkouts': typeof AuthedActiveSStoreIdAbandonedCheckoutsRouteWithChildren;
  '/_authed/_active/s/$storeId/appointments': typeof AuthedActiveSStoreIdAppointmentsRoute;
  '/_authed/_active/s/$storeId/auctions': typeof AuthedActiveSStoreIdAuctionsRouteWithChildren;
  '/_authed/_active/s/$storeId/catalog': typeof AuthedActiveSStoreIdCatalogRouteWithChildren;
  '/_authed/_active/s/$storeId/collections': typeof AuthedActiveSStoreIdCollectionsRouteWithChildren;
  '/_authed/_active/s/$storeId/content': typeof AuthedActiveSStoreIdContentRouteWithChildren;
  '/_authed/_active/s/$storeId/customers': typeof AuthedActiveSStoreIdCustomersRouteWithChildren;
  '/_authed/_active/s/$storeId/discounts': typeof AuthedActiveSStoreIdDiscountsRouteWithChildren;
  '/_authed/_active/s/$storeId/draft-orders': typeof AuthedActiveSStoreIdDraftOrdersRouteWithChildren;
  '/_authed/_active/s/$storeId/gift-cards': typeof AuthedActiveSStoreIdGiftCardsRouteWithChildren;
  '/_authed/_active/s/$storeId/help': typeof AuthedActiveSStoreIdHelpRouteWithChildren;
  '/_authed/_active/s/$storeId/inbox': typeof AuthedActiveSStoreIdInboxRouteWithChildren;
  '/_authed/_active/s/$storeId/inventory': typeof AuthedActiveSStoreIdInventoryRoute;
  '/_authed/_active/s/$storeId/orders': typeof AuthedActiveSStoreIdOrdersRouteWithChildren;
  '/_authed/_active/s/$storeId/privacy-requests': typeof AuthedActiveSStoreIdPrivacyRequestsRoute;
  '/_authed/_active/s/$storeId/production': typeof AuthedActiveSStoreIdProductionRoute;
  '/_authed/_active/s/$storeId/reports': typeof AuthedActiveSStoreIdReportsRouteWithChildren;
  '/_authed/_active/s/$storeId/returns': typeof AuthedActiveSStoreIdReturnsRouteWithChildren;
  '/_authed/_active/s/$storeId/settings': typeof AuthedActiveSStoreIdSettingsRouteWithChildren;
  '/_authed/_active/s/$storeId/social': typeof AuthedActiveSStoreIdSocialRouteWithChildren;
  '/_authed/docs/api/$tag/$operation': typeof AuthedDocsApiTagOperationRoute;
  '/_authed/_active/org/catalog-setup/': typeof AuthedActiveOrgCatalogSetupIndexRoute;
  '/_authed/_active/org/inbox/': typeof AuthedActiveOrgInboxIndexRoute;
  '/_authed/_active/org/products/': typeof AuthedActiveOrgProductsIndexRoute;
  '/_authed/_active/org/schedules/': typeof AuthedActiveOrgSchedulesIndexRoute;
  '/_authed/_active/org/shared-blocks/': typeof AuthedActiveOrgSharedBlocksIndexRoute;
  '/_authed/_active/org/stores/': typeof AuthedActiveOrgStoresIndexRoute;
  '/_authed/_active/s/$storeId/': typeof AuthedActiveSStoreIdIndexRoute;
  '/_authed/_active/org/catalog-setup/attributes/$attributeId': typeof AuthedActiveOrgCatalogSetupAttributesAttributeIdRoute;
  '/_authed/_active/org/catalog-setup/product-types/$productTypeId': typeof AuthedActiveOrgCatalogSetupProductTypesProductTypeIdRoute;
  '/_authed/_active/org/catalog-setup/product-types/new': typeof AuthedActiveOrgCatalogSetupProductTypesNewRoute;
  '/_authed/_active/org/catalog-setup/size-sets/$sizeSetId': typeof AuthedActiveOrgCatalogSetupSizeSetsSizeSetIdRoute;
  '/_authed/_active/org/catalog-setup/size-sets/new': typeof AuthedActiveOrgCatalogSetupSizeSetsNewRoute;
  '/_authed/_active/org/catalog-setup/sku-rules/$ruleId': typeof AuthedActiveOrgCatalogSetupSkuRulesRuleIdRoute;
  '/_authed/_active/org/catalog-setup/sku-rules/new': typeof AuthedActiveOrgCatalogSetupSkuRulesNewRoute;
  '/_authed/_active/org/inbox/$storeId/$conversationId': typeof AuthedActiveOrgInboxStoreIdConversationIdRoute;
  '/_authed/_active/org/shared-blocks/new/$kind': typeof AuthedActiveOrgSharedBlocksNewKindRoute;
  '/_authed/_active/s/$storeId/abandoned-checkouts/$checkoutId': typeof AuthedActiveSStoreIdAbandonedCheckoutsCheckoutIdRoute;
  '/_authed/_active/s/$storeId/auctions/$auctionId': typeof AuthedActiveSStoreIdAuctionsAuctionIdRoute;
  '/_authed/_active/s/$storeId/auctions/bidders': typeof AuthedActiveSStoreIdAuctionsBiddersRoute;
  '/_authed/_active/s/$storeId/auctions/questions': typeof AuthedActiveSStoreIdAuctionsQuestionsRoute;
  '/_authed/_active/s/$storeId/catalog/$storeProductId': typeof AuthedActiveSStoreIdCatalogStoreProductIdRoute;
  '/_authed/_active/s/$storeId/collections/$collectionId': typeof AuthedActiveSStoreIdCollectionsCollectionIdRoute;
  '/_authed/_active/s/$storeId/collections/new': typeof AuthedActiveSStoreIdCollectionsNewRoute;
  '/_authed/_active/s/$storeId/content/blocks': typeof AuthedActiveSStoreIdContentBlocksRouteWithChildren;
  '/_authed/_active/s/$storeId/content/blog': typeof AuthedActiveSStoreIdContentBlogRouteWithChildren;
  '/_authed/_active/s/$storeId/content/menus': typeof AuthedActiveSStoreIdContentMenusRouteWithChildren;
  '/_authed/_active/s/$storeId/content/pages': typeof AuthedActiveSStoreIdContentPagesRouteWithChildren;
  '/_authed/_active/s/$storeId/content/redirects': typeof AuthedActiveSStoreIdContentRedirectsRoute;
  '/_authed/_active/s/$storeId/content/sections': typeof AuthedActiveSStoreIdContentSectionsRouteWithChildren;
  '/_authed/_active/s/$storeId/content/seo': typeof AuthedActiveSStoreIdContentSeoRoute;
  '/_authed/_active/s/$storeId/customers/$customerId': typeof AuthedActiveSStoreIdCustomersCustomerIdRoute;
  '/_authed/_active/s/$storeId/discounts/$discountId': typeof AuthedActiveSStoreIdDiscountsDiscountIdRoute;
  '/_authed/_active/s/$storeId/discounts/new': typeof AuthedActiveSStoreIdDiscountsNewRoute;
  '/_authed/_active/s/$storeId/draft-orders/$draftId': typeof AuthedActiveSStoreIdDraftOrdersDraftIdRoute;
  '/_authed/_active/s/$storeId/draft-orders/new': typeof AuthedActiveSStoreIdDraftOrdersNewRoute;
  '/_authed/_active/s/$storeId/gift-cards/$giftCardId': typeof AuthedActiveSStoreIdGiftCardsGiftCardIdRoute;
  '/_authed/_active/s/$storeId/help/$articleId': typeof AuthedActiveSStoreIdHelpArticleIdRoute;
  '/_authed/_active/s/$storeId/help/categories': typeof AuthedActiveSStoreIdHelpCategoriesRoute;
  '/_authed/_active/s/$storeId/help/new': typeof AuthedActiveSStoreIdHelpNewRoute;
  '/_authed/_active/s/$storeId/inbox/$conversationId': typeof AuthedActiveSStoreIdInboxConversationIdRoute;
  '/_authed/_active/s/$storeId/inventory_/$variantId': typeof AuthedActiveSStoreIdInventoryVariantIdRoute;
  '/_authed/_active/s/$storeId/orders/$orderId': typeof AuthedActiveSStoreIdOrdersOrderIdRoute;
  '/_authed/_active/s/$storeId/reports/analytics': typeof AuthedActiveSStoreIdReportsAnalyticsRoute;
  '/_authed/_active/s/$storeId/reports/auctions': typeof AuthedActiveSStoreIdReportsAuctionsRoute;
  '/_authed/_active/s/$storeId/reports/customers': typeof AuthedActiveSStoreIdReportsCustomersRoute;
  '/_authed/_active/s/$storeId/reports/inventory': typeof AuthedActiveSStoreIdReportsInventoryRoute;
  '/_authed/_active/s/$storeId/reports/payments': typeof AuthedActiveSStoreIdReportsPaymentsRoute;
  '/_authed/_active/s/$storeId/reports/products': typeof AuthedActiveSStoreIdReportsProductsRoute;
  '/_authed/_active/s/$storeId/reports/sales': typeof AuthedActiveSStoreIdReportsSalesRoute;
  '/_authed/_active/s/$storeId/reports/support': typeof AuthedActiveSStoreIdReportsSupportRoute;
  '/_authed/_active/s/$storeId/returns/$returnId': typeof AuthedActiveSStoreIdReturnsReturnIdRoute;
  '/_authed/_active/s/$storeId/settings/analytics': typeof AuthedActiveSStoreIdSettingsAnalyticsRoute;
  '/_authed/_active/s/$storeId/settings/api-keys': typeof AuthedActiveSStoreIdSettingsApiKeysRoute;
  '/_authed/_active/s/$storeId/settings/chat': typeof AuthedActiveSStoreIdSettingsChatRoute;
  '/_authed/_active/s/$storeId/settings/feeds': typeof AuthedActiveSStoreIdSettingsFeedsRoute;
  '/_authed/_active/s/$storeId/settings/imports-exports': typeof AuthedActiveSStoreIdSettingsImportsExportsRoute;
  '/_authed/_active/s/$storeId/settings/locations': typeof AuthedActiveSStoreIdSettingsLocationsRoute;
  '/_authed/_active/s/$storeId/settings/markets': typeof AuthedActiveSStoreIdSettingsMarketsRoute;
  '/_authed/_active/s/$storeId/settings/notifications': typeof AuthedActiveSStoreIdSettingsNotificationsRoute;
  '/_authed/_active/s/$storeId/settings/payment-methods': typeof AuthedActiveSStoreIdSettingsPaymentMethodsRoute;
  '/_authed/_active/s/$storeId/settings/policies': typeof AuthedActiveSStoreIdSettingsPoliciesRouteWithChildren;
  '/_authed/_active/s/$storeId/settings/qc-checklists': typeof AuthedActiveSStoreIdSettingsQcChecklistsRouteWithChildren;
  '/_authed/_active/s/$storeId/settings/recovery': typeof AuthedActiveSStoreIdSettingsRecoveryRoute;
  '/_authed/_active/s/$storeId/settings/returns': typeof AuthedActiveSStoreIdSettingsReturnsRoute;
  '/_authed/_active/s/$storeId/settings/shipping': typeof AuthedActiveSStoreIdSettingsShippingRoute;
  '/_authed/_active/s/$storeId/settings/tax': typeof AuthedActiveSStoreIdSettingsTaxRoute;
  '/_authed/_active/s/$storeId/settings/webhooks': typeof AuthedActiveSStoreIdSettingsWebhooksRouteWithChildren;
  '/_authed/_active/s/$storeId/settings/workflows': typeof AuthedActiveSStoreIdSettingsWorkflowsRouteWithChildren;
  '/_authed/_active/s/$storeId/social/pinterest': typeof AuthedActiveSStoreIdSocialPinterestRouteWithChildren;
  '/_authed/_active/stores/$storeId/inbox/$conversationId': typeof AuthedActiveStoresStoreIdInboxConversationIdRoute;
  '/_authed/_active/org/catalog-setup/attributes/': typeof AuthedActiveOrgCatalogSetupAttributesIndexRoute;
  '/_authed/_active/org/catalog-setup/product-types/': typeof AuthedActiveOrgCatalogSetupProductTypesIndexRoute;
  '/_authed/_active/org/catalog-setup/size-sets/': typeof AuthedActiveOrgCatalogSetupSizeSetsIndexRoute;
  '/_authed/_active/org/catalog-setup/sku-rules/': typeof AuthedActiveOrgCatalogSetupSkuRulesIndexRoute;
  '/_authed/_active/org/shared-blocks/new/': typeof AuthedActiveOrgSharedBlocksNewIndexRoute;
  '/_authed/_active/s/$storeId/abandoned-checkouts/': typeof AuthedActiveSStoreIdAbandonedCheckoutsIndexRoute;
  '/_authed/_active/s/$storeId/auctions/': typeof AuthedActiveSStoreIdAuctionsIndexRoute;
  '/_authed/_active/s/$storeId/catalog/': typeof AuthedActiveSStoreIdCatalogIndexRoute;
  '/_authed/_active/s/$storeId/collections/': typeof AuthedActiveSStoreIdCollectionsIndexRoute;
  '/_authed/_active/s/$storeId/content/': typeof AuthedActiveSStoreIdContentIndexRoute;
  '/_authed/_active/s/$storeId/customers/': typeof AuthedActiveSStoreIdCustomersIndexRoute;
  '/_authed/_active/s/$storeId/discounts/': typeof AuthedActiveSStoreIdDiscountsIndexRoute;
  '/_authed/_active/s/$storeId/draft-orders/': typeof AuthedActiveSStoreIdDraftOrdersIndexRoute;
  '/_authed/_active/s/$storeId/gift-cards/': typeof AuthedActiveSStoreIdGiftCardsIndexRoute;
  '/_authed/_active/s/$storeId/help/': typeof AuthedActiveSStoreIdHelpIndexRoute;
  '/_authed/_active/s/$storeId/inbox/': typeof AuthedActiveSStoreIdInboxIndexRoute;
  '/_authed/_active/s/$storeId/orders/': typeof AuthedActiveSStoreIdOrdersIndexRoute;
  '/_authed/_active/s/$storeId/reports/': typeof AuthedActiveSStoreIdReportsIndexRoute;
  '/_authed/_active/s/$storeId/returns/': typeof AuthedActiveSStoreIdReturnsIndexRoute;
  '/_authed/_active/s/$storeId/settings/': typeof AuthedActiveSStoreIdSettingsIndexRoute;
  '/_authed/_active/s/$storeId/social/': typeof AuthedActiveSStoreIdSocialIndexRoute;
  '/_authed/_active/org/products/$productId_/variants/$variantId': typeof AuthedActiveOrgProductsProductIdVariantsVariantIdRoute;
  '/_authed/_active/s/$storeId/auctions/sales/$saleId': typeof AuthedActiveSStoreIdAuctionsSalesSaleIdRoute;
  '/_authed/_active/s/$storeId/content/blocks/$blockId': typeof AuthedActiveSStoreIdContentBlocksBlockIdRoute;
  '/_authed/_active/s/$storeId/content/blocks/new': typeof AuthedActiveSStoreIdContentBlocksNewRouteWithChildren;
  '/_authed/_active/s/$storeId/content/blog/$postId': typeof AuthedActiveSStoreIdContentBlogPostIdRoute;
  '/_authed/_active/s/$storeId/content/blog/categories': typeof AuthedActiveSStoreIdContentBlogCategoriesRoute;
  '/_authed/_active/s/$storeId/content/blog/new': typeof AuthedActiveSStoreIdContentBlogNewRoute;
  '/_authed/_active/s/$storeId/content/menus/$menuId': typeof AuthedActiveSStoreIdContentMenusMenuIdRoute;
  '/_authed/_active/s/$storeId/content/pages/$pageId': typeof AuthedActiveSStoreIdContentPagesPageIdRoute;
  '/_authed/_active/s/$storeId/content/pages/new': typeof AuthedActiveSStoreIdContentPagesNewRoute;
  '/_authed/_active/s/$storeId/content/sections/$sectionId': typeof AuthedActiveSStoreIdContentSectionsSectionIdRoute;
  '/_authed/_active/s/$storeId/content/sections/new': typeof AuthedActiveSStoreIdContentSectionsNewRoute;
  '/_authed/_active/s/$storeId/settings/policies/$policyId': typeof AuthedActiveSStoreIdSettingsPoliciesPolicyIdRoute;
  '/_authed/_active/s/$storeId/settings/policies/new': typeof AuthedActiveSStoreIdSettingsPoliciesNewRoute;
  '/_authed/_active/s/$storeId/settings/qc-checklists/$checklistId': typeof AuthedActiveSStoreIdSettingsQcChecklistsChecklistIdRoute;
  '/_authed/_active/s/$storeId/settings/qc-checklists/new': typeof AuthedActiveSStoreIdSettingsQcChecklistsNewRoute;
  '/_authed/_active/s/$storeId/settings/webhooks/$endpointId': typeof AuthedActiveSStoreIdSettingsWebhooksEndpointIdRoute;
  '/_authed/_active/s/$storeId/settings/workflows/$templateId': typeof AuthedActiveSStoreIdSettingsWorkflowsTemplateIdRoute;
  '/_authed/_active/s/$storeId/settings/workflows/new': typeof AuthedActiveSStoreIdSettingsWorkflowsNewRoute;
  '/_authed/_active/s/$storeId/social/pinterest/analytics': typeof AuthedActiveSStoreIdSocialPinterestAnalyticsRoute;
  '/_authed/_active/s/$storeId/social/pinterest/connection': typeof AuthedActiveSStoreIdSocialPinterestConnectionRoute;
  '/_authed/_active/s/$storeId/social/pinterest/create': typeof AuthedActiveSStoreIdSocialPinterestCreateRoute;
  '/_authed/_active/s/$storeId/social/pinterest/posts': typeof AuthedActiveSStoreIdSocialPinterestPostsRouteWithChildren;
  '/_authed/_active/s/$storeId/social/pinterest/settings': typeof AuthedActiveSStoreIdSocialPinterestSettingsRoute;
  '/_authed/_active/s/$storeId/auctions/sales/': typeof AuthedActiveSStoreIdAuctionsSalesIndexRoute;
  '/_authed/_active/s/$storeId/content/blocks/': typeof AuthedActiveSStoreIdContentBlocksIndexRoute;
  '/_authed/_active/s/$storeId/content/blog/': typeof AuthedActiveSStoreIdContentBlogIndexRoute;
  '/_authed/_active/s/$storeId/content/menus/': typeof AuthedActiveSStoreIdContentMenusIndexRoute;
  '/_authed/_active/s/$storeId/content/pages/': typeof AuthedActiveSStoreIdContentPagesIndexRoute;
  '/_authed/_active/s/$storeId/content/sections/': typeof AuthedActiveSStoreIdContentSectionsIndexRoute;
  '/_authed/_active/s/$storeId/settings/policies/': typeof AuthedActiveSStoreIdSettingsPoliciesIndexRoute;
  '/_authed/_active/s/$storeId/settings/qc-checklists/': typeof AuthedActiveSStoreIdSettingsQcChecklistsIndexRoute;
  '/_authed/_active/s/$storeId/settings/webhooks/': typeof AuthedActiveSStoreIdSettingsWebhooksIndexRoute;
  '/_authed/_active/s/$storeId/settings/workflows/': typeof AuthedActiveSStoreIdSettingsWorkflowsIndexRoute;
  '/_authed/_active/s/$storeId/social/pinterest/': typeof AuthedActiveSStoreIdSocialPinterestIndexRoute;
  '/_authed/_active/s/$storeId/catalog/$storeProductId_/variants/$variantId': typeof AuthedActiveSStoreIdCatalogStoreProductIdVariantsVariantIdRoute;
  '/_authed/_active/s/$storeId/content/blocks/new/$kind': typeof AuthedActiveSStoreIdContentBlocksNewKindRoute;
  '/_authed/_active/s/$storeId/settings/payments/stripe/callback': typeof AuthedActiveSStoreIdSettingsPaymentsStripeCallbackRoute;
  '/_authed/_active/s/$storeId/social/pinterest/posts/$postId': typeof AuthedActiveSStoreIdSocialPinterestPostsPostIdRoute;
  '/_authed/_active/s/$storeId/content/blocks/new/': typeof AuthedActiveSStoreIdContentBlocksNewIndexRoute;
  '/_authed/_active/s/$storeId/social/pinterest/posts/': typeof AuthedActiveSStoreIdSocialPinterestPostsIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/accept-invite'
    | '/confirm-email'
    | '/forgot-password'
    | '/login'
    | '/magic-link'
    | '/reset-password'
    | '/sign-in-link'
    | '/docs'
    | '/apply/confirm'
    | '/help'
    | '/docs/build'
    | '/docs/postman'
    | '/apply/'
    | '/docs/'
    | '/auth/google/callback'
    | '/account/chat-profile'
    | '/account/notifications'
    | '/account/security'
    | '/org/activity'
    | '/org/catalog-setup'
    | '/org/customizations'
    | '/org/inbox'
    | '/org/media'
    | '/org/products'
    | '/org/roles'
    | '/org/schedules'
    | '/org/settings'
    | '/org/shared-blocks'
    | '/org/stone-pricing'
    | '/org/stores'
    | '/org/team'
    | '/s/$storeId'
    | '/docs/guides/$slug'
    | '/account/'
    | '/org/'
    | '/docs/api/'
    | '/org/catalog-setup/attributes'
    | '/org/catalog-setup/customizations'
    | '/org/catalog-setup/product-types'
    | '/org/catalog-setup/size-sets'
    | '/org/catalog-setup/sku-rules'
    | '/org/products/$productId'
    | '/org/products/new'
    | '/org/schedules/$scheduleId'
    | '/org/schedules/new'
    | '/org/schedules/upcoming'
    | '/org/shared-blocks/$blockId'
    | '/org/shared-blocks/new'
    | '/org/stores/$storeId'
    | '/s/$storeId/abandoned-checkouts'
    | '/s/$storeId/appointments'
    | '/s/$storeId/auctions'
    | '/s/$storeId/catalog'
    | '/s/$storeId/collections'
    | '/s/$storeId/content'
    | '/s/$storeId/customers'
    | '/s/$storeId/discounts'
    | '/s/$storeId/draft-orders'
    | '/s/$storeId/gift-cards'
    | '/s/$storeId/help'
    | '/s/$storeId/inbox'
    | '/s/$storeId/inventory'
    | '/s/$storeId/orders'
    | '/s/$storeId/privacy-requests'
    | '/s/$storeId/production'
    | '/s/$storeId/reports'
    | '/s/$storeId/returns'
    | '/s/$storeId/settings'
    | '/s/$storeId/social'
    | '/docs/api/$tag/$operation'
    | '/org/catalog-setup/'
    | '/org/inbox/'
    | '/org/products/'
    | '/org/schedules/'
    | '/org/shared-blocks/'
    | '/org/stores/'
    | '/s/$storeId/'
    | '/org/catalog-setup/attributes/$attributeId'
    | '/org/catalog-setup/product-types/$productTypeId'
    | '/org/catalog-setup/product-types/new'
    | '/org/catalog-setup/size-sets/$sizeSetId'
    | '/org/catalog-setup/size-sets/new'
    | '/org/catalog-setup/sku-rules/$ruleId'
    | '/org/catalog-setup/sku-rules/new'
    | '/org/inbox/$storeId/$conversationId'
    | '/org/shared-blocks/new/$kind'
    | '/s/$storeId/abandoned-checkouts/$checkoutId'
    | '/s/$storeId/auctions/$auctionId'
    | '/s/$storeId/auctions/bidders'
    | '/s/$storeId/auctions/questions'
    | '/s/$storeId/catalog/$storeProductId'
    | '/s/$storeId/collections/$collectionId'
    | '/s/$storeId/collections/new'
    | '/s/$storeId/content/blocks'
    | '/s/$storeId/content/blog'
    | '/s/$storeId/content/menus'
    | '/s/$storeId/content/pages'
    | '/s/$storeId/content/redirects'
    | '/s/$storeId/content/sections'
    | '/s/$storeId/content/seo'
    | '/s/$storeId/customers/$customerId'
    | '/s/$storeId/discounts/$discountId'
    | '/s/$storeId/discounts/new'
    | '/s/$storeId/draft-orders/$draftId'
    | '/s/$storeId/draft-orders/new'
    | '/s/$storeId/gift-cards/$giftCardId'
    | '/s/$storeId/help/$articleId'
    | '/s/$storeId/help/categories'
    | '/s/$storeId/help/new'
    | '/s/$storeId/inbox/$conversationId'
    | '/s/$storeId/inventory/$variantId'
    | '/s/$storeId/orders/$orderId'
    | '/s/$storeId/reports/analytics'
    | '/s/$storeId/reports/auctions'
    | '/s/$storeId/reports/customers'
    | '/s/$storeId/reports/inventory'
    | '/s/$storeId/reports/payments'
    | '/s/$storeId/reports/products'
    | '/s/$storeId/reports/sales'
    | '/s/$storeId/reports/support'
    | '/s/$storeId/returns/$returnId'
    | '/s/$storeId/settings/analytics'
    | '/s/$storeId/settings/api-keys'
    | '/s/$storeId/settings/chat'
    | '/s/$storeId/settings/feeds'
    | '/s/$storeId/settings/imports-exports'
    | '/s/$storeId/settings/locations'
    | '/s/$storeId/settings/markets'
    | '/s/$storeId/settings/notifications'
    | '/s/$storeId/settings/payment-methods'
    | '/s/$storeId/settings/policies'
    | '/s/$storeId/settings/qc-checklists'
    | '/s/$storeId/settings/recovery'
    | '/s/$storeId/settings/returns'
    | '/s/$storeId/settings/shipping'
    | '/s/$storeId/settings/tax'
    | '/s/$storeId/settings/webhooks'
    | '/s/$storeId/settings/workflows'
    | '/s/$storeId/social/pinterest'
    | '/stores/$storeId/inbox/$conversationId'
    | '/org/catalog-setup/attributes/'
    | '/org/catalog-setup/product-types/'
    | '/org/catalog-setup/size-sets/'
    | '/org/catalog-setup/sku-rules/'
    | '/org/shared-blocks/new/'
    | '/s/$storeId/abandoned-checkouts/'
    | '/s/$storeId/auctions/'
    | '/s/$storeId/catalog/'
    | '/s/$storeId/collections/'
    | '/s/$storeId/content/'
    | '/s/$storeId/customers/'
    | '/s/$storeId/discounts/'
    | '/s/$storeId/draft-orders/'
    | '/s/$storeId/gift-cards/'
    | '/s/$storeId/help/'
    | '/s/$storeId/inbox/'
    | '/s/$storeId/orders/'
    | '/s/$storeId/reports/'
    | '/s/$storeId/returns/'
    | '/s/$storeId/settings/'
    | '/s/$storeId/social/'
    | '/org/products/$productId/variants/$variantId'
    | '/s/$storeId/auctions/sales/$saleId'
    | '/s/$storeId/content/blocks/$blockId'
    | '/s/$storeId/content/blocks/new'
    | '/s/$storeId/content/blog/$postId'
    | '/s/$storeId/content/blog/categories'
    | '/s/$storeId/content/blog/new'
    | '/s/$storeId/content/menus/$menuId'
    | '/s/$storeId/content/pages/$pageId'
    | '/s/$storeId/content/pages/new'
    | '/s/$storeId/content/sections/$sectionId'
    | '/s/$storeId/content/sections/new'
    | '/s/$storeId/settings/policies/$policyId'
    | '/s/$storeId/settings/policies/new'
    | '/s/$storeId/settings/qc-checklists/$checklistId'
    | '/s/$storeId/settings/qc-checklists/new'
    | '/s/$storeId/settings/webhooks/$endpointId'
    | '/s/$storeId/settings/workflows/$templateId'
    | '/s/$storeId/settings/workflows/new'
    | '/s/$storeId/social/pinterest/analytics'
    | '/s/$storeId/social/pinterest/connection'
    | '/s/$storeId/social/pinterest/create'
    | '/s/$storeId/social/pinterest/posts'
    | '/s/$storeId/social/pinterest/settings'
    | '/s/$storeId/auctions/sales/'
    | '/s/$storeId/content/blocks/'
    | '/s/$storeId/content/blog/'
    | '/s/$storeId/content/menus/'
    | '/s/$storeId/content/pages/'
    | '/s/$storeId/content/sections/'
    | '/s/$storeId/settings/policies/'
    | '/s/$storeId/settings/qc-checklists/'
    | '/s/$storeId/settings/webhooks/'
    | '/s/$storeId/settings/workflows/'
    | '/s/$storeId/social/pinterest/'
    | '/s/$storeId/catalog/$storeProductId/variants/$variantId'
    | '/s/$storeId/content/blocks/new/$kind'
    | '/s/$storeId/settings/payments/stripe/callback'
    | '/s/$storeId/social/pinterest/posts/$postId'
    | '/s/$storeId/content/blocks/new/'
    | '/s/$storeId/social/pinterest/posts/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/accept-invite'
    | '/confirm-email'
    | '/forgot-password'
    | '/login'
    | '/magic-link'
    | '/reset-password'
    | '/sign-in-link'
    | '/apply/confirm'
    | '/help'
    | '/docs/build'
    | '/docs/postman'
    | '/apply'
    | '/docs'
    | '/auth/google/callback'
    | '/account/chat-profile'
    | '/account/notifications'
    | '/account/security'
    | '/org/activity'
    | '/org/customizations'
    | '/org/media'
    | '/org/roles'
    | '/org/settings'
    | '/org/stone-pricing'
    | '/org/team'
    | '/docs/guides/$slug'
    | '/account'
    | '/org'
    | '/docs/api'
    | '/org/catalog-setup/customizations'
    | '/org/products/$productId'
    | '/org/products/new'
    | '/org/schedules/$scheduleId'
    | '/org/schedules/new'
    | '/org/schedules/upcoming'
    | '/org/shared-blocks/$blockId'
    | '/org/stores/$storeId'
    | '/s/$storeId/appointments'
    | '/s/$storeId/inventory'
    | '/s/$storeId/privacy-requests'
    | '/s/$storeId/production'
    | '/docs/api/$tag/$operation'
    | '/org/catalog-setup'
    | '/org/inbox'
    | '/org/products'
    | '/org/schedules'
    | '/org/shared-blocks'
    | '/org/stores'
    | '/s/$storeId'
    | '/org/catalog-setup/attributes/$attributeId'
    | '/org/catalog-setup/product-types/$productTypeId'
    | '/org/catalog-setup/product-types/new'
    | '/org/catalog-setup/size-sets/$sizeSetId'
    | '/org/catalog-setup/size-sets/new'
    | '/org/catalog-setup/sku-rules/$ruleId'
    | '/org/catalog-setup/sku-rules/new'
    | '/org/inbox/$storeId/$conversationId'
    | '/org/shared-blocks/new/$kind'
    | '/s/$storeId/abandoned-checkouts/$checkoutId'
    | '/s/$storeId/auctions/$auctionId'
    | '/s/$storeId/auctions/bidders'
    | '/s/$storeId/auctions/questions'
    | '/s/$storeId/catalog/$storeProductId'
    | '/s/$storeId/collections/$collectionId'
    | '/s/$storeId/collections/new'
    | '/s/$storeId/content/redirects'
    | '/s/$storeId/content/seo'
    | '/s/$storeId/customers/$customerId'
    | '/s/$storeId/discounts/$discountId'
    | '/s/$storeId/discounts/new'
    | '/s/$storeId/draft-orders/$draftId'
    | '/s/$storeId/draft-orders/new'
    | '/s/$storeId/gift-cards/$giftCardId'
    | '/s/$storeId/help/$articleId'
    | '/s/$storeId/help/categories'
    | '/s/$storeId/help/new'
    | '/s/$storeId/inbox/$conversationId'
    | '/s/$storeId/inventory/$variantId'
    | '/s/$storeId/orders/$orderId'
    | '/s/$storeId/reports/analytics'
    | '/s/$storeId/reports/auctions'
    | '/s/$storeId/reports/customers'
    | '/s/$storeId/reports/inventory'
    | '/s/$storeId/reports/payments'
    | '/s/$storeId/reports/products'
    | '/s/$storeId/reports/sales'
    | '/s/$storeId/reports/support'
    | '/s/$storeId/returns/$returnId'
    | '/s/$storeId/settings/analytics'
    | '/s/$storeId/settings/api-keys'
    | '/s/$storeId/settings/chat'
    | '/s/$storeId/settings/feeds'
    | '/s/$storeId/settings/imports-exports'
    | '/s/$storeId/settings/locations'
    | '/s/$storeId/settings/markets'
    | '/s/$storeId/settings/notifications'
    | '/s/$storeId/settings/payment-methods'
    | '/s/$storeId/settings/recovery'
    | '/s/$storeId/settings/returns'
    | '/s/$storeId/settings/shipping'
    | '/s/$storeId/settings/tax'
    | '/stores/$storeId/inbox/$conversationId'
    | '/org/catalog-setup/attributes'
    | '/org/catalog-setup/product-types'
    | '/org/catalog-setup/size-sets'
    | '/org/catalog-setup/sku-rules'
    | '/org/shared-blocks/new'
    | '/s/$storeId/abandoned-checkouts'
    | '/s/$storeId/auctions'
    | '/s/$storeId/catalog'
    | '/s/$storeId/collections'
    | '/s/$storeId/content'
    | '/s/$storeId/customers'
    | '/s/$storeId/discounts'
    | '/s/$storeId/draft-orders'
    | '/s/$storeId/gift-cards'
    | '/s/$storeId/help'
    | '/s/$storeId/inbox'
    | '/s/$storeId/orders'
    | '/s/$storeId/reports'
    | '/s/$storeId/returns'
    | '/s/$storeId/settings'
    | '/s/$storeId/social'
    | '/org/products/$productId/variants/$variantId'
    | '/s/$storeId/auctions/sales/$saleId'
    | '/s/$storeId/content/blocks/$blockId'
    | '/s/$storeId/content/blog/$postId'
    | '/s/$storeId/content/blog/categories'
    | '/s/$storeId/content/blog/new'
    | '/s/$storeId/content/menus/$menuId'
    | '/s/$storeId/content/pages/$pageId'
    | '/s/$storeId/content/pages/new'
    | '/s/$storeId/content/sections/$sectionId'
    | '/s/$storeId/content/sections/new'
    | '/s/$storeId/settings/policies/$policyId'
    | '/s/$storeId/settings/policies/new'
    | '/s/$storeId/settings/qc-checklists/$checklistId'
    | '/s/$storeId/settings/qc-checklists/new'
    | '/s/$storeId/settings/webhooks/$endpointId'
    | '/s/$storeId/settings/workflows/$templateId'
    | '/s/$storeId/settings/workflows/new'
    | '/s/$storeId/social/pinterest/analytics'
    | '/s/$storeId/social/pinterest/connection'
    | '/s/$storeId/social/pinterest/create'
    | '/s/$storeId/social/pinterest/settings'
    | '/s/$storeId/auctions/sales'
    | '/s/$storeId/content/blocks'
    | '/s/$storeId/content/blog'
    | '/s/$storeId/content/menus'
    | '/s/$storeId/content/pages'
    | '/s/$storeId/content/sections'
    | '/s/$storeId/settings/policies'
    | '/s/$storeId/settings/qc-checklists'
    | '/s/$storeId/settings/webhooks'
    | '/s/$storeId/settings/workflows'
    | '/s/$storeId/social/pinterest'
    | '/s/$storeId/catalog/$storeProductId/variants/$variantId'
    | '/s/$storeId/content/blocks/new/$kind'
    | '/s/$storeId/settings/payments/stripe/callback'
    | '/s/$storeId/social/pinterest/posts/$postId'
    | '/s/$storeId/content/blocks/new'
    | '/s/$storeId/social/pinterest/posts';
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/(public)/accept-invite'
    | '/(public)/confirm-email'
    | '/(public)/forgot-password'
    | '/(public)/login'
    | '/(public)/magic-link'
    | '/(public)/reset-password'
    | '/(public)/sign-in-link'
    | '/_authed/_active'
    | '/_authed/docs'
    | '/(public)/apply/confirm'
    | '/_authed/_active/help'
    | '/_authed/docs/build'
    | '/_authed/docs/postman'
    | '/(public)/apply/'
    | '/_authed/docs/'
    | '/(public)/auth/google/callback'
    | '/_authed/_active/account/chat-profile'
    | '/_authed/_active/account/notifications'
    | '/_authed/_active/account/security'
    | '/_authed/_active/org/activity'
    | '/_authed/_active/org/catalog-setup'
    | '/_authed/_active/org/customizations'
    | '/_authed/_active/org/inbox'
    | '/_authed/_active/org/media'
    | '/_authed/_active/org/products'
    | '/_authed/_active/org/roles'
    | '/_authed/_active/org/schedules'
    | '/_authed/_active/org/settings'
    | '/_authed/_active/org/shared-blocks'
    | '/_authed/_active/org/stone-pricing'
    | '/_authed/_active/org/stores'
    | '/_authed/_active/org/team'
    | '/_authed/_active/s/$storeId'
    | '/_authed/docs/guides/$slug'
    | '/_authed/_active/account/'
    | '/_authed/_active/org/'
    | '/_authed/docs/api/'
    | '/_authed/_active/org/catalog-setup/attributes'
    | '/_authed/_active/org/catalog-setup/customizations'
    | '/_authed/_active/org/catalog-setup/product-types'
    | '/_authed/_active/org/catalog-setup/size-sets'
    | '/_authed/_active/org/catalog-setup/sku-rules'
    | '/_authed/_active/org/products/$productId'
    | '/_authed/_active/org/products/new'
    | '/_authed/_active/org/schedules/$scheduleId'
    | '/_authed/_active/org/schedules/new'
    | '/_authed/_active/org/schedules/upcoming'
    | '/_authed/_active/org/shared-blocks/$blockId'
    | '/_authed/_active/org/shared-blocks/new'
    | '/_authed/_active/org/stores/$storeId'
    | '/_authed/_active/s/$storeId/abandoned-checkouts'
    | '/_authed/_active/s/$storeId/appointments'
    | '/_authed/_active/s/$storeId/auctions'
    | '/_authed/_active/s/$storeId/catalog'
    | '/_authed/_active/s/$storeId/collections'
    | '/_authed/_active/s/$storeId/content'
    | '/_authed/_active/s/$storeId/customers'
    | '/_authed/_active/s/$storeId/discounts'
    | '/_authed/_active/s/$storeId/draft-orders'
    | '/_authed/_active/s/$storeId/gift-cards'
    | '/_authed/_active/s/$storeId/help'
    | '/_authed/_active/s/$storeId/inbox'
    | '/_authed/_active/s/$storeId/inventory'
    | '/_authed/_active/s/$storeId/orders'
    | '/_authed/_active/s/$storeId/privacy-requests'
    | '/_authed/_active/s/$storeId/production'
    | '/_authed/_active/s/$storeId/reports'
    | '/_authed/_active/s/$storeId/returns'
    | '/_authed/_active/s/$storeId/settings'
    | '/_authed/_active/s/$storeId/social'
    | '/_authed/docs/api/$tag/$operation'
    | '/_authed/_active/org/catalog-setup/'
    | '/_authed/_active/org/inbox/'
    | '/_authed/_active/org/products/'
    | '/_authed/_active/org/schedules/'
    | '/_authed/_active/org/shared-blocks/'
    | '/_authed/_active/org/stores/'
    | '/_authed/_active/s/$storeId/'
    | '/_authed/_active/org/catalog-setup/attributes/$attributeId'
    | '/_authed/_active/org/catalog-setup/product-types/$productTypeId'
    | '/_authed/_active/org/catalog-setup/product-types/new'
    | '/_authed/_active/org/catalog-setup/size-sets/$sizeSetId'
    | '/_authed/_active/org/catalog-setup/size-sets/new'
    | '/_authed/_active/org/catalog-setup/sku-rules/$ruleId'
    | '/_authed/_active/org/catalog-setup/sku-rules/new'
    | '/_authed/_active/org/inbox/$storeId/$conversationId'
    | '/_authed/_active/org/shared-blocks/new/$kind'
    | '/_authed/_active/s/$storeId/abandoned-checkouts/$checkoutId'
    | '/_authed/_active/s/$storeId/auctions/$auctionId'
    | '/_authed/_active/s/$storeId/auctions/bidders'
    | '/_authed/_active/s/$storeId/auctions/questions'
    | '/_authed/_active/s/$storeId/catalog/$storeProductId'
    | '/_authed/_active/s/$storeId/collections/$collectionId'
    | '/_authed/_active/s/$storeId/collections/new'
    | '/_authed/_active/s/$storeId/content/blocks'
    | '/_authed/_active/s/$storeId/content/blog'
    | '/_authed/_active/s/$storeId/content/menus'
    | '/_authed/_active/s/$storeId/content/pages'
    | '/_authed/_active/s/$storeId/content/redirects'
    | '/_authed/_active/s/$storeId/content/sections'
    | '/_authed/_active/s/$storeId/content/seo'
    | '/_authed/_active/s/$storeId/customers/$customerId'
    | '/_authed/_active/s/$storeId/discounts/$discountId'
    | '/_authed/_active/s/$storeId/discounts/new'
    | '/_authed/_active/s/$storeId/draft-orders/$draftId'
    | '/_authed/_active/s/$storeId/draft-orders/new'
    | '/_authed/_active/s/$storeId/gift-cards/$giftCardId'
    | '/_authed/_active/s/$storeId/help/$articleId'
    | '/_authed/_active/s/$storeId/help/categories'
    | '/_authed/_active/s/$storeId/help/new'
    | '/_authed/_active/s/$storeId/inbox/$conversationId'
    | '/_authed/_active/s/$storeId/inventory_/$variantId'
    | '/_authed/_active/s/$storeId/orders/$orderId'
    | '/_authed/_active/s/$storeId/reports/analytics'
    | '/_authed/_active/s/$storeId/reports/auctions'
    | '/_authed/_active/s/$storeId/reports/customers'
    | '/_authed/_active/s/$storeId/reports/inventory'
    | '/_authed/_active/s/$storeId/reports/payments'
    | '/_authed/_active/s/$storeId/reports/products'
    | '/_authed/_active/s/$storeId/reports/sales'
    | '/_authed/_active/s/$storeId/reports/support'
    | '/_authed/_active/s/$storeId/returns/$returnId'
    | '/_authed/_active/s/$storeId/settings/analytics'
    | '/_authed/_active/s/$storeId/settings/api-keys'
    | '/_authed/_active/s/$storeId/settings/chat'
    | '/_authed/_active/s/$storeId/settings/feeds'
    | '/_authed/_active/s/$storeId/settings/imports-exports'
    | '/_authed/_active/s/$storeId/settings/locations'
    | '/_authed/_active/s/$storeId/settings/markets'
    | '/_authed/_active/s/$storeId/settings/notifications'
    | '/_authed/_active/s/$storeId/settings/payment-methods'
    | '/_authed/_active/s/$storeId/settings/policies'
    | '/_authed/_active/s/$storeId/settings/qc-checklists'
    | '/_authed/_active/s/$storeId/settings/recovery'
    | '/_authed/_active/s/$storeId/settings/returns'
    | '/_authed/_active/s/$storeId/settings/shipping'
    | '/_authed/_active/s/$storeId/settings/tax'
    | '/_authed/_active/s/$storeId/settings/webhooks'
    | '/_authed/_active/s/$storeId/settings/workflows'
    | '/_authed/_active/s/$storeId/social/pinterest'
    | '/_authed/_active/stores/$storeId/inbox/$conversationId'
    | '/_authed/_active/org/catalog-setup/attributes/'
    | '/_authed/_active/org/catalog-setup/product-types/'
    | '/_authed/_active/org/catalog-setup/size-sets/'
    | '/_authed/_active/org/catalog-setup/sku-rules/'
    | '/_authed/_active/org/shared-blocks/new/'
    | '/_authed/_active/s/$storeId/abandoned-checkouts/'
    | '/_authed/_active/s/$storeId/auctions/'
    | '/_authed/_active/s/$storeId/catalog/'
    | '/_authed/_active/s/$storeId/collections/'
    | '/_authed/_active/s/$storeId/content/'
    | '/_authed/_active/s/$storeId/customers/'
    | '/_authed/_active/s/$storeId/discounts/'
    | '/_authed/_active/s/$storeId/draft-orders/'
    | '/_authed/_active/s/$storeId/gift-cards/'
    | '/_authed/_active/s/$storeId/help/'
    | '/_authed/_active/s/$storeId/inbox/'
    | '/_authed/_active/s/$storeId/orders/'
    | '/_authed/_active/s/$storeId/reports/'
    | '/_authed/_active/s/$storeId/returns/'
    | '/_authed/_active/s/$storeId/settings/'
    | '/_authed/_active/s/$storeId/social/'
    | '/_authed/_active/org/products/$productId_/variants/$variantId'
    | '/_authed/_active/s/$storeId/auctions/sales/$saleId'
    | '/_authed/_active/s/$storeId/content/blocks/$blockId'
    | '/_authed/_active/s/$storeId/content/blocks/new'
    | '/_authed/_active/s/$storeId/content/blog/$postId'
    | '/_authed/_active/s/$storeId/content/blog/categories'
    | '/_authed/_active/s/$storeId/content/blog/new'
    | '/_authed/_active/s/$storeId/content/menus/$menuId'
    | '/_authed/_active/s/$storeId/content/pages/$pageId'
    | '/_authed/_active/s/$storeId/content/pages/new'
    | '/_authed/_active/s/$storeId/content/sections/$sectionId'
    | '/_authed/_active/s/$storeId/content/sections/new'
    | '/_authed/_active/s/$storeId/settings/policies/$policyId'
    | '/_authed/_active/s/$storeId/settings/policies/new'
    | '/_authed/_active/s/$storeId/settings/qc-checklists/$checklistId'
    | '/_authed/_active/s/$storeId/settings/qc-checklists/new'
    | '/_authed/_active/s/$storeId/settings/webhooks/$endpointId'
    | '/_authed/_active/s/$storeId/settings/workflows/$templateId'
    | '/_authed/_active/s/$storeId/settings/workflows/new'
    | '/_authed/_active/s/$storeId/social/pinterest/analytics'
    | '/_authed/_active/s/$storeId/social/pinterest/connection'
    | '/_authed/_active/s/$storeId/social/pinterest/create'
    | '/_authed/_active/s/$storeId/social/pinterest/posts'
    | '/_authed/_active/s/$storeId/social/pinterest/settings'
    | '/_authed/_active/s/$storeId/auctions/sales/'
    | '/_authed/_active/s/$storeId/content/blocks/'
    | '/_authed/_active/s/$storeId/content/blog/'
    | '/_authed/_active/s/$storeId/content/menus/'
    | '/_authed/_active/s/$storeId/content/pages/'
    | '/_authed/_active/s/$storeId/content/sections/'
    | '/_authed/_active/s/$storeId/settings/policies/'
    | '/_authed/_active/s/$storeId/settings/qc-checklists/'
    | '/_authed/_active/s/$storeId/settings/webhooks/'
    | '/_authed/_active/s/$storeId/settings/workflows/'
    | '/_authed/_active/s/$storeId/social/pinterest/'
    | '/_authed/_active/s/$storeId/catalog/$storeProductId_/variants/$variantId'
    | '/_authed/_active/s/$storeId/content/blocks/new/$kind'
    | '/_authed/_active/s/$storeId/settings/payments/stripe/callback'
    | '/_authed/_active/s/$storeId/social/pinterest/posts/$postId'
    | '/_authed/_active/s/$storeId/content/blocks/new/'
    | '/_authed/_active/s/$storeId/social/pinterest/posts/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthedRoute: typeof AuthedRouteWithChildren;
  publicAcceptInviteRoute: typeof publicAcceptInviteRoute;
  publicConfirmEmailRoute: typeof publicConfirmEmailRoute;
  publicForgotPasswordRoute: typeof publicForgotPasswordRoute;
  publicLoginRoute: typeof publicLoginRoute;
  publicMagicLinkRoute: typeof publicMagicLinkRoute;
  publicResetPasswordRoute: typeof publicResetPasswordRoute;
  publicSignInLinkRoute: typeof publicSignInLinkRoute;
  publicApplyConfirmRoute: typeof publicApplyConfirmRoute;
  publicApplyIndexRoute: typeof publicApplyIndexRoute;
  publicAuthGoogleCallbackRoute: typeof publicAuthGoogleCallbackRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authed': {
      id: '/_authed';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/accept-invite': {
      id: '/(public)/accept-invite';
      path: '/accept-invite';
      fullPath: '/accept-invite';
      preLoaderRoute: typeof publicAcceptInviteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/confirm-email': {
      id: '/(public)/confirm-email';
      path: '/confirm-email';
      fullPath: '/confirm-email';
      preLoaderRoute: typeof publicConfirmEmailRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/forgot-password': {
      id: '/(public)/forgot-password';
      path: '/forgot-password';
      fullPath: '/forgot-password';
      preLoaderRoute: typeof publicForgotPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/login': {
      id: '/(public)/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof publicLoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/magic-link': {
      id: '/(public)/magic-link';
      path: '/magic-link';
      fullPath: '/magic-link';
      preLoaderRoute: typeof publicMagicLinkRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/reset-password': {
      id: '/(public)/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof publicResetPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/sign-in-link': {
      id: '/(public)/sign-in-link';
      path: '/sign-in-link';
      fullPath: '/sign-in-link';
      preLoaderRoute: typeof publicSignInLinkRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authed/_active': {
      id: '/_authed/_active';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthedActiveRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/_authed/docs': {
      id: '/_authed/docs';
      path: '/docs';
      fullPath: '/docs';
      preLoaderRoute: typeof AuthedDocsRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    '/(public)/apply/': {
      id: '/(public)/apply/';
      path: '/apply';
      fullPath: '/apply/';
      preLoaderRoute: typeof publicApplyIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/apply/confirm': {
      id: '/(public)/apply/confirm';
      path: '/apply/confirm';
      fullPath: '/apply/confirm';
      preLoaderRoute: typeof publicApplyConfirmRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authed/_active/help': {
      id: '/_authed/_active/help';
      path: '/help';
      fullPath: '/help';
      preLoaderRoute: typeof AuthedActiveHelpRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/docs/': {
      id: '/_authed/docs/';
      path: '/';
      fullPath: '/docs/';
      preLoaderRoute: typeof AuthedDocsIndexRouteImport;
      parentRoute: typeof AuthedDocsRoute;
    };
    '/_authed/docs/build': {
      id: '/_authed/docs/build';
      path: '/build';
      fullPath: '/docs/build';
      preLoaderRoute: typeof AuthedDocsBuildRouteImport;
      parentRoute: typeof AuthedDocsRoute;
    };
    '/_authed/docs/postman': {
      id: '/_authed/docs/postman';
      path: '/postman';
      fullPath: '/docs/postman';
      preLoaderRoute: typeof AuthedDocsPostmanRouteImport;
      parentRoute: typeof AuthedDocsRoute;
    };
    '/(public)/auth/google/callback': {
      id: '/(public)/auth/google/callback';
      path: '/auth/google/callback';
      fullPath: '/auth/google/callback';
      preLoaderRoute: typeof publicAuthGoogleCallbackRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authed/_active/account/': {
      id: '/_authed/_active/account/';
      path: '/account';
      fullPath: '/account/';
      preLoaderRoute: typeof AuthedActiveAccountIndexRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/account/chat-profile': {
      id: '/_authed/_active/account/chat-profile';
      path: '/account/chat-profile';
      fullPath: '/account/chat-profile';
      preLoaderRoute: typeof AuthedActiveAccountChatProfileRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/account/notifications': {
      id: '/_authed/_active/account/notifications';
      path: '/account/notifications';
      fullPath: '/account/notifications';
      preLoaderRoute: typeof AuthedActiveAccountNotificationsRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/account/security': {
      id: '/_authed/_active/account/security';
      path: '/account/security';
      fullPath: '/account/security';
      preLoaderRoute: typeof AuthedActiveAccountSecurityRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/org/': {
      id: '/_authed/_active/org/';
      path: '/org';
      fullPath: '/org/';
      preLoaderRoute: typeof AuthedActiveOrgIndexRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/org/activity': {
      id: '/_authed/_active/org/activity';
      path: '/org/activity';
      fullPath: '/org/activity';
      preLoaderRoute: typeof AuthedActiveOrgActivityRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/org/catalog-setup': {
      id: '/_authed/_active/org/catalog-setup';
      path: '/org/catalog-setup';
      fullPath: '/org/catalog-setup';
      preLoaderRoute: typeof AuthedActiveOrgCatalogSetupRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/org/customizations': {
      id: '/_authed/_active/org/customizations';
      path: '/org/customizations';
      fullPath: '/org/customizations';
      preLoaderRoute: typeof AuthedActiveOrgCustomizationsRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/org/inbox': {
      id: '/_authed/_active/org/inbox';
      path: '/org/inbox';
      fullPath: '/org/inbox';
      preLoaderRoute: typeof AuthedActiveOrgInboxRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/org/media': {
      id: '/_authed/_active/org/media';
      path: '/org/media';
      fullPath: '/org/media';
      preLoaderRoute: typeof AuthedActiveOrgMediaRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/org/products': {
      id: '/_authed/_active/org/products';
      path: '/org/products';
      fullPath: '/org/products';
      preLoaderRoute: typeof AuthedActiveOrgProductsRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/org/roles': {
      id: '/_authed/_active/org/roles';
      path: '/org/roles';
      fullPath: '/org/roles';
      preLoaderRoute: typeof AuthedActiveOrgRolesRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/org/schedules': {
      id: '/_authed/_active/org/schedules';
      path: '/org/schedules';
      fullPath: '/org/schedules';
      preLoaderRoute: typeof AuthedActiveOrgSchedulesRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/org/settings': {
      id: '/_authed/_active/org/settings';
      path: '/org/settings';
      fullPath: '/org/settings';
      preLoaderRoute: typeof AuthedActiveOrgSettingsRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/org/shared-blocks': {
      id: '/_authed/_active/org/shared-blocks';
      path: '/org/shared-blocks';
      fullPath: '/org/shared-blocks';
      preLoaderRoute: typeof AuthedActiveOrgSharedBlocksRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/org/stone-pricing': {
      id: '/_authed/_active/org/stone-pricing';
      path: '/org/stone-pricing';
      fullPath: '/org/stone-pricing';
      preLoaderRoute: typeof AuthedActiveOrgStonePricingRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/org/stores': {
      id: '/_authed/_active/org/stores';
      path: '/org/stores';
      fullPath: '/org/stores';
      preLoaderRoute: typeof AuthedActiveOrgStoresRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/org/team': {
      id: '/_authed/_active/org/team';
      path: '/org/team';
      fullPath: '/org/team';
      preLoaderRoute: typeof AuthedActiveOrgTeamRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/s/$storeId': {
      id: '/_authed/_active/s/$storeId';
      path: '/s/$storeId';
      fullPath: '/s/$storeId';
      preLoaderRoute: typeof AuthedActiveSStoreIdRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/docs/api/': {
      id: '/_authed/docs/api/';
      path: '/api';
      fullPath: '/docs/api/';
      preLoaderRoute: typeof AuthedDocsApiIndexRouteImport;
      parentRoute: typeof AuthedDocsRoute;
    };
    '/_authed/docs/guides/$slug': {
      id: '/_authed/docs/guides/$slug';
      path: '/guides/$slug';
      fullPath: '/docs/guides/$slug';
      preLoaderRoute: typeof AuthedDocsGuidesSlugRouteImport;
      parentRoute: typeof AuthedDocsRoute;
    };
    '/_authed/_active/org/catalog-setup/': {
      id: '/_authed/_active/org/catalog-setup/';
      path: '/';
      fullPath: '/org/catalog-setup/';
      preLoaderRoute: typeof AuthedActiveOrgCatalogSetupIndexRouteImport;
      parentRoute: typeof AuthedActiveOrgCatalogSetupRoute;
    };
    '/_authed/_active/org/catalog-setup/attributes': {
      id: '/_authed/_active/org/catalog-setup/attributes';
      path: '/attributes';
      fullPath: '/org/catalog-setup/attributes';
      preLoaderRoute: typeof AuthedActiveOrgCatalogSetupAttributesRouteImport;
      parentRoute: typeof AuthedActiveOrgCatalogSetupRoute;
    };
    '/_authed/_active/org/catalog-setup/customizations': {
      id: '/_authed/_active/org/catalog-setup/customizations';
      path: '/customizations';
      fullPath: '/org/catalog-setup/customizations';
      preLoaderRoute: typeof AuthedActiveOrgCatalogSetupCustomizationsRouteImport;
      parentRoute: typeof AuthedActiveOrgCatalogSetupRoute;
    };
    '/_authed/_active/org/catalog-setup/product-types': {
      id: '/_authed/_active/org/catalog-setup/product-types';
      path: '/product-types';
      fullPath: '/org/catalog-setup/product-types';
      preLoaderRoute: typeof AuthedActiveOrgCatalogSetupProductTypesRouteImport;
      parentRoute: typeof AuthedActiveOrgCatalogSetupRoute;
    };
    '/_authed/_active/org/catalog-setup/size-sets': {
      id: '/_authed/_active/org/catalog-setup/size-sets';
      path: '/size-sets';
      fullPath: '/org/catalog-setup/size-sets';
      preLoaderRoute: typeof AuthedActiveOrgCatalogSetupSizeSetsRouteImport;
      parentRoute: typeof AuthedActiveOrgCatalogSetupRoute;
    };
    '/_authed/_active/org/catalog-setup/sku-rules': {
      id: '/_authed/_active/org/catalog-setup/sku-rules';
      path: '/sku-rules';
      fullPath: '/org/catalog-setup/sku-rules';
      preLoaderRoute: typeof AuthedActiveOrgCatalogSetupSkuRulesRouteImport;
      parentRoute: typeof AuthedActiveOrgCatalogSetupRoute;
    };
    '/_authed/_active/org/inbox/': {
      id: '/_authed/_active/org/inbox/';
      path: '/';
      fullPath: '/org/inbox/';
      preLoaderRoute: typeof AuthedActiveOrgInboxIndexRouteImport;
      parentRoute: typeof AuthedActiveOrgInboxRoute;
    };
    '/_authed/_active/org/products/': {
      id: '/_authed/_active/org/products/';
      path: '/';
      fullPath: '/org/products/';
      preLoaderRoute: typeof AuthedActiveOrgProductsIndexRouteImport;
      parentRoute: typeof AuthedActiveOrgProductsRoute;
    };
    '/_authed/_active/org/products/$productId': {
      id: '/_authed/_active/org/products/$productId';
      path: '/$productId';
      fullPath: '/org/products/$productId';
      preLoaderRoute: typeof AuthedActiveOrgProductsProductIdRouteImport;
      parentRoute: typeof AuthedActiveOrgProductsRoute;
    };
    '/_authed/_active/org/products/new': {
      id: '/_authed/_active/org/products/new';
      path: '/new';
      fullPath: '/org/products/new';
      preLoaderRoute: typeof AuthedActiveOrgProductsNewRouteImport;
      parentRoute: typeof AuthedActiveOrgProductsRoute;
    };
    '/_authed/_active/org/schedules/': {
      id: '/_authed/_active/org/schedules/';
      path: '/';
      fullPath: '/org/schedules/';
      preLoaderRoute: typeof AuthedActiveOrgSchedulesIndexRouteImport;
      parentRoute: typeof AuthedActiveOrgSchedulesRoute;
    };
    '/_authed/_active/org/schedules/$scheduleId': {
      id: '/_authed/_active/org/schedules/$scheduleId';
      path: '/$scheduleId';
      fullPath: '/org/schedules/$scheduleId';
      preLoaderRoute: typeof AuthedActiveOrgSchedulesScheduleIdRouteImport;
      parentRoute: typeof AuthedActiveOrgSchedulesRoute;
    };
    '/_authed/_active/org/schedules/new': {
      id: '/_authed/_active/org/schedules/new';
      path: '/new';
      fullPath: '/org/schedules/new';
      preLoaderRoute: typeof AuthedActiveOrgSchedulesNewRouteImport;
      parentRoute: typeof AuthedActiveOrgSchedulesRoute;
    };
    '/_authed/_active/org/schedules/upcoming': {
      id: '/_authed/_active/org/schedules/upcoming';
      path: '/upcoming';
      fullPath: '/org/schedules/upcoming';
      preLoaderRoute: typeof AuthedActiveOrgSchedulesUpcomingRouteImport;
      parentRoute: typeof AuthedActiveOrgSchedulesRoute;
    };
    '/_authed/_active/org/shared-blocks/': {
      id: '/_authed/_active/org/shared-blocks/';
      path: '/';
      fullPath: '/org/shared-blocks/';
      preLoaderRoute: typeof AuthedActiveOrgSharedBlocksIndexRouteImport;
      parentRoute: typeof AuthedActiveOrgSharedBlocksRoute;
    };
    '/_authed/_active/org/shared-blocks/$blockId': {
      id: '/_authed/_active/org/shared-blocks/$blockId';
      path: '/$blockId';
      fullPath: '/org/shared-blocks/$blockId';
      preLoaderRoute: typeof AuthedActiveOrgSharedBlocksBlockIdRouteImport;
      parentRoute: typeof AuthedActiveOrgSharedBlocksRoute;
    };
    '/_authed/_active/org/shared-blocks/new': {
      id: '/_authed/_active/org/shared-blocks/new';
      path: '/new';
      fullPath: '/org/shared-blocks/new';
      preLoaderRoute: typeof AuthedActiveOrgSharedBlocksNewRouteImport;
      parentRoute: typeof AuthedActiveOrgSharedBlocksRoute;
    };
    '/_authed/_active/org/stores/': {
      id: '/_authed/_active/org/stores/';
      path: '/';
      fullPath: '/org/stores/';
      preLoaderRoute: typeof AuthedActiveOrgStoresIndexRouteImport;
      parentRoute: typeof AuthedActiveOrgStoresRoute;
    };
    '/_authed/_active/org/stores/$storeId': {
      id: '/_authed/_active/org/stores/$storeId';
      path: '/$storeId';
      fullPath: '/org/stores/$storeId';
      preLoaderRoute: typeof AuthedActiveOrgStoresStoreIdRouteImport;
      parentRoute: typeof AuthedActiveOrgStoresRoute;
    };
    '/_authed/_active/s/$storeId/': {
      id: '/_authed/_active/s/$storeId/';
      path: '/';
      fullPath: '/s/$storeId/';
      preLoaderRoute: typeof AuthedActiveSStoreIdIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/abandoned-checkouts': {
      id: '/_authed/_active/s/$storeId/abandoned-checkouts';
      path: '/abandoned-checkouts';
      fullPath: '/s/$storeId/abandoned-checkouts';
      preLoaderRoute: typeof AuthedActiveSStoreIdAbandonedCheckoutsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/appointments': {
      id: '/_authed/_active/s/$storeId/appointments';
      path: '/appointments';
      fullPath: '/s/$storeId/appointments';
      preLoaderRoute: typeof AuthedActiveSStoreIdAppointmentsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/auctions': {
      id: '/_authed/_active/s/$storeId/auctions';
      path: '/auctions';
      fullPath: '/s/$storeId/auctions';
      preLoaderRoute: typeof AuthedActiveSStoreIdAuctionsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/catalog': {
      id: '/_authed/_active/s/$storeId/catalog';
      path: '/catalog';
      fullPath: '/s/$storeId/catalog';
      preLoaderRoute: typeof AuthedActiveSStoreIdCatalogRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/collections': {
      id: '/_authed/_active/s/$storeId/collections';
      path: '/collections';
      fullPath: '/s/$storeId/collections';
      preLoaderRoute: typeof AuthedActiveSStoreIdCollectionsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/content': {
      id: '/_authed/_active/s/$storeId/content';
      path: '/content';
      fullPath: '/s/$storeId/content';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/customers': {
      id: '/_authed/_active/s/$storeId/customers';
      path: '/customers';
      fullPath: '/s/$storeId/customers';
      preLoaderRoute: typeof AuthedActiveSStoreIdCustomersRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/discounts': {
      id: '/_authed/_active/s/$storeId/discounts';
      path: '/discounts';
      fullPath: '/s/$storeId/discounts';
      preLoaderRoute: typeof AuthedActiveSStoreIdDiscountsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/draft-orders': {
      id: '/_authed/_active/s/$storeId/draft-orders';
      path: '/draft-orders';
      fullPath: '/s/$storeId/draft-orders';
      preLoaderRoute: typeof AuthedActiveSStoreIdDraftOrdersRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/gift-cards': {
      id: '/_authed/_active/s/$storeId/gift-cards';
      path: '/gift-cards';
      fullPath: '/s/$storeId/gift-cards';
      preLoaderRoute: typeof AuthedActiveSStoreIdGiftCardsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/help': {
      id: '/_authed/_active/s/$storeId/help';
      path: '/help';
      fullPath: '/s/$storeId/help';
      preLoaderRoute: typeof AuthedActiveSStoreIdHelpRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/inbox': {
      id: '/_authed/_active/s/$storeId/inbox';
      path: '/inbox';
      fullPath: '/s/$storeId/inbox';
      preLoaderRoute: typeof AuthedActiveSStoreIdInboxRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/inventory': {
      id: '/_authed/_active/s/$storeId/inventory';
      path: '/inventory';
      fullPath: '/s/$storeId/inventory';
      preLoaderRoute: typeof AuthedActiveSStoreIdInventoryRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/orders': {
      id: '/_authed/_active/s/$storeId/orders';
      path: '/orders';
      fullPath: '/s/$storeId/orders';
      preLoaderRoute: typeof AuthedActiveSStoreIdOrdersRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/privacy-requests': {
      id: '/_authed/_active/s/$storeId/privacy-requests';
      path: '/privacy-requests';
      fullPath: '/s/$storeId/privacy-requests';
      preLoaderRoute: typeof AuthedActiveSStoreIdPrivacyRequestsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/production': {
      id: '/_authed/_active/s/$storeId/production';
      path: '/production';
      fullPath: '/s/$storeId/production';
      preLoaderRoute: typeof AuthedActiveSStoreIdProductionRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/reports': {
      id: '/_authed/_active/s/$storeId/reports';
      path: '/reports';
      fullPath: '/s/$storeId/reports';
      preLoaderRoute: typeof AuthedActiveSStoreIdReportsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/returns': {
      id: '/_authed/_active/s/$storeId/returns';
      path: '/returns';
      fullPath: '/s/$storeId/returns';
      preLoaderRoute: typeof AuthedActiveSStoreIdReturnsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/settings': {
      id: '/_authed/_active/s/$storeId/settings';
      path: '/settings';
      fullPath: '/s/$storeId/settings';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/social': {
      id: '/_authed/_active/s/$storeId/social';
      path: '/social';
      fullPath: '/s/$storeId/social';
      preLoaderRoute: typeof AuthedActiveSStoreIdSocialRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/docs/api/$tag/$operation': {
      id: '/_authed/docs/api/$tag/$operation';
      path: '/api/$tag/$operation';
      fullPath: '/docs/api/$tag/$operation';
      preLoaderRoute: typeof AuthedDocsApiTagOperationRouteImport;
      parentRoute: typeof AuthedDocsRoute;
    };
    '/_authed/_active/org/catalog-setup/attributes/': {
      id: '/_authed/_active/org/catalog-setup/attributes/';
      path: '/';
      fullPath: '/org/catalog-setup/attributes/';
      preLoaderRoute: typeof AuthedActiveOrgCatalogSetupAttributesIndexRouteImport;
      parentRoute: typeof AuthedActiveOrgCatalogSetupAttributesRoute;
    };
    '/_authed/_active/org/catalog-setup/attributes/$attributeId': {
      id: '/_authed/_active/org/catalog-setup/attributes/$attributeId';
      path: '/$attributeId';
      fullPath: '/org/catalog-setup/attributes/$attributeId';
      preLoaderRoute: typeof AuthedActiveOrgCatalogSetupAttributesAttributeIdRouteImport;
      parentRoute: typeof AuthedActiveOrgCatalogSetupAttributesRoute;
    };
    '/_authed/_active/org/catalog-setup/product-types/': {
      id: '/_authed/_active/org/catalog-setup/product-types/';
      path: '/';
      fullPath: '/org/catalog-setup/product-types/';
      preLoaderRoute: typeof AuthedActiveOrgCatalogSetupProductTypesIndexRouteImport;
      parentRoute: typeof AuthedActiveOrgCatalogSetupProductTypesRoute;
    };
    '/_authed/_active/org/catalog-setup/product-types/$productTypeId': {
      id: '/_authed/_active/org/catalog-setup/product-types/$productTypeId';
      path: '/$productTypeId';
      fullPath: '/org/catalog-setup/product-types/$productTypeId';
      preLoaderRoute: typeof AuthedActiveOrgCatalogSetupProductTypesProductTypeIdRouteImport;
      parentRoute: typeof AuthedActiveOrgCatalogSetupProductTypesRoute;
    };
    '/_authed/_active/org/catalog-setup/product-types/new': {
      id: '/_authed/_active/org/catalog-setup/product-types/new';
      path: '/new';
      fullPath: '/org/catalog-setup/product-types/new';
      preLoaderRoute: typeof AuthedActiveOrgCatalogSetupProductTypesNewRouteImport;
      parentRoute: typeof AuthedActiveOrgCatalogSetupProductTypesRoute;
    };
    '/_authed/_active/org/catalog-setup/size-sets/': {
      id: '/_authed/_active/org/catalog-setup/size-sets/';
      path: '/';
      fullPath: '/org/catalog-setup/size-sets/';
      preLoaderRoute: typeof AuthedActiveOrgCatalogSetupSizeSetsIndexRouteImport;
      parentRoute: typeof AuthedActiveOrgCatalogSetupSizeSetsRoute;
    };
    '/_authed/_active/org/catalog-setup/size-sets/$sizeSetId': {
      id: '/_authed/_active/org/catalog-setup/size-sets/$sizeSetId';
      path: '/$sizeSetId';
      fullPath: '/org/catalog-setup/size-sets/$sizeSetId';
      preLoaderRoute: typeof AuthedActiveOrgCatalogSetupSizeSetsSizeSetIdRouteImport;
      parentRoute: typeof AuthedActiveOrgCatalogSetupSizeSetsRoute;
    };
    '/_authed/_active/org/catalog-setup/size-sets/new': {
      id: '/_authed/_active/org/catalog-setup/size-sets/new';
      path: '/new';
      fullPath: '/org/catalog-setup/size-sets/new';
      preLoaderRoute: typeof AuthedActiveOrgCatalogSetupSizeSetsNewRouteImport;
      parentRoute: typeof AuthedActiveOrgCatalogSetupSizeSetsRoute;
    };
    '/_authed/_active/org/catalog-setup/sku-rules/': {
      id: '/_authed/_active/org/catalog-setup/sku-rules/';
      path: '/';
      fullPath: '/org/catalog-setup/sku-rules/';
      preLoaderRoute: typeof AuthedActiveOrgCatalogSetupSkuRulesIndexRouteImport;
      parentRoute: typeof AuthedActiveOrgCatalogSetupSkuRulesRoute;
    };
    '/_authed/_active/org/catalog-setup/sku-rules/$ruleId': {
      id: '/_authed/_active/org/catalog-setup/sku-rules/$ruleId';
      path: '/$ruleId';
      fullPath: '/org/catalog-setup/sku-rules/$ruleId';
      preLoaderRoute: typeof AuthedActiveOrgCatalogSetupSkuRulesRuleIdRouteImport;
      parentRoute: typeof AuthedActiveOrgCatalogSetupSkuRulesRoute;
    };
    '/_authed/_active/org/catalog-setup/sku-rules/new': {
      id: '/_authed/_active/org/catalog-setup/sku-rules/new';
      path: '/new';
      fullPath: '/org/catalog-setup/sku-rules/new';
      preLoaderRoute: typeof AuthedActiveOrgCatalogSetupSkuRulesNewRouteImport;
      parentRoute: typeof AuthedActiveOrgCatalogSetupSkuRulesRoute;
    };
    '/_authed/_active/org/inbox/$storeId/$conversationId': {
      id: '/_authed/_active/org/inbox/$storeId/$conversationId';
      path: '/$storeId/$conversationId';
      fullPath: '/org/inbox/$storeId/$conversationId';
      preLoaderRoute: typeof AuthedActiveOrgInboxStoreIdConversationIdRouteImport;
      parentRoute: typeof AuthedActiveOrgInboxRoute;
    };
    '/_authed/_active/org/shared-blocks/new/': {
      id: '/_authed/_active/org/shared-blocks/new/';
      path: '/';
      fullPath: '/org/shared-blocks/new/';
      preLoaderRoute: typeof AuthedActiveOrgSharedBlocksNewIndexRouteImport;
      parentRoute: typeof AuthedActiveOrgSharedBlocksNewRoute;
    };
    '/_authed/_active/org/shared-blocks/new/$kind': {
      id: '/_authed/_active/org/shared-blocks/new/$kind';
      path: '/$kind';
      fullPath: '/org/shared-blocks/new/$kind';
      preLoaderRoute: typeof AuthedActiveOrgSharedBlocksNewKindRouteImport;
      parentRoute: typeof AuthedActiveOrgSharedBlocksNewRoute;
    };
    '/_authed/_active/s/$storeId/abandoned-checkouts/': {
      id: '/_authed/_active/s/$storeId/abandoned-checkouts/';
      path: '/';
      fullPath: '/s/$storeId/abandoned-checkouts/';
      preLoaderRoute: typeof AuthedActiveSStoreIdAbandonedCheckoutsIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdAbandonedCheckoutsRoute;
    };
    '/_authed/_active/s/$storeId/abandoned-checkouts/$checkoutId': {
      id: '/_authed/_active/s/$storeId/abandoned-checkouts/$checkoutId';
      path: '/$checkoutId';
      fullPath: '/s/$storeId/abandoned-checkouts/$checkoutId';
      preLoaderRoute: typeof AuthedActiveSStoreIdAbandonedCheckoutsCheckoutIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdAbandonedCheckoutsRoute;
    };
    '/_authed/_active/s/$storeId/auctions/': {
      id: '/_authed/_active/s/$storeId/auctions/';
      path: '/';
      fullPath: '/s/$storeId/auctions/';
      preLoaderRoute: typeof AuthedActiveSStoreIdAuctionsIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdAuctionsRoute;
    };
    '/_authed/_active/s/$storeId/auctions/$auctionId': {
      id: '/_authed/_active/s/$storeId/auctions/$auctionId';
      path: '/$auctionId';
      fullPath: '/s/$storeId/auctions/$auctionId';
      preLoaderRoute: typeof AuthedActiveSStoreIdAuctionsAuctionIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdAuctionsRoute;
    };
    '/_authed/_active/s/$storeId/auctions/bidders': {
      id: '/_authed/_active/s/$storeId/auctions/bidders';
      path: '/bidders';
      fullPath: '/s/$storeId/auctions/bidders';
      preLoaderRoute: typeof AuthedActiveSStoreIdAuctionsBiddersRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdAuctionsRoute;
    };
    '/_authed/_active/s/$storeId/auctions/questions': {
      id: '/_authed/_active/s/$storeId/auctions/questions';
      path: '/questions';
      fullPath: '/s/$storeId/auctions/questions';
      preLoaderRoute: typeof AuthedActiveSStoreIdAuctionsQuestionsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdAuctionsRoute;
    };
    '/_authed/_active/s/$storeId/catalog/': {
      id: '/_authed/_active/s/$storeId/catalog/';
      path: '/';
      fullPath: '/s/$storeId/catalog/';
      preLoaderRoute: typeof AuthedActiveSStoreIdCatalogIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdCatalogRoute;
    };
    '/_authed/_active/s/$storeId/catalog/$storeProductId': {
      id: '/_authed/_active/s/$storeId/catalog/$storeProductId';
      path: '/$storeProductId';
      fullPath: '/s/$storeId/catalog/$storeProductId';
      preLoaderRoute: typeof AuthedActiveSStoreIdCatalogStoreProductIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdCatalogRoute;
    };
    '/_authed/_active/s/$storeId/collections/': {
      id: '/_authed/_active/s/$storeId/collections/';
      path: '/';
      fullPath: '/s/$storeId/collections/';
      preLoaderRoute: typeof AuthedActiveSStoreIdCollectionsIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdCollectionsRoute;
    };
    '/_authed/_active/s/$storeId/collections/$collectionId': {
      id: '/_authed/_active/s/$storeId/collections/$collectionId';
      path: '/$collectionId';
      fullPath: '/s/$storeId/collections/$collectionId';
      preLoaderRoute: typeof AuthedActiveSStoreIdCollectionsCollectionIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdCollectionsRoute;
    };
    '/_authed/_active/s/$storeId/collections/new': {
      id: '/_authed/_active/s/$storeId/collections/new';
      path: '/new';
      fullPath: '/s/$storeId/collections/new';
      preLoaderRoute: typeof AuthedActiveSStoreIdCollectionsNewRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdCollectionsRoute;
    };
    '/_authed/_active/s/$storeId/content/': {
      id: '/_authed/_active/s/$storeId/content/';
      path: '/';
      fullPath: '/s/$storeId/content/';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentRoute;
    };
    '/_authed/_active/s/$storeId/content/blocks': {
      id: '/_authed/_active/s/$storeId/content/blocks';
      path: '/blocks';
      fullPath: '/s/$storeId/content/blocks';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentBlocksRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentRoute;
    };
    '/_authed/_active/s/$storeId/content/blog': {
      id: '/_authed/_active/s/$storeId/content/blog';
      path: '/blog';
      fullPath: '/s/$storeId/content/blog';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentBlogRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentRoute;
    };
    '/_authed/_active/s/$storeId/content/menus': {
      id: '/_authed/_active/s/$storeId/content/menus';
      path: '/menus';
      fullPath: '/s/$storeId/content/menus';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentMenusRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentRoute;
    };
    '/_authed/_active/s/$storeId/content/pages': {
      id: '/_authed/_active/s/$storeId/content/pages';
      path: '/pages';
      fullPath: '/s/$storeId/content/pages';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentPagesRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentRoute;
    };
    '/_authed/_active/s/$storeId/content/redirects': {
      id: '/_authed/_active/s/$storeId/content/redirects';
      path: '/redirects';
      fullPath: '/s/$storeId/content/redirects';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentRedirectsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentRoute;
    };
    '/_authed/_active/s/$storeId/content/sections': {
      id: '/_authed/_active/s/$storeId/content/sections';
      path: '/sections';
      fullPath: '/s/$storeId/content/sections';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentSectionsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentRoute;
    };
    '/_authed/_active/s/$storeId/content/seo': {
      id: '/_authed/_active/s/$storeId/content/seo';
      path: '/seo';
      fullPath: '/s/$storeId/content/seo';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentSeoRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentRoute;
    };
    '/_authed/_active/s/$storeId/customers/': {
      id: '/_authed/_active/s/$storeId/customers/';
      path: '/';
      fullPath: '/s/$storeId/customers/';
      preLoaderRoute: typeof AuthedActiveSStoreIdCustomersIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdCustomersRoute;
    };
    '/_authed/_active/s/$storeId/customers/$customerId': {
      id: '/_authed/_active/s/$storeId/customers/$customerId';
      path: '/$customerId';
      fullPath: '/s/$storeId/customers/$customerId';
      preLoaderRoute: typeof AuthedActiveSStoreIdCustomersCustomerIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdCustomersRoute;
    };
    '/_authed/_active/s/$storeId/discounts/': {
      id: '/_authed/_active/s/$storeId/discounts/';
      path: '/';
      fullPath: '/s/$storeId/discounts/';
      preLoaderRoute: typeof AuthedActiveSStoreIdDiscountsIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdDiscountsRoute;
    };
    '/_authed/_active/s/$storeId/discounts/$discountId': {
      id: '/_authed/_active/s/$storeId/discounts/$discountId';
      path: '/$discountId';
      fullPath: '/s/$storeId/discounts/$discountId';
      preLoaderRoute: typeof AuthedActiveSStoreIdDiscountsDiscountIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdDiscountsRoute;
    };
    '/_authed/_active/s/$storeId/discounts/new': {
      id: '/_authed/_active/s/$storeId/discounts/new';
      path: '/new';
      fullPath: '/s/$storeId/discounts/new';
      preLoaderRoute: typeof AuthedActiveSStoreIdDiscountsNewRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdDiscountsRoute;
    };
    '/_authed/_active/s/$storeId/draft-orders/': {
      id: '/_authed/_active/s/$storeId/draft-orders/';
      path: '/';
      fullPath: '/s/$storeId/draft-orders/';
      preLoaderRoute: typeof AuthedActiveSStoreIdDraftOrdersIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdDraftOrdersRoute;
    };
    '/_authed/_active/s/$storeId/draft-orders/$draftId': {
      id: '/_authed/_active/s/$storeId/draft-orders/$draftId';
      path: '/$draftId';
      fullPath: '/s/$storeId/draft-orders/$draftId';
      preLoaderRoute: typeof AuthedActiveSStoreIdDraftOrdersDraftIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdDraftOrdersRoute;
    };
    '/_authed/_active/s/$storeId/draft-orders/new': {
      id: '/_authed/_active/s/$storeId/draft-orders/new';
      path: '/new';
      fullPath: '/s/$storeId/draft-orders/new';
      preLoaderRoute: typeof AuthedActiveSStoreIdDraftOrdersNewRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdDraftOrdersRoute;
    };
    '/_authed/_active/s/$storeId/gift-cards/': {
      id: '/_authed/_active/s/$storeId/gift-cards/';
      path: '/';
      fullPath: '/s/$storeId/gift-cards/';
      preLoaderRoute: typeof AuthedActiveSStoreIdGiftCardsIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdGiftCardsRoute;
    };
    '/_authed/_active/s/$storeId/gift-cards/$giftCardId': {
      id: '/_authed/_active/s/$storeId/gift-cards/$giftCardId';
      path: '/$giftCardId';
      fullPath: '/s/$storeId/gift-cards/$giftCardId';
      preLoaderRoute: typeof AuthedActiveSStoreIdGiftCardsGiftCardIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdGiftCardsRoute;
    };
    '/_authed/_active/s/$storeId/help/': {
      id: '/_authed/_active/s/$storeId/help/';
      path: '/';
      fullPath: '/s/$storeId/help/';
      preLoaderRoute: typeof AuthedActiveSStoreIdHelpIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdHelpRoute;
    };
    '/_authed/_active/s/$storeId/help/$articleId': {
      id: '/_authed/_active/s/$storeId/help/$articleId';
      path: '/$articleId';
      fullPath: '/s/$storeId/help/$articleId';
      preLoaderRoute: typeof AuthedActiveSStoreIdHelpArticleIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdHelpRoute;
    };
    '/_authed/_active/s/$storeId/help/categories': {
      id: '/_authed/_active/s/$storeId/help/categories';
      path: '/categories';
      fullPath: '/s/$storeId/help/categories';
      preLoaderRoute: typeof AuthedActiveSStoreIdHelpCategoriesRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdHelpRoute;
    };
    '/_authed/_active/s/$storeId/help/new': {
      id: '/_authed/_active/s/$storeId/help/new';
      path: '/new';
      fullPath: '/s/$storeId/help/new';
      preLoaderRoute: typeof AuthedActiveSStoreIdHelpNewRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdHelpRoute;
    };
    '/_authed/_active/s/$storeId/inbox/': {
      id: '/_authed/_active/s/$storeId/inbox/';
      path: '/';
      fullPath: '/s/$storeId/inbox/';
      preLoaderRoute: typeof AuthedActiveSStoreIdInboxIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdInboxRoute;
    };
    '/_authed/_active/s/$storeId/inbox/$conversationId': {
      id: '/_authed/_active/s/$storeId/inbox/$conversationId';
      path: '/$conversationId';
      fullPath: '/s/$storeId/inbox/$conversationId';
      preLoaderRoute: typeof AuthedActiveSStoreIdInboxConversationIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdInboxRoute;
    };
    '/_authed/_active/s/$storeId/inventory_/$variantId': {
      id: '/_authed/_active/s/$storeId/inventory_/$variantId';
      path: '/inventory/$variantId';
      fullPath: '/s/$storeId/inventory/$variantId';
      preLoaderRoute: typeof AuthedActiveSStoreIdInventoryVariantIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdRoute;
    };
    '/_authed/_active/s/$storeId/orders/': {
      id: '/_authed/_active/s/$storeId/orders/';
      path: '/';
      fullPath: '/s/$storeId/orders/';
      preLoaderRoute: typeof AuthedActiveSStoreIdOrdersIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdOrdersRoute;
    };
    '/_authed/_active/s/$storeId/orders/$orderId': {
      id: '/_authed/_active/s/$storeId/orders/$orderId';
      path: '/$orderId';
      fullPath: '/s/$storeId/orders/$orderId';
      preLoaderRoute: typeof AuthedActiveSStoreIdOrdersOrderIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdOrdersRoute;
    };
    '/_authed/_active/s/$storeId/reports/': {
      id: '/_authed/_active/s/$storeId/reports/';
      path: '/';
      fullPath: '/s/$storeId/reports/';
      preLoaderRoute: typeof AuthedActiveSStoreIdReportsIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdReportsRoute;
    };
    '/_authed/_active/s/$storeId/reports/analytics': {
      id: '/_authed/_active/s/$storeId/reports/analytics';
      path: '/analytics';
      fullPath: '/s/$storeId/reports/analytics';
      preLoaderRoute: typeof AuthedActiveSStoreIdReportsAnalyticsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdReportsRoute;
    };
    '/_authed/_active/s/$storeId/reports/auctions': {
      id: '/_authed/_active/s/$storeId/reports/auctions';
      path: '/auctions';
      fullPath: '/s/$storeId/reports/auctions';
      preLoaderRoute: typeof AuthedActiveSStoreIdReportsAuctionsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdReportsRoute;
    };
    '/_authed/_active/s/$storeId/reports/customers': {
      id: '/_authed/_active/s/$storeId/reports/customers';
      path: '/customers';
      fullPath: '/s/$storeId/reports/customers';
      preLoaderRoute: typeof AuthedActiveSStoreIdReportsCustomersRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdReportsRoute;
    };
    '/_authed/_active/s/$storeId/reports/inventory': {
      id: '/_authed/_active/s/$storeId/reports/inventory';
      path: '/inventory';
      fullPath: '/s/$storeId/reports/inventory';
      preLoaderRoute: typeof AuthedActiveSStoreIdReportsInventoryRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdReportsRoute;
    };
    '/_authed/_active/s/$storeId/reports/payments': {
      id: '/_authed/_active/s/$storeId/reports/payments';
      path: '/payments';
      fullPath: '/s/$storeId/reports/payments';
      preLoaderRoute: typeof AuthedActiveSStoreIdReportsPaymentsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdReportsRoute;
    };
    '/_authed/_active/s/$storeId/reports/products': {
      id: '/_authed/_active/s/$storeId/reports/products';
      path: '/products';
      fullPath: '/s/$storeId/reports/products';
      preLoaderRoute: typeof AuthedActiveSStoreIdReportsProductsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdReportsRoute;
    };
    '/_authed/_active/s/$storeId/reports/sales': {
      id: '/_authed/_active/s/$storeId/reports/sales';
      path: '/sales';
      fullPath: '/s/$storeId/reports/sales';
      preLoaderRoute: typeof AuthedActiveSStoreIdReportsSalesRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdReportsRoute;
    };
    '/_authed/_active/s/$storeId/reports/support': {
      id: '/_authed/_active/s/$storeId/reports/support';
      path: '/support';
      fullPath: '/s/$storeId/reports/support';
      preLoaderRoute: typeof AuthedActiveSStoreIdReportsSupportRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdReportsRoute;
    };
    '/_authed/_active/s/$storeId/returns/': {
      id: '/_authed/_active/s/$storeId/returns/';
      path: '/';
      fullPath: '/s/$storeId/returns/';
      preLoaderRoute: typeof AuthedActiveSStoreIdReturnsIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdReturnsRoute;
    };
    '/_authed/_active/s/$storeId/returns/$returnId': {
      id: '/_authed/_active/s/$storeId/returns/$returnId';
      path: '/$returnId';
      fullPath: '/s/$storeId/returns/$returnId';
      preLoaderRoute: typeof AuthedActiveSStoreIdReturnsReturnIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdReturnsRoute;
    };
    '/_authed/_active/s/$storeId/settings/': {
      id: '/_authed/_active/s/$storeId/settings/';
      path: '/';
      fullPath: '/s/$storeId/settings/';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/settings/analytics': {
      id: '/_authed/_active/s/$storeId/settings/analytics';
      path: '/analytics';
      fullPath: '/s/$storeId/settings/analytics';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsAnalyticsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/settings/api-keys': {
      id: '/_authed/_active/s/$storeId/settings/api-keys';
      path: '/api-keys';
      fullPath: '/s/$storeId/settings/api-keys';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsApiKeysRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/settings/chat': {
      id: '/_authed/_active/s/$storeId/settings/chat';
      path: '/chat';
      fullPath: '/s/$storeId/settings/chat';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsChatRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/settings/feeds': {
      id: '/_authed/_active/s/$storeId/settings/feeds';
      path: '/feeds';
      fullPath: '/s/$storeId/settings/feeds';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsFeedsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/settings/imports-exports': {
      id: '/_authed/_active/s/$storeId/settings/imports-exports';
      path: '/imports-exports';
      fullPath: '/s/$storeId/settings/imports-exports';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsImportsExportsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/settings/locations': {
      id: '/_authed/_active/s/$storeId/settings/locations';
      path: '/locations';
      fullPath: '/s/$storeId/settings/locations';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsLocationsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/settings/markets': {
      id: '/_authed/_active/s/$storeId/settings/markets';
      path: '/markets';
      fullPath: '/s/$storeId/settings/markets';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsMarketsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/settings/notifications': {
      id: '/_authed/_active/s/$storeId/settings/notifications';
      path: '/notifications';
      fullPath: '/s/$storeId/settings/notifications';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsNotificationsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/settings/payment-methods': {
      id: '/_authed/_active/s/$storeId/settings/payment-methods';
      path: '/payment-methods';
      fullPath: '/s/$storeId/settings/payment-methods';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsPaymentMethodsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/settings/policies': {
      id: '/_authed/_active/s/$storeId/settings/policies';
      path: '/policies';
      fullPath: '/s/$storeId/settings/policies';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsPoliciesRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/settings/qc-checklists': {
      id: '/_authed/_active/s/$storeId/settings/qc-checklists';
      path: '/qc-checklists';
      fullPath: '/s/$storeId/settings/qc-checklists';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsQcChecklistsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/settings/recovery': {
      id: '/_authed/_active/s/$storeId/settings/recovery';
      path: '/recovery';
      fullPath: '/s/$storeId/settings/recovery';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsRecoveryRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/settings/returns': {
      id: '/_authed/_active/s/$storeId/settings/returns';
      path: '/returns';
      fullPath: '/s/$storeId/settings/returns';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsReturnsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/settings/shipping': {
      id: '/_authed/_active/s/$storeId/settings/shipping';
      path: '/shipping';
      fullPath: '/s/$storeId/settings/shipping';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsShippingRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/settings/tax': {
      id: '/_authed/_active/s/$storeId/settings/tax';
      path: '/tax';
      fullPath: '/s/$storeId/settings/tax';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsTaxRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/settings/webhooks': {
      id: '/_authed/_active/s/$storeId/settings/webhooks';
      path: '/webhooks';
      fullPath: '/s/$storeId/settings/webhooks';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsWebhooksRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/settings/workflows': {
      id: '/_authed/_active/s/$storeId/settings/workflows';
      path: '/workflows';
      fullPath: '/s/$storeId/settings/workflows';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsWorkflowsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/social/': {
      id: '/_authed/_active/s/$storeId/social/';
      path: '/';
      fullPath: '/s/$storeId/social/';
      preLoaderRoute: typeof AuthedActiveSStoreIdSocialIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSocialRoute;
    };
    '/_authed/_active/s/$storeId/social/pinterest': {
      id: '/_authed/_active/s/$storeId/social/pinterest';
      path: '/pinterest';
      fullPath: '/s/$storeId/social/pinterest';
      preLoaderRoute: typeof AuthedActiveSStoreIdSocialPinterestRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSocialRoute;
    };
    '/_authed/_active/stores/$storeId/inbox/$conversationId': {
      id: '/_authed/_active/stores/$storeId/inbox/$conversationId';
      path: '/stores/$storeId/inbox/$conversationId';
      fullPath: '/stores/$storeId/inbox/$conversationId';
      preLoaderRoute: typeof AuthedActiveStoresStoreIdInboxConversationIdRouteImport;
      parentRoute: typeof AuthedActiveRoute;
    };
    '/_authed/_active/org/products/$productId_/variants/$variantId': {
      id: '/_authed/_active/org/products/$productId_/variants/$variantId';
      path: '/$productId/variants/$variantId';
      fullPath: '/org/products/$productId/variants/$variantId';
      preLoaderRoute: typeof AuthedActiveOrgProductsProductIdVariantsVariantIdRouteImport;
      parentRoute: typeof AuthedActiveOrgProductsRoute;
    };
    '/_authed/_active/s/$storeId/auctions/sales/': {
      id: '/_authed/_active/s/$storeId/auctions/sales/';
      path: '/sales';
      fullPath: '/s/$storeId/auctions/sales/';
      preLoaderRoute: typeof AuthedActiveSStoreIdAuctionsSalesIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdAuctionsRoute;
    };
    '/_authed/_active/s/$storeId/auctions/sales/$saleId': {
      id: '/_authed/_active/s/$storeId/auctions/sales/$saleId';
      path: '/sales/$saleId';
      fullPath: '/s/$storeId/auctions/sales/$saleId';
      preLoaderRoute: typeof AuthedActiveSStoreIdAuctionsSalesSaleIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdAuctionsRoute;
    };
    '/_authed/_active/s/$storeId/content/blocks/': {
      id: '/_authed/_active/s/$storeId/content/blocks/';
      path: '/';
      fullPath: '/s/$storeId/content/blocks/';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentBlocksIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentBlocksRoute;
    };
    '/_authed/_active/s/$storeId/content/blocks/$blockId': {
      id: '/_authed/_active/s/$storeId/content/blocks/$blockId';
      path: '/$blockId';
      fullPath: '/s/$storeId/content/blocks/$blockId';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentBlocksBlockIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentBlocksRoute;
    };
    '/_authed/_active/s/$storeId/content/blocks/new': {
      id: '/_authed/_active/s/$storeId/content/blocks/new';
      path: '/new';
      fullPath: '/s/$storeId/content/blocks/new';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentBlocksNewRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentBlocksRoute;
    };
    '/_authed/_active/s/$storeId/content/blog/': {
      id: '/_authed/_active/s/$storeId/content/blog/';
      path: '/';
      fullPath: '/s/$storeId/content/blog/';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentBlogIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentBlogRoute;
    };
    '/_authed/_active/s/$storeId/content/blog/$postId': {
      id: '/_authed/_active/s/$storeId/content/blog/$postId';
      path: '/$postId';
      fullPath: '/s/$storeId/content/blog/$postId';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentBlogPostIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentBlogRoute;
    };
    '/_authed/_active/s/$storeId/content/blog/categories': {
      id: '/_authed/_active/s/$storeId/content/blog/categories';
      path: '/categories';
      fullPath: '/s/$storeId/content/blog/categories';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentBlogCategoriesRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentBlogRoute;
    };
    '/_authed/_active/s/$storeId/content/blog/new': {
      id: '/_authed/_active/s/$storeId/content/blog/new';
      path: '/new';
      fullPath: '/s/$storeId/content/blog/new';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentBlogNewRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentBlogRoute;
    };
    '/_authed/_active/s/$storeId/content/menus/': {
      id: '/_authed/_active/s/$storeId/content/menus/';
      path: '/';
      fullPath: '/s/$storeId/content/menus/';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentMenusIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentMenusRoute;
    };
    '/_authed/_active/s/$storeId/content/menus/$menuId': {
      id: '/_authed/_active/s/$storeId/content/menus/$menuId';
      path: '/$menuId';
      fullPath: '/s/$storeId/content/menus/$menuId';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentMenusMenuIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentMenusRoute;
    };
    '/_authed/_active/s/$storeId/content/pages/': {
      id: '/_authed/_active/s/$storeId/content/pages/';
      path: '/';
      fullPath: '/s/$storeId/content/pages/';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentPagesIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentPagesRoute;
    };
    '/_authed/_active/s/$storeId/content/pages/$pageId': {
      id: '/_authed/_active/s/$storeId/content/pages/$pageId';
      path: '/$pageId';
      fullPath: '/s/$storeId/content/pages/$pageId';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentPagesPageIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentPagesRoute;
    };
    '/_authed/_active/s/$storeId/content/pages/new': {
      id: '/_authed/_active/s/$storeId/content/pages/new';
      path: '/new';
      fullPath: '/s/$storeId/content/pages/new';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentPagesNewRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentPagesRoute;
    };
    '/_authed/_active/s/$storeId/content/sections/': {
      id: '/_authed/_active/s/$storeId/content/sections/';
      path: '/';
      fullPath: '/s/$storeId/content/sections/';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentSectionsIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentSectionsRoute;
    };
    '/_authed/_active/s/$storeId/content/sections/$sectionId': {
      id: '/_authed/_active/s/$storeId/content/sections/$sectionId';
      path: '/$sectionId';
      fullPath: '/s/$storeId/content/sections/$sectionId';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentSectionsSectionIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentSectionsRoute;
    };
    '/_authed/_active/s/$storeId/content/sections/new': {
      id: '/_authed/_active/s/$storeId/content/sections/new';
      path: '/new';
      fullPath: '/s/$storeId/content/sections/new';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentSectionsNewRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentSectionsRoute;
    };
    '/_authed/_active/s/$storeId/settings/policies/': {
      id: '/_authed/_active/s/$storeId/settings/policies/';
      path: '/';
      fullPath: '/s/$storeId/settings/policies/';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsPoliciesIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsPoliciesRoute;
    };
    '/_authed/_active/s/$storeId/settings/policies/$policyId': {
      id: '/_authed/_active/s/$storeId/settings/policies/$policyId';
      path: '/$policyId';
      fullPath: '/s/$storeId/settings/policies/$policyId';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsPoliciesPolicyIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsPoliciesRoute;
    };
    '/_authed/_active/s/$storeId/settings/policies/new': {
      id: '/_authed/_active/s/$storeId/settings/policies/new';
      path: '/new';
      fullPath: '/s/$storeId/settings/policies/new';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsPoliciesNewRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsPoliciesRoute;
    };
    '/_authed/_active/s/$storeId/settings/qc-checklists/': {
      id: '/_authed/_active/s/$storeId/settings/qc-checklists/';
      path: '/';
      fullPath: '/s/$storeId/settings/qc-checklists/';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsQcChecklistsIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsQcChecklistsRoute;
    };
    '/_authed/_active/s/$storeId/settings/qc-checklists/$checklistId': {
      id: '/_authed/_active/s/$storeId/settings/qc-checklists/$checklistId';
      path: '/$checklistId';
      fullPath: '/s/$storeId/settings/qc-checklists/$checklistId';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsQcChecklistsChecklistIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsQcChecklistsRoute;
    };
    '/_authed/_active/s/$storeId/settings/qc-checklists/new': {
      id: '/_authed/_active/s/$storeId/settings/qc-checklists/new';
      path: '/new';
      fullPath: '/s/$storeId/settings/qc-checklists/new';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsQcChecklistsNewRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsQcChecklistsRoute;
    };
    '/_authed/_active/s/$storeId/settings/webhooks/': {
      id: '/_authed/_active/s/$storeId/settings/webhooks/';
      path: '/';
      fullPath: '/s/$storeId/settings/webhooks/';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsWebhooksIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsWebhooksRoute;
    };
    '/_authed/_active/s/$storeId/settings/webhooks/$endpointId': {
      id: '/_authed/_active/s/$storeId/settings/webhooks/$endpointId';
      path: '/$endpointId';
      fullPath: '/s/$storeId/settings/webhooks/$endpointId';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsWebhooksEndpointIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsWebhooksRoute;
    };
    '/_authed/_active/s/$storeId/settings/workflows/': {
      id: '/_authed/_active/s/$storeId/settings/workflows/';
      path: '/';
      fullPath: '/s/$storeId/settings/workflows/';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsWorkflowsIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsWorkflowsRoute;
    };
    '/_authed/_active/s/$storeId/settings/workflows/$templateId': {
      id: '/_authed/_active/s/$storeId/settings/workflows/$templateId';
      path: '/$templateId';
      fullPath: '/s/$storeId/settings/workflows/$templateId';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsWorkflowsTemplateIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsWorkflowsRoute;
    };
    '/_authed/_active/s/$storeId/settings/workflows/new': {
      id: '/_authed/_active/s/$storeId/settings/workflows/new';
      path: '/new';
      fullPath: '/s/$storeId/settings/workflows/new';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsWorkflowsNewRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsWorkflowsRoute;
    };
    '/_authed/_active/s/$storeId/social/pinterest/': {
      id: '/_authed/_active/s/$storeId/social/pinterest/';
      path: '/';
      fullPath: '/s/$storeId/social/pinterest/';
      preLoaderRoute: typeof AuthedActiveSStoreIdSocialPinterestIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSocialPinterestRoute;
    };
    '/_authed/_active/s/$storeId/social/pinterest/analytics': {
      id: '/_authed/_active/s/$storeId/social/pinterest/analytics';
      path: '/analytics';
      fullPath: '/s/$storeId/social/pinterest/analytics';
      preLoaderRoute: typeof AuthedActiveSStoreIdSocialPinterestAnalyticsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSocialPinterestRoute;
    };
    '/_authed/_active/s/$storeId/social/pinterest/connection': {
      id: '/_authed/_active/s/$storeId/social/pinterest/connection';
      path: '/connection';
      fullPath: '/s/$storeId/social/pinterest/connection';
      preLoaderRoute: typeof AuthedActiveSStoreIdSocialPinterestConnectionRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSocialPinterestRoute;
    };
    '/_authed/_active/s/$storeId/social/pinterest/create': {
      id: '/_authed/_active/s/$storeId/social/pinterest/create';
      path: '/create';
      fullPath: '/s/$storeId/social/pinterest/create';
      preLoaderRoute: typeof AuthedActiveSStoreIdSocialPinterestCreateRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSocialPinterestRoute;
    };
    '/_authed/_active/s/$storeId/social/pinterest/posts': {
      id: '/_authed/_active/s/$storeId/social/pinterest/posts';
      path: '/posts';
      fullPath: '/s/$storeId/social/pinterest/posts';
      preLoaderRoute: typeof AuthedActiveSStoreIdSocialPinterestPostsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSocialPinterestRoute;
    };
    '/_authed/_active/s/$storeId/social/pinterest/settings': {
      id: '/_authed/_active/s/$storeId/social/pinterest/settings';
      path: '/settings';
      fullPath: '/s/$storeId/social/pinterest/settings';
      preLoaderRoute: typeof AuthedActiveSStoreIdSocialPinterestSettingsRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSocialPinterestRoute;
    };
    '/_authed/_active/s/$storeId/catalog/$storeProductId_/variants/$variantId': {
      id: '/_authed/_active/s/$storeId/catalog/$storeProductId_/variants/$variantId';
      path: '/$storeProductId/variants/$variantId';
      fullPath: '/s/$storeId/catalog/$storeProductId/variants/$variantId';
      preLoaderRoute: typeof AuthedActiveSStoreIdCatalogStoreProductIdVariantsVariantIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdCatalogRoute;
    };
    '/_authed/_active/s/$storeId/content/blocks/new/': {
      id: '/_authed/_active/s/$storeId/content/blocks/new/';
      path: '/';
      fullPath: '/s/$storeId/content/blocks/new/';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentBlocksNewIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentBlocksNewRoute;
    };
    '/_authed/_active/s/$storeId/content/blocks/new/$kind': {
      id: '/_authed/_active/s/$storeId/content/blocks/new/$kind';
      path: '/$kind';
      fullPath: '/s/$storeId/content/blocks/new/$kind';
      preLoaderRoute: typeof AuthedActiveSStoreIdContentBlocksNewKindRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdContentBlocksNewRoute;
    };
    '/_authed/_active/s/$storeId/settings/payments/stripe/callback': {
      id: '/_authed/_active/s/$storeId/settings/payments/stripe/callback';
      path: '/payments/stripe/callback';
      fullPath: '/s/$storeId/settings/payments/stripe/callback';
      preLoaderRoute: typeof AuthedActiveSStoreIdSettingsPaymentsStripeCallbackRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSettingsRoute;
    };
    '/_authed/_active/s/$storeId/social/pinterest/posts/': {
      id: '/_authed/_active/s/$storeId/social/pinterest/posts/';
      path: '/';
      fullPath: '/s/$storeId/social/pinterest/posts/';
      preLoaderRoute: typeof AuthedActiveSStoreIdSocialPinterestPostsIndexRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSocialPinterestPostsRoute;
    };
    '/_authed/_active/s/$storeId/social/pinterest/posts/$postId': {
      id: '/_authed/_active/s/$storeId/social/pinterest/posts/$postId';
      path: '/$postId';
      fullPath: '/s/$storeId/social/pinterest/posts/$postId';
      preLoaderRoute: typeof AuthedActiveSStoreIdSocialPinterestPostsPostIdRouteImport;
      parentRoute: typeof AuthedActiveSStoreIdSocialPinterestPostsRoute;
    };
  }
}

interface AuthedActiveOrgCatalogSetupAttributesRouteChildren {
  AuthedActiveOrgCatalogSetupAttributesAttributeIdRoute: typeof AuthedActiveOrgCatalogSetupAttributesAttributeIdRoute;
  AuthedActiveOrgCatalogSetupAttributesIndexRoute: typeof AuthedActiveOrgCatalogSetupAttributesIndexRoute;
}

const AuthedActiveOrgCatalogSetupAttributesRouteChildren: AuthedActiveOrgCatalogSetupAttributesRouteChildren =
  {
    AuthedActiveOrgCatalogSetupAttributesAttributeIdRoute:
      AuthedActiveOrgCatalogSetupAttributesAttributeIdRoute,
    AuthedActiveOrgCatalogSetupAttributesIndexRoute:
      AuthedActiveOrgCatalogSetupAttributesIndexRoute,
  };

const AuthedActiveOrgCatalogSetupAttributesRouteWithChildren =
  AuthedActiveOrgCatalogSetupAttributesRoute._addFileChildren(
    AuthedActiveOrgCatalogSetupAttributesRouteChildren,
  );

interface AuthedActiveOrgCatalogSetupProductTypesRouteChildren {
  AuthedActiveOrgCatalogSetupProductTypesProductTypeIdRoute: typeof AuthedActiveOrgCatalogSetupProductTypesProductTypeIdRoute;
  AuthedActiveOrgCatalogSetupProductTypesNewRoute: typeof AuthedActiveOrgCatalogSetupProductTypesNewRoute;
  AuthedActiveOrgCatalogSetupProductTypesIndexRoute: typeof AuthedActiveOrgCatalogSetupProductTypesIndexRoute;
}

const AuthedActiveOrgCatalogSetupProductTypesRouteChildren: AuthedActiveOrgCatalogSetupProductTypesRouteChildren =
  {
    AuthedActiveOrgCatalogSetupProductTypesProductTypeIdRoute:
      AuthedActiveOrgCatalogSetupProductTypesProductTypeIdRoute,
    AuthedActiveOrgCatalogSetupProductTypesNewRoute:
      AuthedActiveOrgCatalogSetupProductTypesNewRoute,
    AuthedActiveOrgCatalogSetupProductTypesIndexRoute:
      AuthedActiveOrgCatalogSetupProductTypesIndexRoute,
  };

const AuthedActiveOrgCatalogSetupProductTypesRouteWithChildren =
  AuthedActiveOrgCatalogSetupProductTypesRoute._addFileChildren(
    AuthedActiveOrgCatalogSetupProductTypesRouteChildren,
  );

interface AuthedActiveOrgCatalogSetupSizeSetsRouteChildren {
  AuthedActiveOrgCatalogSetupSizeSetsSizeSetIdRoute: typeof AuthedActiveOrgCatalogSetupSizeSetsSizeSetIdRoute;
  AuthedActiveOrgCatalogSetupSizeSetsNewRoute: typeof AuthedActiveOrgCatalogSetupSizeSetsNewRoute;
  AuthedActiveOrgCatalogSetupSizeSetsIndexRoute: typeof AuthedActiveOrgCatalogSetupSizeSetsIndexRoute;
}

const AuthedActiveOrgCatalogSetupSizeSetsRouteChildren: AuthedActiveOrgCatalogSetupSizeSetsRouteChildren =
  {
    AuthedActiveOrgCatalogSetupSizeSetsSizeSetIdRoute:
      AuthedActiveOrgCatalogSetupSizeSetsSizeSetIdRoute,
    AuthedActiveOrgCatalogSetupSizeSetsNewRoute:
      AuthedActiveOrgCatalogSetupSizeSetsNewRoute,
    AuthedActiveOrgCatalogSetupSizeSetsIndexRoute:
      AuthedActiveOrgCatalogSetupSizeSetsIndexRoute,
  };

const AuthedActiveOrgCatalogSetupSizeSetsRouteWithChildren =
  AuthedActiveOrgCatalogSetupSizeSetsRoute._addFileChildren(
    AuthedActiveOrgCatalogSetupSizeSetsRouteChildren,
  );

interface AuthedActiveOrgCatalogSetupSkuRulesRouteChildren {
  AuthedActiveOrgCatalogSetupSkuRulesRuleIdRoute: typeof AuthedActiveOrgCatalogSetupSkuRulesRuleIdRoute;
  AuthedActiveOrgCatalogSetupSkuRulesNewRoute: typeof AuthedActiveOrgCatalogSetupSkuRulesNewRoute;
  AuthedActiveOrgCatalogSetupSkuRulesIndexRoute: typeof AuthedActiveOrgCatalogSetupSkuRulesIndexRoute;
}

const AuthedActiveOrgCatalogSetupSkuRulesRouteChildren: AuthedActiveOrgCatalogSetupSkuRulesRouteChildren =
  {
    AuthedActiveOrgCatalogSetupSkuRulesRuleIdRoute:
      AuthedActiveOrgCatalogSetupSkuRulesRuleIdRoute,
    AuthedActiveOrgCatalogSetupSkuRulesNewRoute:
      AuthedActiveOrgCatalogSetupSkuRulesNewRoute,
    AuthedActiveOrgCatalogSetupSkuRulesIndexRoute:
      AuthedActiveOrgCatalogSetupSkuRulesIndexRoute,
  };

const AuthedActiveOrgCatalogSetupSkuRulesRouteWithChildren =
  AuthedActiveOrgCatalogSetupSkuRulesRoute._addFileChildren(
    AuthedActiveOrgCatalogSetupSkuRulesRouteChildren,
  );

interface AuthedActiveOrgCatalogSetupRouteChildren {
  AuthedActiveOrgCatalogSetupAttributesRoute: typeof AuthedActiveOrgCatalogSetupAttributesRouteWithChildren;
  AuthedActiveOrgCatalogSetupCustomizationsRoute: typeof AuthedActiveOrgCatalogSetupCustomizationsRoute;
  AuthedActiveOrgCatalogSetupProductTypesRoute: typeof AuthedActiveOrgCatalogSetupProductTypesRouteWithChildren;
  AuthedActiveOrgCatalogSetupSizeSetsRoute: typeof AuthedActiveOrgCatalogSetupSizeSetsRouteWithChildren;
  AuthedActiveOrgCatalogSetupSkuRulesRoute: typeof AuthedActiveOrgCatalogSetupSkuRulesRouteWithChildren;
  AuthedActiveOrgCatalogSetupIndexRoute: typeof AuthedActiveOrgCatalogSetupIndexRoute;
}

const AuthedActiveOrgCatalogSetupRouteChildren: AuthedActiveOrgCatalogSetupRouteChildren =
  {
    AuthedActiveOrgCatalogSetupAttributesRoute:
      AuthedActiveOrgCatalogSetupAttributesRouteWithChildren,
    AuthedActiveOrgCatalogSetupCustomizationsRoute:
      AuthedActiveOrgCatalogSetupCustomizationsRoute,
    AuthedActiveOrgCatalogSetupProductTypesRoute:
      AuthedActiveOrgCatalogSetupProductTypesRouteWithChildren,
    AuthedActiveOrgCatalogSetupSizeSetsRoute:
      AuthedActiveOrgCatalogSetupSizeSetsRouteWithChildren,
    AuthedActiveOrgCatalogSetupSkuRulesRoute:
      AuthedActiveOrgCatalogSetupSkuRulesRouteWithChildren,
    AuthedActiveOrgCatalogSetupIndexRoute:
      AuthedActiveOrgCatalogSetupIndexRoute,
  };

const AuthedActiveOrgCatalogSetupRouteWithChildren =
  AuthedActiveOrgCatalogSetupRoute._addFileChildren(
    AuthedActiveOrgCatalogSetupRouteChildren,
  );

interface AuthedActiveOrgInboxRouteChildren {
  AuthedActiveOrgInboxIndexRoute: typeof AuthedActiveOrgInboxIndexRoute;
  AuthedActiveOrgInboxStoreIdConversationIdRoute: typeof AuthedActiveOrgInboxStoreIdConversationIdRoute;
}

const AuthedActiveOrgInboxRouteChildren: AuthedActiveOrgInboxRouteChildren = {
  AuthedActiveOrgInboxIndexRoute: AuthedActiveOrgInboxIndexRoute,
  AuthedActiveOrgInboxStoreIdConversationIdRoute:
    AuthedActiveOrgInboxStoreIdConversationIdRoute,
};

const AuthedActiveOrgInboxRouteWithChildren =
  AuthedActiveOrgInboxRoute._addFileChildren(AuthedActiveOrgInboxRouteChildren);

interface AuthedActiveOrgProductsRouteChildren {
  AuthedActiveOrgProductsProductIdRoute: typeof AuthedActiveOrgProductsProductIdRoute;
  AuthedActiveOrgProductsNewRoute: typeof AuthedActiveOrgProductsNewRoute;
  AuthedActiveOrgProductsIndexRoute: typeof AuthedActiveOrgProductsIndexRoute;
  AuthedActiveOrgProductsProductIdVariantsVariantIdRoute: typeof AuthedActiveOrgProductsProductIdVariantsVariantIdRoute;
}

const AuthedActiveOrgProductsRouteChildren: AuthedActiveOrgProductsRouteChildren =
  {
    AuthedActiveOrgProductsProductIdRoute:
      AuthedActiveOrgProductsProductIdRoute,
    AuthedActiveOrgProductsNewRoute: AuthedActiveOrgProductsNewRoute,
    AuthedActiveOrgProductsIndexRoute: AuthedActiveOrgProductsIndexRoute,
    AuthedActiveOrgProductsProductIdVariantsVariantIdRoute:
      AuthedActiveOrgProductsProductIdVariantsVariantIdRoute,
  };

const AuthedActiveOrgProductsRouteWithChildren =
  AuthedActiveOrgProductsRoute._addFileChildren(
    AuthedActiveOrgProductsRouteChildren,
  );

interface AuthedActiveOrgSchedulesRouteChildren {
  AuthedActiveOrgSchedulesScheduleIdRoute: typeof AuthedActiveOrgSchedulesScheduleIdRoute;
  AuthedActiveOrgSchedulesNewRoute: typeof AuthedActiveOrgSchedulesNewRoute;
  AuthedActiveOrgSchedulesUpcomingRoute: typeof AuthedActiveOrgSchedulesUpcomingRoute;
  AuthedActiveOrgSchedulesIndexRoute: typeof AuthedActiveOrgSchedulesIndexRoute;
}

const AuthedActiveOrgSchedulesRouteChildren: AuthedActiveOrgSchedulesRouteChildren =
  {
    AuthedActiveOrgSchedulesScheduleIdRoute:
      AuthedActiveOrgSchedulesScheduleIdRoute,
    AuthedActiveOrgSchedulesNewRoute: AuthedActiveOrgSchedulesNewRoute,
    AuthedActiveOrgSchedulesUpcomingRoute:
      AuthedActiveOrgSchedulesUpcomingRoute,
    AuthedActiveOrgSchedulesIndexRoute: AuthedActiveOrgSchedulesIndexRoute,
  };

const AuthedActiveOrgSchedulesRouteWithChildren =
  AuthedActiveOrgSchedulesRoute._addFileChildren(
    AuthedActiveOrgSchedulesRouteChildren,
  );

interface AuthedActiveOrgSharedBlocksNewRouteChildren {
  AuthedActiveOrgSharedBlocksNewKindRoute: typeof AuthedActiveOrgSharedBlocksNewKindRoute;
  AuthedActiveOrgSharedBlocksNewIndexRoute: typeof AuthedActiveOrgSharedBlocksNewIndexRoute;
}

const AuthedActiveOrgSharedBlocksNewRouteChildren: AuthedActiveOrgSharedBlocksNewRouteChildren =
  {
    AuthedActiveOrgSharedBlocksNewKindRoute:
      AuthedActiveOrgSharedBlocksNewKindRoute,
    AuthedActiveOrgSharedBlocksNewIndexRoute:
      AuthedActiveOrgSharedBlocksNewIndexRoute,
  };

const AuthedActiveOrgSharedBlocksNewRouteWithChildren =
  AuthedActiveOrgSharedBlocksNewRoute._addFileChildren(
    AuthedActiveOrgSharedBlocksNewRouteChildren,
  );

interface AuthedActiveOrgSharedBlocksRouteChildren {
  AuthedActiveOrgSharedBlocksBlockIdRoute: typeof AuthedActiveOrgSharedBlocksBlockIdRoute;
  AuthedActiveOrgSharedBlocksNewRoute: typeof AuthedActiveOrgSharedBlocksNewRouteWithChildren;
  AuthedActiveOrgSharedBlocksIndexRoute: typeof AuthedActiveOrgSharedBlocksIndexRoute;
}

const AuthedActiveOrgSharedBlocksRouteChildren: AuthedActiveOrgSharedBlocksRouteChildren =
  {
    AuthedActiveOrgSharedBlocksBlockIdRoute:
      AuthedActiveOrgSharedBlocksBlockIdRoute,
    AuthedActiveOrgSharedBlocksNewRoute:
      AuthedActiveOrgSharedBlocksNewRouteWithChildren,
    AuthedActiveOrgSharedBlocksIndexRoute:
      AuthedActiveOrgSharedBlocksIndexRoute,
  };

const AuthedActiveOrgSharedBlocksRouteWithChildren =
  AuthedActiveOrgSharedBlocksRoute._addFileChildren(
    AuthedActiveOrgSharedBlocksRouteChildren,
  );

interface AuthedActiveOrgStoresRouteChildren {
  AuthedActiveOrgStoresStoreIdRoute: typeof AuthedActiveOrgStoresStoreIdRoute;
  AuthedActiveOrgStoresIndexRoute: typeof AuthedActiveOrgStoresIndexRoute;
}

const AuthedActiveOrgStoresRouteChildren: AuthedActiveOrgStoresRouteChildren = {
  AuthedActiveOrgStoresStoreIdRoute: AuthedActiveOrgStoresStoreIdRoute,
  AuthedActiveOrgStoresIndexRoute: AuthedActiveOrgStoresIndexRoute,
};

const AuthedActiveOrgStoresRouteWithChildren =
  AuthedActiveOrgStoresRoute._addFileChildren(
    AuthedActiveOrgStoresRouteChildren,
  );

interface AuthedActiveSStoreIdAbandonedCheckoutsRouteChildren {
  AuthedActiveSStoreIdAbandonedCheckoutsCheckoutIdRoute: typeof AuthedActiveSStoreIdAbandonedCheckoutsCheckoutIdRoute;
  AuthedActiveSStoreIdAbandonedCheckoutsIndexRoute: typeof AuthedActiveSStoreIdAbandonedCheckoutsIndexRoute;
}

const AuthedActiveSStoreIdAbandonedCheckoutsRouteChildren: AuthedActiveSStoreIdAbandonedCheckoutsRouteChildren =
  {
    AuthedActiveSStoreIdAbandonedCheckoutsCheckoutIdRoute:
      AuthedActiveSStoreIdAbandonedCheckoutsCheckoutIdRoute,
    AuthedActiveSStoreIdAbandonedCheckoutsIndexRoute:
      AuthedActiveSStoreIdAbandonedCheckoutsIndexRoute,
  };

const AuthedActiveSStoreIdAbandonedCheckoutsRouteWithChildren =
  AuthedActiveSStoreIdAbandonedCheckoutsRoute._addFileChildren(
    AuthedActiveSStoreIdAbandonedCheckoutsRouteChildren,
  );

interface AuthedActiveSStoreIdAuctionsRouteChildren {
  AuthedActiveSStoreIdAuctionsAuctionIdRoute: typeof AuthedActiveSStoreIdAuctionsAuctionIdRoute;
  AuthedActiveSStoreIdAuctionsBiddersRoute: typeof AuthedActiveSStoreIdAuctionsBiddersRoute;
  AuthedActiveSStoreIdAuctionsQuestionsRoute: typeof AuthedActiveSStoreIdAuctionsQuestionsRoute;
  AuthedActiveSStoreIdAuctionsIndexRoute: typeof AuthedActiveSStoreIdAuctionsIndexRoute;
  AuthedActiveSStoreIdAuctionsSalesSaleIdRoute: typeof AuthedActiveSStoreIdAuctionsSalesSaleIdRoute;
  AuthedActiveSStoreIdAuctionsSalesIndexRoute: typeof AuthedActiveSStoreIdAuctionsSalesIndexRoute;
}

const AuthedActiveSStoreIdAuctionsRouteChildren: AuthedActiveSStoreIdAuctionsRouteChildren =
  {
    AuthedActiveSStoreIdAuctionsAuctionIdRoute:
      AuthedActiveSStoreIdAuctionsAuctionIdRoute,
    AuthedActiveSStoreIdAuctionsBiddersRoute:
      AuthedActiveSStoreIdAuctionsBiddersRoute,
    AuthedActiveSStoreIdAuctionsQuestionsRoute:
      AuthedActiveSStoreIdAuctionsQuestionsRoute,
    AuthedActiveSStoreIdAuctionsIndexRoute:
      AuthedActiveSStoreIdAuctionsIndexRoute,
    AuthedActiveSStoreIdAuctionsSalesSaleIdRoute:
      AuthedActiveSStoreIdAuctionsSalesSaleIdRoute,
    AuthedActiveSStoreIdAuctionsSalesIndexRoute:
      AuthedActiveSStoreIdAuctionsSalesIndexRoute,
  };

const AuthedActiveSStoreIdAuctionsRouteWithChildren =
  AuthedActiveSStoreIdAuctionsRoute._addFileChildren(
    AuthedActiveSStoreIdAuctionsRouteChildren,
  );

interface AuthedActiveSStoreIdCatalogRouteChildren {
  AuthedActiveSStoreIdCatalogStoreProductIdRoute: typeof AuthedActiveSStoreIdCatalogStoreProductIdRoute;
  AuthedActiveSStoreIdCatalogIndexRoute: typeof AuthedActiveSStoreIdCatalogIndexRoute;
  AuthedActiveSStoreIdCatalogStoreProductIdVariantsVariantIdRoute: typeof AuthedActiveSStoreIdCatalogStoreProductIdVariantsVariantIdRoute;
}

const AuthedActiveSStoreIdCatalogRouteChildren: AuthedActiveSStoreIdCatalogRouteChildren =
  {
    AuthedActiveSStoreIdCatalogStoreProductIdRoute:
      AuthedActiveSStoreIdCatalogStoreProductIdRoute,
    AuthedActiveSStoreIdCatalogIndexRoute:
      AuthedActiveSStoreIdCatalogIndexRoute,
    AuthedActiveSStoreIdCatalogStoreProductIdVariantsVariantIdRoute:
      AuthedActiveSStoreIdCatalogStoreProductIdVariantsVariantIdRoute,
  };

const AuthedActiveSStoreIdCatalogRouteWithChildren =
  AuthedActiveSStoreIdCatalogRoute._addFileChildren(
    AuthedActiveSStoreIdCatalogRouteChildren,
  );

interface AuthedActiveSStoreIdCollectionsRouteChildren {
  AuthedActiveSStoreIdCollectionsCollectionIdRoute: typeof AuthedActiveSStoreIdCollectionsCollectionIdRoute;
  AuthedActiveSStoreIdCollectionsNewRoute: typeof AuthedActiveSStoreIdCollectionsNewRoute;
  AuthedActiveSStoreIdCollectionsIndexRoute: typeof AuthedActiveSStoreIdCollectionsIndexRoute;
}

const AuthedActiveSStoreIdCollectionsRouteChildren: AuthedActiveSStoreIdCollectionsRouteChildren =
  {
    AuthedActiveSStoreIdCollectionsCollectionIdRoute:
      AuthedActiveSStoreIdCollectionsCollectionIdRoute,
    AuthedActiveSStoreIdCollectionsNewRoute:
      AuthedActiveSStoreIdCollectionsNewRoute,
    AuthedActiveSStoreIdCollectionsIndexRoute:
      AuthedActiveSStoreIdCollectionsIndexRoute,
  };

const AuthedActiveSStoreIdCollectionsRouteWithChildren =
  AuthedActiveSStoreIdCollectionsRoute._addFileChildren(
    AuthedActiveSStoreIdCollectionsRouteChildren,
  );

interface AuthedActiveSStoreIdContentBlocksNewRouteChildren {
  AuthedActiveSStoreIdContentBlocksNewKindRoute: typeof AuthedActiveSStoreIdContentBlocksNewKindRoute;
  AuthedActiveSStoreIdContentBlocksNewIndexRoute: typeof AuthedActiveSStoreIdContentBlocksNewIndexRoute;
}

const AuthedActiveSStoreIdContentBlocksNewRouteChildren: AuthedActiveSStoreIdContentBlocksNewRouteChildren =
  {
    AuthedActiveSStoreIdContentBlocksNewKindRoute:
      AuthedActiveSStoreIdContentBlocksNewKindRoute,
    AuthedActiveSStoreIdContentBlocksNewIndexRoute:
      AuthedActiveSStoreIdContentBlocksNewIndexRoute,
  };

const AuthedActiveSStoreIdContentBlocksNewRouteWithChildren =
  AuthedActiveSStoreIdContentBlocksNewRoute._addFileChildren(
    AuthedActiveSStoreIdContentBlocksNewRouteChildren,
  );

interface AuthedActiveSStoreIdContentBlocksRouteChildren {
  AuthedActiveSStoreIdContentBlocksBlockIdRoute: typeof AuthedActiveSStoreIdContentBlocksBlockIdRoute;
  AuthedActiveSStoreIdContentBlocksNewRoute: typeof AuthedActiveSStoreIdContentBlocksNewRouteWithChildren;
  AuthedActiveSStoreIdContentBlocksIndexRoute: typeof AuthedActiveSStoreIdContentBlocksIndexRoute;
}

const AuthedActiveSStoreIdContentBlocksRouteChildren: AuthedActiveSStoreIdContentBlocksRouteChildren =
  {
    AuthedActiveSStoreIdContentBlocksBlockIdRoute:
      AuthedActiveSStoreIdContentBlocksBlockIdRoute,
    AuthedActiveSStoreIdContentBlocksNewRoute:
      AuthedActiveSStoreIdContentBlocksNewRouteWithChildren,
    AuthedActiveSStoreIdContentBlocksIndexRoute:
      AuthedActiveSStoreIdContentBlocksIndexRoute,
  };

const AuthedActiveSStoreIdContentBlocksRouteWithChildren =
  AuthedActiveSStoreIdContentBlocksRoute._addFileChildren(
    AuthedActiveSStoreIdContentBlocksRouteChildren,
  );

interface AuthedActiveSStoreIdContentBlogRouteChildren {
  AuthedActiveSStoreIdContentBlogPostIdRoute: typeof AuthedActiveSStoreIdContentBlogPostIdRoute;
  AuthedActiveSStoreIdContentBlogCategoriesRoute: typeof AuthedActiveSStoreIdContentBlogCategoriesRoute;
  AuthedActiveSStoreIdContentBlogNewRoute: typeof AuthedActiveSStoreIdContentBlogNewRoute;
  AuthedActiveSStoreIdContentBlogIndexRoute: typeof AuthedActiveSStoreIdContentBlogIndexRoute;
}

const AuthedActiveSStoreIdContentBlogRouteChildren: AuthedActiveSStoreIdContentBlogRouteChildren =
  {
    AuthedActiveSStoreIdContentBlogPostIdRoute:
      AuthedActiveSStoreIdContentBlogPostIdRoute,
    AuthedActiveSStoreIdContentBlogCategoriesRoute:
      AuthedActiveSStoreIdContentBlogCategoriesRoute,
    AuthedActiveSStoreIdContentBlogNewRoute:
      AuthedActiveSStoreIdContentBlogNewRoute,
    AuthedActiveSStoreIdContentBlogIndexRoute:
      AuthedActiveSStoreIdContentBlogIndexRoute,
  };

const AuthedActiveSStoreIdContentBlogRouteWithChildren =
  AuthedActiveSStoreIdContentBlogRoute._addFileChildren(
    AuthedActiveSStoreIdContentBlogRouteChildren,
  );

interface AuthedActiveSStoreIdContentMenusRouteChildren {
  AuthedActiveSStoreIdContentMenusMenuIdRoute: typeof AuthedActiveSStoreIdContentMenusMenuIdRoute;
  AuthedActiveSStoreIdContentMenusIndexRoute: typeof AuthedActiveSStoreIdContentMenusIndexRoute;
}

const AuthedActiveSStoreIdContentMenusRouteChildren: AuthedActiveSStoreIdContentMenusRouteChildren =
  {
    AuthedActiveSStoreIdContentMenusMenuIdRoute:
      AuthedActiveSStoreIdContentMenusMenuIdRoute,
    AuthedActiveSStoreIdContentMenusIndexRoute:
      AuthedActiveSStoreIdContentMenusIndexRoute,
  };

const AuthedActiveSStoreIdContentMenusRouteWithChildren =
  AuthedActiveSStoreIdContentMenusRoute._addFileChildren(
    AuthedActiveSStoreIdContentMenusRouteChildren,
  );

interface AuthedActiveSStoreIdContentPagesRouteChildren {
  AuthedActiveSStoreIdContentPagesPageIdRoute: typeof AuthedActiveSStoreIdContentPagesPageIdRoute;
  AuthedActiveSStoreIdContentPagesNewRoute: typeof AuthedActiveSStoreIdContentPagesNewRoute;
  AuthedActiveSStoreIdContentPagesIndexRoute: typeof AuthedActiveSStoreIdContentPagesIndexRoute;
}

const AuthedActiveSStoreIdContentPagesRouteChildren: AuthedActiveSStoreIdContentPagesRouteChildren =
  {
    AuthedActiveSStoreIdContentPagesPageIdRoute:
      AuthedActiveSStoreIdContentPagesPageIdRoute,
    AuthedActiveSStoreIdContentPagesNewRoute:
      AuthedActiveSStoreIdContentPagesNewRoute,
    AuthedActiveSStoreIdContentPagesIndexRoute:
      AuthedActiveSStoreIdContentPagesIndexRoute,
  };

const AuthedActiveSStoreIdContentPagesRouteWithChildren =
  AuthedActiveSStoreIdContentPagesRoute._addFileChildren(
    AuthedActiveSStoreIdContentPagesRouteChildren,
  );

interface AuthedActiveSStoreIdContentSectionsRouteChildren {
  AuthedActiveSStoreIdContentSectionsSectionIdRoute: typeof AuthedActiveSStoreIdContentSectionsSectionIdRoute;
  AuthedActiveSStoreIdContentSectionsNewRoute: typeof AuthedActiveSStoreIdContentSectionsNewRoute;
  AuthedActiveSStoreIdContentSectionsIndexRoute: typeof AuthedActiveSStoreIdContentSectionsIndexRoute;
}

const AuthedActiveSStoreIdContentSectionsRouteChildren: AuthedActiveSStoreIdContentSectionsRouteChildren =
  {
    AuthedActiveSStoreIdContentSectionsSectionIdRoute:
      AuthedActiveSStoreIdContentSectionsSectionIdRoute,
    AuthedActiveSStoreIdContentSectionsNewRoute:
      AuthedActiveSStoreIdContentSectionsNewRoute,
    AuthedActiveSStoreIdContentSectionsIndexRoute:
      AuthedActiveSStoreIdContentSectionsIndexRoute,
  };

const AuthedActiveSStoreIdContentSectionsRouteWithChildren =
  AuthedActiveSStoreIdContentSectionsRoute._addFileChildren(
    AuthedActiveSStoreIdContentSectionsRouteChildren,
  );

interface AuthedActiveSStoreIdContentRouteChildren {
  AuthedActiveSStoreIdContentBlocksRoute: typeof AuthedActiveSStoreIdContentBlocksRouteWithChildren;
  AuthedActiveSStoreIdContentBlogRoute: typeof AuthedActiveSStoreIdContentBlogRouteWithChildren;
  AuthedActiveSStoreIdContentMenusRoute: typeof AuthedActiveSStoreIdContentMenusRouteWithChildren;
  AuthedActiveSStoreIdContentPagesRoute: typeof AuthedActiveSStoreIdContentPagesRouteWithChildren;
  AuthedActiveSStoreIdContentRedirectsRoute: typeof AuthedActiveSStoreIdContentRedirectsRoute;
  AuthedActiveSStoreIdContentSectionsRoute: typeof AuthedActiveSStoreIdContentSectionsRouteWithChildren;
  AuthedActiveSStoreIdContentSeoRoute: typeof AuthedActiveSStoreIdContentSeoRoute;
  AuthedActiveSStoreIdContentIndexRoute: typeof AuthedActiveSStoreIdContentIndexRoute;
}

const AuthedActiveSStoreIdContentRouteChildren: AuthedActiveSStoreIdContentRouteChildren =
  {
    AuthedActiveSStoreIdContentBlocksRoute:
      AuthedActiveSStoreIdContentBlocksRouteWithChildren,
    AuthedActiveSStoreIdContentBlogRoute:
      AuthedActiveSStoreIdContentBlogRouteWithChildren,
    AuthedActiveSStoreIdContentMenusRoute:
      AuthedActiveSStoreIdContentMenusRouteWithChildren,
    AuthedActiveSStoreIdContentPagesRoute:
      AuthedActiveSStoreIdContentPagesRouteWithChildren,
    AuthedActiveSStoreIdContentRedirectsRoute:
      AuthedActiveSStoreIdContentRedirectsRoute,
    AuthedActiveSStoreIdContentSectionsRoute:
      AuthedActiveSStoreIdContentSectionsRouteWithChildren,
    AuthedActiveSStoreIdContentSeoRoute: AuthedActiveSStoreIdContentSeoRoute,
    AuthedActiveSStoreIdContentIndexRoute:
      AuthedActiveSStoreIdContentIndexRoute,
  };

const AuthedActiveSStoreIdContentRouteWithChildren =
  AuthedActiveSStoreIdContentRoute._addFileChildren(
    AuthedActiveSStoreIdContentRouteChildren,
  );

interface AuthedActiveSStoreIdCustomersRouteChildren {
  AuthedActiveSStoreIdCustomersCustomerIdRoute: typeof AuthedActiveSStoreIdCustomersCustomerIdRoute;
  AuthedActiveSStoreIdCustomersIndexRoute: typeof AuthedActiveSStoreIdCustomersIndexRoute;
}

const AuthedActiveSStoreIdCustomersRouteChildren: AuthedActiveSStoreIdCustomersRouteChildren =
  {
    AuthedActiveSStoreIdCustomersCustomerIdRoute:
      AuthedActiveSStoreIdCustomersCustomerIdRoute,
    AuthedActiveSStoreIdCustomersIndexRoute:
      AuthedActiveSStoreIdCustomersIndexRoute,
  };

const AuthedActiveSStoreIdCustomersRouteWithChildren =
  AuthedActiveSStoreIdCustomersRoute._addFileChildren(
    AuthedActiveSStoreIdCustomersRouteChildren,
  );

interface AuthedActiveSStoreIdDiscountsRouteChildren {
  AuthedActiveSStoreIdDiscountsDiscountIdRoute: typeof AuthedActiveSStoreIdDiscountsDiscountIdRoute;
  AuthedActiveSStoreIdDiscountsNewRoute: typeof AuthedActiveSStoreIdDiscountsNewRoute;
  AuthedActiveSStoreIdDiscountsIndexRoute: typeof AuthedActiveSStoreIdDiscountsIndexRoute;
}

const AuthedActiveSStoreIdDiscountsRouteChildren: AuthedActiveSStoreIdDiscountsRouteChildren =
  {
    AuthedActiveSStoreIdDiscountsDiscountIdRoute:
      AuthedActiveSStoreIdDiscountsDiscountIdRoute,
    AuthedActiveSStoreIdDiscountsNewRoute:
      AuthedActiveSStoreIdDiscountsNewRoute,
    AuthedActiveSStoreIdDiscountsIndexRoute:
      AuthedActiveSStoreIdDiscountsIndexRoute,
  };

const AuthedActiveSStoreIdDiscountsRouteWithChildren =
  AuthedActiveSStoreIdDiscountsRoute._addFileChildren(
    AuthedActiveSStoreIdDiscountsRouteChildren,
  );

interface AuthedActiveSStoreIdDraftOrdersRouteChildren {
  AuthedActiveSStoreIdDraftOrdersDraftIdRoute: typeof AuthedActiveSStoreIdDraftOrdersDraftIdRoute;
  AuthedActiveSStoreIdDraftOrdersNewRoute: typeof AuthedActiveSStoreIdDraftOrdersNewRoute;
  AuthedActiveSStoreIdDraftOrdersIndexRoute: typeof AuthedActiveSStoreIdDraftOrdersIndexRoute;
}

const AuthedActiveSStoreIdDraftOrdersRouteChildren: AuthedActiveSStoreIdDraftOrdersRouteChildren =
  {
    AuthedActiveSStoreIdDraftOrdersDraftIdRoute:
      AuthedActiveSStoreIdDraftOrdersDraftIdRoute,
    AuthedActiveSStoreIdDraftOrdersNewRoute:
      AuthedActiveSStoreIdDraftOrdersNewRoute,
    AuthedActiveSStoreIdDraftOrdersIndexRoute:
      AuthedActiveSStoreIdDraftOrdersIndexRoute,
  };

const AuthedActiveSStoreIdDraftOrdersRouteWithChildren =
  AuthedActiveSStoreIdDraftOrdersRoute._addFileChildren(
    AuthedActiveSStoreIdDraftOrdersRouteChildren,
  );

interface AuthedActiveSStoreIdGiftCardsRouteChildren {
  AuthedActiveSStoreIdGiftCardsGiftCardIdRoute: typeof AuthedActiveSStoreIdGiftCardsGiftCardIdRoute;
  AuthedActiveSStoreIdGiftCardsIndexRoute: typeof AuthedActiveSStoreIdGiftCardsIndexRoute;
}

const AuthedActiveSStoreIdGiftCardsRouteChildren: AuthedActiveSStoreIdGiftCardsRouteChildren =
  {
    AuthedActiveSStoreIdGiftCardsGiftCardIdRoute:
      AuthedActiveSStoreIdGiftCardsGiftCardIdRoute,
    AuthedActiveSStoreIdGiftCardsIndexRoute:
      AuthedActiveSStoreIdGiftCardsIndexRoute,
  };

const AuthedActiveSStoreIdGiftCardsRouteWithChildren =
  AuthedActiveSStoreIdGiftCardsRoute._addFileChildren(
    AuthedActiveSStoreIdGiftCardsRouteChildren,
  );

interface AuthedActiveSStoreIdHelpRouteChildren {
  AuthedActiveSStoreIdHelpArticleIdRoute: typeof AuthedActiveSStoreIdHelpArticleIdRoute;
  AuthedActiveSStoreIdHelpCategoriesRoute: typeof AuthedActiveSStoreIdHelpCategoriesRoute;
  AuthedActiveSStoreIdHelpNewRoute: typeof AuthedActiveSStoreIdHelpNewRoute;
  AuthedActiveSStoreIdHelpIndexRoute: typeof AuthedActiveSStoreIdHelpIndexRoute;
}

const AuthedActiveSStoreIdHelpRouteChildren: AuthedActiveSStoreIdHelpRouteChildren =
  {
    AuthedActiveSStoreIdHelpArticleIdRoute:
      AuthedActiveSStoreIdHelpArticleIdRoute,
    AuthedActiveSStoreIdHelpCategoriesRoute:
      AuthedActiveSStoreIdHelpCategoriesRoute,
    AuthedActiveSStoreIdHelpNewRoute: AuthedActiveSStoreIdHelpNewRoute,
    AuthedActiveSStoreIdHelpIndexRoute: AuthedActiveSStoreIdHelpIndexRoute,
  };

const AuthedActiveSStoreIdHelpRouteWithChildren =
  AuthedActiveSStoreIdHelpRoute._addFileChildren(
    AuthedActiveSStoreIdHelpRouteChildren,
  );

interface AuthedActiveSStoreIdInboxRouteChildren {
  AuthedActiveSStoreIdInboxConversationIdRoute: typeof AuthedActiveSStoreIdInboxConversationIdRoute;
  AuthedActiveSStoreIdInboxIndexRoute: typeof AuthedActiveSStoreIdInboxIndexRoute;
}

const AuthedActiveSStoreIdInboxRouteChildren: AuthedActiveSStoreIdInboxRouteChildren =
  {
    AuthedActiveSStoreIdInboxConversationIdRoute:
      AuthedActiveSStoreIdInboxConversationIdRoute,
    AuthedActiveSStoreIdInboxIndexRoute: AuthedActiveSStoreIdInboxIndexRoute,
  };

const AuthedActiveSStoreIdInboxRouteWithChildren =
  AuthedActiveSStoreIdInboxRoute._addFileChildren(
    AuthedActiveSStoreIdInboxRouteChildren,
  );

interface AuthedActiveSStoreIdOrdersRouteChildren {
  AuthedActiveSStoreIdOrdersOrderIdRoute: typeof AuthedActiveSStoreIdOrdersOrderIdRoute;
  AuthedActiveSStoreIdOrdersIndexRoute: typeof AuthedActiveSStoreIdOrdersIndexRoute;
}

const AuthedActiveSStoreIdOrdersRouteChildren: AuthedActiveSStoreIdOrdersRouteChildren =
  {
    AuthedActiveSStoreIdOrdersOrderIdRoute:
      AuthedActiveSStoreIdOrdersOrderIdRoute,
    AuthedActiveSStoreIdOrdersIndexRoute: AuthedActiveSStoreIdOrdersIndexRoute,
  };

const AuthedActiveSStoreIdOrdersRouteWithChildren =
  AuthedActiveSStoreIdOrdersRoute._addFileChildren(
    AuthedActiveSStoreIdOrdersRouteChildren,
  );

interface AuthedActiveSStoreIdReportsRouteChildren {
  AuthedActiveSStoreIdReportsAnalyticsRoute: typeof AuthedActiveSStoreIdReportsAnalyticsRoute;
  AuthedActiveSStoreIdReportsAuctionsRoute: typeof AuthedActiveSStoreIdReportsAuctionsRoute;
  AuthedActiveSStoreIdReportsCustomersRoute: typeof AuthedActiveSStoreIdReportsCustomersRoute;
  AuthedActiveSStoreIdReportsInventoryRoute: typeof AuthedActiveSStoreIdReportsInventoryRoute;
  AuthedActiveSStoreIdReportsPaymentsRoute: typeof AuthedActiveSStoreIdReportsPaymentsRoute;
  AuthedActiveSStoreIdReportsProductsRoute: typeof AuthedActiveSStoreIdReportsProductsRoute;
  AuthedActiveSStoreIdReportsSalesRoute: typeof AuthedActiveSStoreIdReportsSalesRoute;
  AuthedActiveSStoreIdReportsSupportRoute: typeof AuthedActiveSStoreIdReportsSupportRoute;
  AuthedActiveSStoreIdReportsIndexRoute: typeof AuthedActiveSStoreIdReportsIndexRoute;
}

const AuthedActiveSStoreIdReportsRouteChildren: AuthedActiveSStoreIdReportsRouteChildren =
  {
    AuthedActiveSStoreIdReportsAnalyticsRoute:
      AuthedActiveSStoreIdReportsAnalyticsRoute,
    AuthedActiveSStoreIdReportsAuctionsRoute:
      AuthedActiveSStoreIdReportsAuctionsRoute,
    AuthedActiveSStoreIdReportsCustomersRoute:
      AuthedActiveSStoreIdReportsCustomersRoute,
    AuthedActiveSStoreIdReportsInventoryRoute:
      AuthedActiveSStoreIdReportsInventoryRoute,
    AuthedActiveSStoreIdReportsPaymentsRoute:
      AuthedActiveSStoreIdReportsPaymentsRoute,
    AuthedActiveSStoreIdReportsProductsRoute:
      AuthedActiveSStoreIdReportsProductsRoute,
    AuthedActiveSStoreIdReportsSalesRoute:
      AuthedActiveSStoreIdReportsSalesRoute,
    AuthedActiveSStoreIdReportsSupportRoute:
      AuthedActiveSStoreIdReportsSupportRoute,
    AuthedActiveSStoreIdReportsIndexRoute:
      AuthedActiveSStoreIdReportsIndexRoute,
  };

const AuthedActiveSStoreIdReportsRouteWithChildren =
  AuthedActiveSStoreIdReportsRoute._addFileChildren(
    AuthedActiveSStoreIdReportsRouteChildren,
  );

interface AuthedActiveSStoreIdReturnsRouteChildren {
  AuthedActiveSStoreIdReturnsReturnIdRoute: typeof AuthedActiveSStoreIdReturnsReturnIdRoute;
  AuthedActiveSStoreIdReturnsIndexRoute: typeof AuthedActiveSStoreIdReturnsIndexRoute;
}

const AuthedActiveSStoreIdReturnsRouteChildren: AuthedActiveSStoreIdReturnsRouteChildren =
  {
    AuthedActiveSStoreIdReturnsReturnIdRoute:
      AuthedActiveSStoreIdReturnsReturnIdRoute,
    AuthedActiveSStoreIdReturnsIndexRoute:
      AuthedActiveSStoreIdReturnsIndexRoute,
  };

const AuthedActiveSStoreIdReturnsRouteWithChildren =
  AuthedActiveSStoreIdReturnsRoute._addFileChildren(
    AuthedActiveSStoreIdReturnsRouteChildren,
  );

interface AuthedActiveSStoreIdSettingsPoliciesRouteChildren {
  AuthedActiveSStoreIdSettingsPoliciesPolicyIdRoute: typeof AuthedActiveSStoreIdSettingsPoliciesPolicyIdRoute;
  AuthedActiveSStoreIdSettingsPoliciesNewRoute: typeof AuthedActiveSStoreIdSettingsPoliciesNewRoute;
  AuthedActiveSStoreIdSettingsPoliciesIndexRoute: typeof AuthedActiveSStoreIdSettingsPoliciesIndexRoute;
}

const AuthedActiveSStoreIdSettingsPoliciesRouteChildren: AuthedActiveSStoreIdSettingsPoliciesRouteChildren =
  {
    AuthedActiveSStoreIdSettingsPoliciesPolicyIdRoute:
      AuthedActiveSStoreIdSettingsPoliciesPolicyIdRoute,
    AuthedActiveSStoreIdSettingsPoliciesNewRoute:
      AuthedActiveSStoreIdSettingsPoliciesNewRoute,
    AuthedActiveSStoreIdSettingsPoliciesIndexRoute:
      AuthedActiveSStoreIdSettingsPoliciesIndexRoute,
  };

const AuthedActiveSStoreIdSettingsPoliciesRouteWithChildren =
  AuthedActiveSStoreIdSettingsPoliciesRoute._addFileChildren(
    AuthedActiveSStoreIdSettingsPoliciesRouteChildren,
  );

interface AuthedActiveSStoreIdSettingsQcChecklistsRouteChildren {
  AuthedActiveSStoreIdSettingsQcChecklistsChecklistIdRoute: typeof AuthedActiveSStoreIdSettingsQcChecklistsChecklistIdRoute;
  AuthedActiveSStoreIdSettingsQcChecklistsNewRoute: typeof AuthedActiveSStoreIdSettingsQcChecklistsNewRoute;
  AuthedActiveSStoreIdSettingsQcChecklistsIndexRoute: typeof AuthedActiveSStoreIdSettingsQcChecklistsIndexRoute;
}

const AuthedActiveSStoreIdSettingsQcChecklistsRouteChildren: AuthedActiveSStoreIdSettingsQcChecklistsRouteChildren =
  {
    AuthedActiveSStoreIdSettingsQcChecklistsChecklistIdRoute:
      AuthedActiveSStoreIdSettingsQcChecklistsChecklistIdRoute,
    AuthedActiveSStoreIdSettingsQcChecklistsNewRoute:
      AuthedActiveSStoreIdSettingsQcChecklistsNewRoute,
    AuthedActiveSStoreIdSettingsQcChecklistsIndexRoute:
      AuthedActiveSStoreIdSettingsQcChecklistsIndexRoute,
  };

const AuthedActiveSStoreIdSettingsQcChecklistsRouteWithChildren =
  AuthedActiveSStoreIdSettingsQcChecklistsRoute._addFileChildren(
    AuthedActiveSStoreIdSettingsQcChecklistsRouteChildren,
  );

interface AuthedActiveSStoreIdSettingsWebhooksRouteChildren {
  AuthedActiveSStoreIdSettingsWebhooksEndpointIdRoute: typeof AuthedActiveSStoreIdSettingsWebhooksEndpointIdRoute;
  AuthedActiveSStoreIdSettingsWebhooksIndexRoute: typeof AuthedActiveSStoreIdSettingsWebhooksIndexRoute;
}

const AuthedActiveSStoreIdSettingsWebhooksRouteChildren: AuthedActiveSStoreIdSettingsWebhooksRouteChildren =
  {
    AuthedActiveSStoreIdSettingsWebhooksEndpointIdRoute:
      AuthedActiveSStoreIdSettingsWebhooksEndpointIdRoute,
    AuthedActiveSStoreIdSettingsWebhooksIndexRoute:
      AuthedActiveSStoreIdSettingsWebhooksIndexRoute,
  };

const AuthedActiveSStoreIdSettingsWebhooksRouteWithChildren =
  AuthedActiveSStoreIdSettingsWebhooksRoute._addFileChildren(
    AuthedActiveSStoreIdSettingsWebhooksRouteChildren,
  );

interface AuthedActiveSStoreIdSettingsWorkflowsRouteChildren {
  AuthedActiveSStoreIdSettingsWorkflowsTemplateIdRoute: typeof AuthedActiveSStoreIdSettingsWorkflowsTemplateIdRoute;
  AuthedActiveSStoreIdSettingsWorkflowsNewRoute: typeof AuthedActiveSStoreIdSettingsWorkflowsNewRoute;
  AuthedActiveSStoreIdSettingsWorkflowsIndexRoute: typeof AuthedActiveSStoreIdSettingsWorkflowsIndexRoute;
}

const AuthedActiveSStoreIdSettingsWorkflowsRouteChildren: AuthedActiveSStoreIdSettingsWorkflowsRouteChildren =
  {
    AuthedActiveSStoreIdSettingsWorkflowsTemplateIdRoute:
      AuthedActiveSStoreIdSettingsWorkflowsTemplateIdRoute,
    AuthedActiveSStoreIdSettingsWorkflowsNewRoute:
      AuthedActiveSStoreIdSettingsWorkflowsNewRoute,
    AuthedActiveSStoreIdSettingsWorkflowsIndexRoute:
      AuthedActiveSStoreIdSettingsWorkflowsIndexRoute,
  };

const AuthedActiveSStoreIdSettingsWorkflowsRouteWithChildren =
  AuthedActiveSStoreIdSettingsWorkflowsRoute._addFileChildren(
    AuthedActiveSStoreIdSettingsWorkflowsRouteChildren,
  );

interface AuthedActiveSStoreIdSettingsRouteChildren {
  AuthedActiveSStoreIdSettingsAnalyticsRoute: typeof AuthedActiveSStoreIdSettingsAnalyticsRoute;
  AuthedActiveSStoreIdSettingsApiKeysRoute: typeof AuthedActiveSStoreIdSettingsApiKeysRoute;
  AuthedActiveSStoreIdSettingsChatRoute: typeof AuthedActiveSStoreIdSettingsChatRoute;
  AuthedActiveSStoreIdSettingsFeedsRoute: typeof AuthedActiveSStoreIdSettingsFeedsRoute;
  AuthedActiveSStoreIdSettingsImportsExportsRoute: typeof AuthedActiveSStoreIdSettingsImportsExportsRoute;
  AuthedActiveSStoreIdSettingsLocationsRoute: typeof AuthedActiveSStoreIdSettingsLocationsRoute;
  AuthedActiveSStoreIdSettingsMarketsRoute: typeof AuthedActiveSStoreIdSettingsMarketsRoute;
  AuthedActiveSStoreIdSettingsNotificationsRoute: typeof AuthedActiveSStoreIdSettingsNotificationsRoute;
  AuthedActiveSStoreIdSettingsPaymentMethodsRoute: typeof AuthedActiveSStoreIdSettingsPaymentMethodsRoute;
  AuthedActiveSStoreIdSettingsPoliciesRoute: typeof AuthedActiveSStoreIdSettingsPoliciesRouteWithChildren;
  AuthedActiveSStoreIdSettingsQcChecklistsRoute: typeof AuthedActiveSStoreIdSettingsQcChecklistsRouteWithChildren;
  AuthedActiveSStoreIdSettingsRecoveryRoute: typeof AuthedActiveSStoreIdSettingsRecoveryRoute;
  AuthedActiveSStoreIdSettingsReturnsRoute: typeof AuthedActiveSStoreIdSettingsReturnsRoute;
  AuthedActiveSStoreIdSettingsShippingRoute: typeof AuthedActiveSStoreIdSettingsShippingRoute;
  AuthedActiveSStoreIdSettingsTaxRoute: typeof AuthedActiveSStoreIdSettingsTaxRoute;
  AuthedActiveSStoreIdSettingsWebhooksRoute: typeof AuthedActiveSStoreIdSettingsWebhooksRouteWithChildren;
  AuthedActiveSStoreIdSettingsWorkflowsRoute: typeof AuthedActiveSStoreIdSettingsWorkflowsRouteWithChildren;
  AuthedActiveSStoreIdSettingsIndexRoute: typeof AuthedActiveSStoreIdSettingsIndexRoute;
  AuthedActiveSStoreIdSettingsPaymentsStripeCallbackRoute: typeof AuthedActiveSStoreIdSettingsPaymentsStripeCallbackRoute;
}

const AuthedActiveSStoreIdSettingsRouteChildren: AuthedActiveSStoreIdSettingsRouteChildren =
  {
    AuthedActiveSStoreIdSettingsAnalyticsRoute:
      AuthedActiveSStoreIdSettingsAnalyticsRoute,
    AuthedActiveSStoreIdSettingsApiKeysRoute:
      AuthedActiveSStoreIdSettingsApiKeysRoute,
    AuthedActiveSStoreIdSettingsChatRoute:
      AuthedActiveSStoreIdSettingsChatRoute,
    AuthedActiveSStoreIdSettingsFeedsRoute:
      AuthedActiveSStoreIdSettingsFeedsRoute,
    AuthedActiveSStoreIdSettingsImportsExportsRoute:
      AuthedActiveSStoreIdSettingsImportsExportsRoute,
    AuthedActiveSStoreIdSettingsLocationsRoute:
      AuthedActiveSStoreIdSettingsLocationsRoute,
    AuthedActiveSStoreIdSettingsMarketsRoute:
      AuthedActiveSStoreIdSettingsMarketsRoute,
    AuthedActiveSStoreIdSettingsNotificationsRoute:
      AuthedActiveSStoreIdSettingsNotificationsRoute,
    AuthedActiveSStoreIdSettingsPaymentMethodsRoute:
      AuthedActiveSStoreIdSettingsPaymentMethodsRoute,
    AuthedActiveSStoreIdSettingsPoliciesRoute:
      AuthedActiveSStoreIdSettingsPoliciesRouteWithChildren,
    AuthedActiveSStoreIdSettingsQcChecklistsRoute:
      AuthedActiveSStoreIdSettingsQcChecklistsRouteWithChildren,
    AuthedActiveSStoreIdSettingsRecoveryRoute:
      AuthedActiveSStoreIdSettingsRecoveryRoute,
    AuthedActiveSStoreIdSettingsReturnsRoute:
      AuthedActiveSStoreIdSettingsReturnsRoute,
    AuthedActiveSStoreIdSettingsShippingRoute:
      AuthedActiveSStoreIdSettingsShippingRoute,
    AuthedActiveSStoreIdSettingsTaxRoute: AuthedActiveSStoreIdSettingsTaxRoute,
    AuthedActiveSStoreIdSettingsWebhooksRoute:
      AuthedActiveSStoreIdSettingsWebhooksRouteWithChildren,
    AuthedActiveSStoreIdSettingsWorkflowsRoute:
      AuthedActiveSStoreIdSettingsWorkflowsRouteWithChildren,
    AuthedActiveSStoreIdSettingsIndexRoute:
      AuthedActiveSStoreIdSettingsIndexRoute,
    AuthedActiveSStoreIdSettingsPaymentsStripeCallbackRoute:
      AuthedActiveSStoreIdSettingsPaymentsStripeCallbackRoute,
  };

const AuthedActiveSStoreIdSettingsRouteWithChildren =
  AuthedActiveSStoreIdSettingsRoute._addFileChildren(
    AuthedActiveSStoreIdSettingsRouteChildren,
  );

interface AuthedActiveSStoreIdSocialPinterestPostsRouteChildren {
  AuthedActiveSStoreIdSocialPinterestPostsPostIdRoute: typeof AuthedActiveSStoreIdSocialPinterestPostsPostIdRoute;
  AuthedActiveSStoreIdSocialPinterestPostsIndexRoute: typeof AuthedActiveSStoreIdSocialPinterestPostsIndexRoute;
}

const AuthedActiveSStoreIdSocialPinterestPostsRouteChildren: AuthedActiveSStoreIdSocialPinterestPostsRouteChildren =
  {
    AuthedActiveSStoreIdSocialPinterestPostsPostIdRoute:
      AuthedActiveSStoreIdSocialPinterestPostsPostIdRoute,
    AuthedActiveSStoreIdSocialPinterestPostsIndexRoute:
      AuthedActiveSStoreIdSocialPinterestPostsIndexRoute,
  };

const AuthedActiveSStoreIdSocialPinterestPostsRouteWithChildren =
  AuthedActiveSStoreIdSocialPinterestPostsRoute._addFileChildren(
    AuthedActiveSStoreIdSocialPinterestPostsRouteChildren,
  );

interface AuthedActiveSStoreIdSocialPinterestRouteChildren {
  AuthedActiveSStoreIdSocialPinterestAnalyticsRoute: typeof AuthedActiveSStoreIdSocialPinterestAnalyticsRoute;
  AuthedActiveSStoreIdSocialPinterestConnectionRoute: typeof AuthedActiveSStoreIdSocialPinterestConnectionRoute;
  AuthedActiveSStoreIdSocialPinterestCreateRoute: typeof AuthedActiveSStoreIdSocialPinterestCreateRoute;
  AuthedActiveSStoreIdSocialPinterestPostsRoute: typeof AuthedActiveSStoreIdSocialPinterestPostsRouteWithChildren;
  AuthedActiveSStoreIdSocialPinterestSettingsRoute: typeof AuthedActiveSStoreIdSocialPinterestSettingsRoute;
  AuthedActiveSStoreIdSocialPinterestIndexRoute: typeof AuthedActiveSStoreIdSocialPinterestIndexRoute;
}

const AuthedActiveSStoreIdSocialPinterestRouteChildren: AuthedActiveSStoreIdSocialPinterestRouteChildren =
  {
    AuthedActiveSStoreIdSocialPinterestAnalyticsRoute:
      AuthedActiveSStoreIdSocialPinterestAnalyticsRoute,
    AuthedActiveSStoreIdSocialPinterestConnectionRoute:
      AuthedActiveSStoreIdSocialPinterestConnectionRoute,
    AuthedActiveSStoreIdSocialPinterestCreateRoute:
      AuthedActiveSStoreIdSocialPinterestCreateRoute,
    AuthedActiveSStoreIdSocialPinterestPostsRoute:
      AuthedActiveSStoreIdSocialPinterestPostsRouteWithChildren,
    AuthedActiveSStoreIdSocialPinterestSettingsRoute:
      AuthedActiveSStoreIdSocialPinterestSettingsRoute,
    AuthedActiveSStoreIdSocialPinterestIndexRoute:
      AuthedActiveSStoreIdSocialPinterestIndexRoute,
  };

const AuthedActiveSStoreIdSocialPinterestRouteWithChildren =
  AuthedActiveSStoreIdSocialPinterestRoute._addFileChildren(
    AuthedActiveSStoreIdSocialPinterestRouteChildren,
  );

interface AuthedActiveSStoreIdSocialRouteChildren {
  AuthedActiveSStoreIdSocialPinterestRoute: typeof AuthedActiveSStoreIdSocialPinterestRouteWithChildren;
  AuthedActiveSStoreIdSocialIndexRoute: typeof AuthedActiveSStoreIdSocialIndexRoute;
}

const AuthedActiveSStoreIdSocialRouteChildren: AuthedActiveSStoreIdSocialRouteChildren =
  {
    AuthedActiveSStoreIdSocialPinterestRoute:
      AuthedActiveSStoreIdSocialPinterestRouteWithChildren,
    AuthedActiveSStoreIdSocialIndexRoute: AuthedActiveSStoreIdSocialIndexRoute,
  };

const AuthedActiveSStoreIdSocialRouteWithChildren =
  AuthedActiveSStoreIdSocialRoute._addFileChildren(
    AuthedActiveSStoreIdSocialRouteChildren,
  );

interface AuthedActiveSStoreIdRouteChildren {
  AuthedActiveSStoreIdAbandonedCheckoutsRoute: typeof AuthedActiveSStoreIdAbandonedCheckoutsRouteWithChildren;
  AuthedActiveSStoreIdAppointmentsRoute: typeof AuthedActiveSStoreIdAppointmentsRoute;
  AuthedActiveSStoreIdAuctionsRoute: typeof AuthedActiveSStoreIdAuctionsRouteWithChildren;
  AuthedActiveSStoreIdCatalogRoute: typeof AuthedActiveSStoreIdCatalogRouteWithChildren;
  AuthedActiveSStoreIdCollectionsRoute: typeof AuthedActiveSStoreIdCollectionsRouteWithChildren;
  AuthedActiveSStoreIdContentRoute: typeof AuthedActiveSStoreIdContentRouteWithChildren;
  AuthedActiveSStoreIdCustomersRoute: typeof AuthedActiveSStoreIdCustomersRouteWithChildren;
  AuthedActiveSStoreIdDiscountsRoute: typeof AuthedActiveSStoreIdDiscountsRouteWithChildren;
  AuthedActiveSStoreIdDraftOrdersRoute: typeof AuthedActiveSStoreIdDraftOrdersRouteWithChildren;
  AuthedActiveSStoreIdGiftCardsRoute: typeof AuthedActiveSStoreIdGiftCardsRouteWithChildren;
  AuthedActiveSStoreIdHelpRoute: typeof AuthedActiveSStoreIdHelpRouteWithChildren;
  AuthedActiveSStoreIdInboxRoute: typeof AuthedActiveSStoreIdInboxRouteWithChildren;
  AuthedActiveSStoreIdInventoryRoute: typeof AuthedActiveSStoreIdInventoryRoute;
  AuthedActiveSStoreIdOrdersRoute: typeof AuthedActiveSStoreIdOrdersRouteWithChildren;
  AuthedActiveSStoreIdPrivacyRequestsRoute: typeof AuthedActiveSStoreIdPrivacyRequestsRoute;
  AuthedActiveSStoreIdProductionRoute: typeof AuthedActiveSStoreIdProductionRoute;
  AuthedActiveSStoreIdReportsRoute: typeof AuthedActiveSStoreIdReportsRouteWithChildren;
  AuthedActiveSStoreIdReturnsRoute: typeof AuthedActiveSStoreIdReturnsRouteWithChildren;
  AuthedActiveSStoreIdSettingsRoute: typeof AuthedActiveSStoreIdSettingsRouteWithChildren;
  AuthedActiveSStoreIdSocialRoute: typeof AuthedActiveSStoreIdSocialRouteWithChildren;
  AuthedActiveSStoreIdIndexRoute: typeof AuthedActiveSStoreIdIndexRoute;
  AuthedActiveSStoreIdInventoryVariantIdRoute: typeof AuthedActiveSStoreIdInventoryVariantIdRoute;
}

const AuthedActiveSStoreIdRouteChildren: AuthedActiveSStoreIdRouteChildren = {
  AuthedActiveSStoreIdAbandonedCheckoutsRoute:
    AuthedActiveSStoreIdAbandonedCheckoutsRouteWithChildren,
  AuthedActiveSStoreIdAppointmentsRoute: AuthedActiveSStoreIdAppointmentsRoute,
  AuthedActiveSStoreIdAuctionsRoute:
    AuthedActiveSStoreIdAuctionsRouteWithChildren,
  AuthedActiveSStoreIdCatalogRoute:
    AuthedActiveSStoreIdCatalogRouteWithChildren,
  AuthedActiveSStoreIdCollectionsRoute:
    AuthedActiveSStoreIdCollectionsRouteWithChildren,
  AuthedActiveSStoreIdContentRoute:
    AuthedActiveSStoreIdContentRouteWithChildren,
  AuthedActiveSStoreIdCustomersRoute:
    AuthedActiveSStoreIdCustomersRouteWithChildren,
  AuthedActiveSStoreIdDiscountsRoute:
    AuthedActiveSStoreIdDiscountsRouteWithChildren,
  AuthedActiveSStoreIdDraftOrdersRoute:
    AuthedActiveSStoreIdDraftOrdersRouteWithChildren,
  AuthedActiveSStoreIdGiftCardsRoute:
    AuthedActiveSStoreIdGiftCardsRouteWithChildren,
  AuthedActiveSStoreIdHelpRoute: AuthedActiveSStoreIdHelpRouteWithChildren,
  AuthedActiveSStoreIdInboxRoute: AuthedActiveSStoreIdInboxRouteWithChildren,
  AuthedActiveSStoreIdInventoryRoute: AuthedActiveSStoreIdInventoryRoute,
  AuthedActiveSStoreIdOrdersRoute: AuthedActiveSStoreIdOrdersRouteWithChildren,
  AuthedActiveSStoreIdPrivacyRequestsRoute:
    AuthedActiveSStoreIdPrivacyRequestsRoute,
  AuthedActiveSStoreIdProductionRoute: AuthedActiveSStoreIdProductionRoute,
  AuthedActiveSStoreIdReportsRoute:
    AuthedActiveSStoreIdReportsRouteWithChildren,
  AuthedActiveSStoreIdReturnsRoute:
    AuthedActiveSStoreIdReturnsRouteWithChildren,
  AuthedActiveSStoreIdSettingsRoute:
    AuthedActiveSStoreIdSettingsRouteWithChildren,
  AuthedActiveSStoreIdSocialRoute: AuthedActiveSStoreIdSocialRouteWithChildren,
  AuthedActiveSStoreIdIndexRoute: AuthedActiveSStoreIdIndexRoute,
  AuthedActiveSStoreIdInventoryVariantIdRoute:
    AuthedActiveSStoreIdInventoryVariantIdRoute,
};

const AuthedActiveSStoreIdRouteWithChildren =
  AuthedActiveSStoreIdRoute._addFileChildren(AuthedActiveSStoreIdRouteChildren);

interface AuthedActiveRouteChildren {
  AuthedActiveHelpRoute: typeof AuthedActiveHelpRoute;
  AuthedActiveAccountChatProfileRoute: typeof AuthedActiveAccountChatProfileRoute;
  AuthedActiveAccountNotificationsRoute: typeof AuthedActiveAccountNotificationsRoute;
  AuthedActiveAccountSecurityRoute: typeof AuthedActiveAccountSecurityRoute;
  AuthedActiveOrgActivityRoute: typeof AuthedActiveOrgActivityRoute;
  AuthedActiveOrgCatalogSetupRoute: typeof AuthedActiveOrgCatalogSetupRouteWithChildren;
  AuthedActiveOrgCustomizationsRoute: typeof AuthedActiveOrgCustomizationsRoute;
  AuthedActiveOrgInboxRoute: typeof AuthedActiveOrgInboxRouteWithChildren;
  AuthedActiveOrgMediaRoute: typeof AuthedActiveOrgMediaRoute;
  AuthedActiveOrgProductsRoute: typeof AuthedActiveOrgProductsRouteWithChildren;
  AuthedActiveOrgRolesRoute: typeof AuthedActiveOrgRolesRoute;
  AuthedActiveOrgSchedulesRoute: typeof AuthedActiveOrgSchedulesRouteWithChildren;
  AuthedActiveOrgSettingsRoute: typeof AuthedActiveOrgSettingsRoute;
  AuthedActiveOrgSharedBlocksRoute: typeof AuthedActiveOrgSharedBlocksRouteWithChildren;
  AuthedActiveOrgStonePricingRoute: typeof AuthedActiveOrgStonePricingRoute;
  AuthedActiveOrgStoresRoute: typeof AuthedActiveOrgStoresRouteWithChildren;
  AuthedActiveOrgTeamRoute: typeof AuthedActiveOrgTeamRoute;
  AuthedActiveSStoreIdRoute: typeof AuthedActiveSStoreIdRouteWithChildren;
  AuthedActiveAccountIndexRoute: typeof AuthedActiveAccountIndexRoute;
  AuthedActiveOrgIndexRoute: typeof AuthedActiveOrgIndexRoute;
  AuthedActiveStoresStoreIdInboxConversationIdRoute: typeof AuthedActiveStoresStoreIdInboxConversationIdRoute;
}

const AuthedActiveRouteChildren: AuthedActiveRouteChildren = {
  AuthedActiveHelpRoute: AuthedActiveHelpRoute,
  AuthedActiveAccountChatProfileRoute: AuthedActiveAccountChatProfileRoute,
  AuthedActiveAccountNotificationsRoute: AuthedActiveAccountNotificationsRoute,
  AuthedActiveAccountSecurityRoute: AuthedActiveAccountSecurityRoute,
  AuthedActiveOrgActivityRoute: AuthedActiveOrgActivityRoute,
  AuthedActiveOrgCatalogSetupRoute:
    AuthedActiveOrgCatalogSetupRouteWithChildren,
  AuthedActiveOrgCustomizationsRoute: AuthedActiveOrgCustomizationsRoute,
  AuthedActiveOrgInboxRoute: AuthedActiveOrgInboxRouteWithChildren,
  AuthedActiveOrgMediaRoute: AuthedActiveOrgMediaRoute,
  AuthedActiveOrgProductsRoute: AuthedActiveOrgProductsRouteWithChildren,
  AuthedActiveOrgRolesRoute: AuthedActiveOrgRolesRoute,
  AuthedActiveOrgSchedulesRoute: AuthedActiveOrgSchedulesRouteWithChildren,
  AuthedActiveOrgSettingsRoute: AuthedActiveOrgSettingsRoute,
  AuthedActiveOrgSharedBlocksRoute:
    AuthedActiveOrgSharedBlocksRouteWithChildren,
  AuthedActiveOrgStonePricingRoute: AuthedActiveOrgStonePricingRoute,
  AuthedActiveOrgStoresRoute: AuthedActiveOrgStoresRouteWithChildren,
  AuthedActiveOrgTeamRoute: AuthedActiveOrgTeamRoute,
  AuthedActiveSStoreIdRoute: AuthedActiveSStoreIdRouteWithChildren,
  AuthedActiveAccountIndexRoute: AuthedActiveAccountIndexRoute,
  AuthedActiveOrgIndexRoute: AuthedActiveOrgIndexRoute,
  AuthedActiveStoresStoreIdInboxConversationIdRoute:
    AuthedActiveStoresStoreIdInboxConversationIdRoute,
};

const AuthedActiveRouteWithChildren = AuthedActiveRoute._addFileChildren(
  AuthedActiveRouteChildren,
);

interface AuthedDocsRouteChildren {
  AuthedDocsBuildRoute: typeof AuthedDocsBuildRoute;
  AuthedDocsPostmanRoute: typeof AuthedDocsPostmanRoute;
  AuthedDocsIndexRoute: typeof AuthedDocsIndexRoute;
  AuthedDocsGuidesSlugRoute: typeof AuthedDocsGuidesSlugRoute;
  AuthedDocsApiIndexRoute: typeof AuthedDocsApiIndexRoute;
  AuthedDocsApiTagOperationRoute: typeof AuthedDocsApiTagOperationRoute;
}

const AuthedDocsRouteChildren: AuthedDocsRouteChildren = {
  AuthedDocsBuildRoute: AuthedDocsBuildRoute,
  AuthedDocsPostmanRoute: AuthedDocsPostmanRoute,
  AuthedDocsIndexRoute: AuthedDocsIndexRoute,
  AuthedDocsGuidesSlugRoute: AuthedDocsGuidesSlugRoute,
  AuthedDocsApiIndexRoute: AuthedDocsApiIndexRoute,
  AuthedDocsApiTagOperationRoute: AuthedDocsApiTagOperationRoute,
};

const AuthedDocsRouteWithChildren = AuthedDocsRoute._addFileChildren(
  AuthedDocsRouteChildren,
);

interface AuthedRouteChildren {
  AuthedActiveRoute: typeof AuthedActiveRouteWithChildren;
  AuthedDocsRoute: typeof AuthedDocsRouteWithChildren;
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedActiveRoute: AuthedActiveRouteWithChildren,
  AuthedDocsRoute: AuthedDocsRouteWithChildren,
};

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  publicAcceptInviteRoute: publicAcceptInviteRoute,
  publicConfirmEmailRoute: publicConfirmEmailRoute,
  publicForgotPasswordRoute: publicForgotPasswordRoute,
  publicLoginRoute: publicLoginRoute,
  publicMagicLinkRoute: publicMagicLinkRoute,
  publicResetPasswordRoute: publicResetPasswordRoute,
  publicSignInLinkRoute: publicSignInLinkRoute,
  publicApplyConfirmRoute: publicApplyConfirmRoute,
  publicApplyIndexRoute: publicApplyIndexRoute,
  publicAuthGoogleCallbackRoute: publicAuthGoogleCallbackRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
